// https://www.paintcolourchart.com/ncs-colors/s0502-y.html is used to convert NCS to hex
// swap ncs-code in link to get hex-value
//RAL colors are extracted from https://www.ral-farben.de/en/all-ral-colours

const colors = [
  {
    factoryValueCode: '0502-Y',
    hexCode: '#f3efe3',
  },
  {
    factoryValueCode: 'YESWHITE0502Y',
    hexCode: '#f3efe3',
  },
  {
    factoryValueCode: 'WHITE_0502Y',
    hexCode: '#f3efe3',
  },
  {
    factoryValueCode: 'YESWHITE0500N',
    hexCode: '#ECECE7',
  },
  {
    factoryValueCode: 'WHITE_0500N',
    hexCode: '#ECECE7',
  },
  {
    factoryValueCode: '4050-Y90R',
    hexCode: '#89312e',
  },
  {
    factoryValueCode: '6530-G10Y',
    hexCode: '#16482e',
  },
  {
    factoryValueCode: '6502-Y',
    hexCode: '#66655f',
  },
  {
    factoryValueCode: '6020-R90B',
    hexCode: '#3a546c',
  },
  {
    factoryValueCode: '1030-Y20R',
    hexCode: '#f5c988',
  },
  {
    factoryValueCode: '1040-Y10R',
    hexCode: '#f6ca6f',
  },
  {
    factoryValueCode: '2502-Y',
    hexCode: '#bbb8af',
  },
  {
    factoryValueCode: '5030-B',
    hexCode: '#2e627b',
  },
  {
    factoryValueCode: '1580-Y90R',
    hexCode: '#bd1921',
  },
  {
    factoryValueCode: '7010-Y70R',
    hexCode: '#5d453d',
  },
  {
    factoryValueCode: '2005-G30Y',
    hexCode: '#bdc4ba',
  },
  {
    factoryValueCode: '5020-G70Y',
    hexCode: '#7c7c57',
  },
  {
    factoryValueCode: '6020-B',
    hexCode: '#39586a',
  },
  {
    factoryValueCode: '2040-Y20R',
    hexCode: '#dda65d',
  },
  {
    factoryValueCode: '1502-Y50R',
    hexCode: '#d4cfc8',
  },
  {
    factoryValueCode: '9000-N',
    hexCode: '#191a1b',
  },
  {
    factoryValueCode: '0500-N',
    hexCode: '#f1efeb',
  },
  {
    factoryValueCode: 'BRRED_RAL3011',
    hexCode: '#792423',
  },
  {
    factoryValueCode: 'WHITE_RAL9010',
    hexCode: '#fcfaf5',
  },
  {
    factoryValueCode: 'ASHG_RAL7037',
    hexCode: '#7a7b7a',
  },
  {
    factoryValueCode: 'ANTH_RAL7016',
    hexCode: '#4B5054',
  },
  {
    factoryValueCode: 'BLACK_RAL9005',
    hexCode: '#3C3C3C',
  },
  {
    factoryValueCode: 'OLIVEG_RAL3006',
    hexCode: '#eee9e4',
  },
  {
    factoryValueCode: 'NUTBR_RAL8011',
    hexCode: '#5a3826',
  },
  {
    factoryValueCode: 'TWIBLUE_RAL5023',
    hexCode: '#42698c',
  },
  {
    factoryValueCode: '6000-N',
    hexCode: '#717170',
  },
  {
    factoryValueCode: 'OPTIONAL_COLOR',
    hexCode: 'url("//s.skbv.se/assets/images/lfc/thumbnail-OPTIONAL_COLOR.jpg")',
  },
  { factoryValueCode: 'RAL 1000', hexCode: '#CDBA88' },
  { factoryValueCode: 'RAL 1001', hexCode: '#D0B084' },
  { factoryValueCode: 'RAL 1002', hexCode: '#D2AA6D' },
  { factoryValueCode: 'RAL 1003', hexCode: '#F9A900' },
  { factoryValueCode: 'RAL 1004', hexCode: '#E49E00' },
  { factoryValueCode: 'RAL 1005', hexCode: '#CB8F00' },
  { factoryValueCode: 'RAL 1006', hexCode: '#E19000' },
  { factoryValueCode: 'RAL 1007', hexCode: '#E88C00' },
  { factoryValueCode: 'RAL 1011', hexCode: '#AF8050' },
  { factoryValueCode: 'RAL 1012', hexCode: '#DDAF28' },
  { factoryValueCode: 'RAL 1013', hexCode: '#E3D9C7' },
  { factoryValueCode: 'RAL 1014', hexCode: '#DDC49B' },
  { factoryValueCode: 'RAL 1015', hexCode: '#E6D2B5' },
  { factoryValueCode: 'RAL 1016', hexCode: '#F1DD39' },
  { factoryValueCode: 'RAL 1017', hexCode: '#F6A951' },
  { factoryValueCode: 'RAL 1018', hexCode: '#FACA31' },
  { factoryValueCode: 'RAL 1019', hexCode: '#A48F7A' },
  { factoryValueCode: 'RAL 1020', hexCode: '#A08F65' },
  { factoryValueCode: 'RAL 1021', hexCode: '#F6B600' },
  { factoryValueCode: 'RAL 1023', hexCode: '#F7B500' },
  { factoryValueCode: 'RAL 1024', hexCode: '#BA8F4C' },
  { factoryValueCode: 'RAL 1026', hexCode: '#FFFF00' },
  { factoryValueCode: 'RAL 1027', hexCode: '#A77F0F' },
  { factoryValueCode: 'RAL 1028', hexCode: '#FF9C00' },
  { factoryValueCode: 'RAL 1032', hexCode: '#E2A300' },
  { factoryValueCode: 'RAL 1033', hexCode: '#F99A1D' },
  { factoryValueCode: 'RAL 1034', hexCode: '#EB9C52' },
  { factoryValueCode: 'RAL 1035', hexCode: '#8F8370' },
  { factoryValueCode: 'RAL 1036', hexCode: '#806440' },
  { factoryValueCode: 'RAL 1037', hexCode: '#F09200' },
  { factoryValueCode: 'RAL 2000', hexCode: '#DA6E00' },
  { factoryValueCode: 'RAL 2001', hexCode: '#BA481C' },
  { factoryValueCode: 'RAL 2002', hexCode: '#BF3922' },
  { factoryValueCode: 'RAL 2003', hexCode: '#F67829' },
  { factoryValueCode: 'RAL 2004', hexCode: '#E25304' },
  { factoryValueCode: 'RAL 2005', hexCode: '#FF4D08' },
  { factoryValueCode: 'RAL 2007', hexCode: '#FFB200' },
  { factoryValueCode: 'RAL 2008', hexCode: '#EC6B22' },
  { factoryValueCode: 'RAL 2009', hexCode: '#DE5308' },
  { factoryValueCode: 'RAL 2010', hexCode: '#D05D29' },
  { factoryValueCode: 'RAL 2011', hexCode: '#E26E0F' },
  { factoryValueCode: 'RAL 2012', hexCode: '#D5654E' },
  { factoryValueCode: 'RAL 2013', hexCode: '#923E25' },
  { factoryValueCode: 'RAL 2017', hexCode: '#FC5500' },
  { factoryValueCode: 'RAL 3000', hexCode: '#A72920' },
  { factoryValueCode: 'RAL 3001', hexCode: '#9B2423' },
  { factoryValueCode: 'RAL 3002', hexCode: '#9B2321' },
  { factoryValueCode: 'RAL 3003', hexCode: '#861A22' },
  { factoryValueCode: 'RAL 3004', hexCode: '#6B1C23' },
  { factoryValueCode: 'RAL 3005', hexCode: '#59191F' },
  { factoryValueCode: 'RAL 3007', hexCode: '#3E2022' },
  { factoryValueCode: 'RAL 3009', hexCode: '#6D342D' },
  { factoryValueCode: 'RAL 3011', hexCode: '#782423' },
  { factoryValueCode: 'RAL 3012', hexCode: '#C5856D' },
  { factoryValueCode: 'RAL 3013', hexCode: '#972E25' },
  { factoryValueCode: 'RAL 3014', hexCode: '#CB7375' },
  { factoryValueCode: 'RAL 3015', hexCode: '#D8A0A6' },
  { factoryValueCode: 'RAL 3016', hexCode: '#A63D30' },
  { factoryValueCode: 'RAL 3017', hexCode: '#CA555D' },
  { factoryValueCode: 'RAL 3018', hexCode: '#C63F4A' },
  { factoryValueCode: 'RAL 3020', hexCode: '#BB1F11' },
  { factoryValueCode: 'RAL 3022', hexCode: '#CF6955' },
  { factoryValueCode: 'RAL 3024', hexCode: '#FF2D21' },
  { factoryValueCode: 'RAL 3026', hexCode: '#FF2A1C' },
  { factoryValueCode: 'RAL 3027', hexCode: '#AB273C' },
  { factoryValueCode: 'RAL 3028', hexCode: '#CC2C24' },
  { factoryValueCode: 'RAL 3031', hexCode: '#A63437' },
  { factoryValueCode: 'RAL 3032', hexCode: '#701D24' },
  { factoryValueCode: 'RAL 3033', hexCode: '#A53A2E' },
  { factoryValueCode: 'RAL 4001', hexCode: '#816183' },
  { factoryValueCode: 'RAL 4002', hexCode: '#8D3C4B' },
  { factoryValueCode: 'RAL 4003', hexCode: '#C4618C' },
  { factoryValueCode: 'RAL 4004', hexCode: '#651E38' },
  { factoryValueCode: 'RAL 4005', hexCode: '#76689A' },
  { factoryValueCode: 'RAL 4006', hexCode: '#903373' },
  { factoryValueCode: 'RAL 4007', hexCode: '#47243C' },
  { factoryValueCode: 'RAL 4008', hexCode: '#844C82' },
  { factoryValueCode: 'RAL 4009', hexCode: '#9D8692' },
  { factoryValueCode: 'RAL 4010', hexCode: '#BB4077' },
  { factoryValueCode: 'RAL 4011', hexCode: '#6E6387' },
  { factoryValueCode: 'RAL 4012', hexCode: '#6A6B7F' },
  { factoryValueCode: 'RAL 5000', hexCode: '#304F6E' },
  { factoryValueCode: 'RAL 5001', hexCode: '#0E4C64' },
  { factoryValueCode: 'RAL 5002', hexCode: '#00387A' },
  { factoryValueCode: 'RAL 5003', hexCode: '#1F3855' },
  { factoryValueCode: 'RAL 5004', hexCode: '#191E28' },
  { factoryValueCode: 'RAL 5005', hexCode: '#005387' },
  { factoryValueCode: 'RAL 5007', hexCode: '#376B8C' },
  { factoryValueCode: 'RAL 5008', hexCode: '#2B3A44' },
  { factoryValueCode: 'RAL 5009', hexCode: '#215F78' },
  { factoryValueCode: 'RAL 5010', hexCode: '#004F7C' },
  { factoryValueCode: 'RAL 5011', hexCode: '#1A2B3C' },
  { factoryValueCode: 'RAL 5012', hexCode: '#0089B6' },
  { factoryValueCode: 'RAL 5013', hexCode: '#193153' },
  { factoryValueCode: 'RAL 5014', hexCode: '#637D96' },
  { factoryValueCode: 'RAL 5015', hexCode: '#007CAF' },
  { factoryValueCode: 'RAL 5017', hexCode: '#005B8C' },
  { factoryValueCode: 'RAL 5018', hexCode: '#048B8C' },
  { factoryValueCode: 'RAL 5019', hexCode: '#005E83' },
  { factoryValueCode: 'RAL 5020', hexCode: '#00414B' },
  { factoryValueCode: 'RAL 5021', hexCode: '#007577' },
  { factoryValueCode: 'RAL 5022', hexCode: '#222D5A' },
  { factoryValueCode: 'RAL 5023', hexCode: '#41698C' },
  { factoryValueCode: 'RAL 5024', hexCode: '#6093AC' },
  { factoryValueCode: 'RAL 5025', hexCode: '#20697C' },
  { factoryValueCode: 'RAL 5026', hexCode: '#0F3052' },
  { factoryValueCode: 'RAL 6000', hexCode: '#3C7460' },
  { factoryValueCode: 'RAL 6001', hexCode: '#366735' },
  { factoryValueCode: 'RAL 6002', hexCode: '#325928' },
  { factoryValueCode: 'RAL 6003', hexCode: '#50533C' },
  { factoryValueCode: 'RAL 6004', hexCode: '#024442' },
  { factoryValueCode: 'RAL 6005', hexCode: '#114232' },
  { factoryValueCode: 'RAL 6006', hexCode: '#3C392E' },
  { factoryValueCode: 'RAL 6007', hexCode: '#2C3222' },
  { factoryValueCode: 'RAL 6008', hexCode: '#36342A' },
  { factoryValueCode: 'RAL 6009', hexCode: '#27352A' },
  { factoryValueCode: 'RAL 6010', hexCode: '#4D6F39' },
  { factoryValueCode: 'RAL 6011', hexCode: '#6B7C59' },
  { factoryValueCode: 'RAL 6012', hexCode: '#2F3D3A' },
  { factoryValueCode: 'RAL 6013', hexCode: '#7C765A' },
  { factoryValueCode: 'RAL 6014', hexCode: '#474135' },
  { factoryValueCode: 'RAL 6015', hexCode: '#3D3D36' },
  { factoryValueCode: 'RAL 6016', hexCode: '#00694C' },
  { factoryValueCode: 'RAL 6017', hexCode: '#587F40' },
  { factoryValueCode: 'RAL 6018', hexCode: '#60993B' },
  { factoryValueCode: 'RAL 6019', hexCode: '#B9CEAC' },
  { factoryValueCode: 'RAL 6020', hexCode: '#37422F' },
  { factoryValueCode: 'RAL 6021', hexCode: '#8A9977' },
  { factoryValueCode: 'RAL 6022', hexCode: '#3A3327' },
  { factoryValueCode: 'RAL 6024', hexCode: '#008351' },
  { factoryValueCode: 'RAL 6025', hexCode: '#5E6E3B' },
  { factoryValueCode: 'RAL 6026', hexCode: '#005F4E' },
  { factoryValueCode: 'RAL 6027', hexCode: '#7EBAB5' },
  { factoryValueCode: 'RAL 6028', hexCode: '#315442' },
  { factoryValueCode: 'RAL 6029', hexCode: '#006F3D' },
  { factoryValueCode: 'RAL 6032', hexCode: '#237F52' },
  { factoryValueCode: 'RAL 6033', hexCode: '#45877F' },
  { factoryValueCode: 'RAL 6034', hexCode: '#7AADAC' },
  { factoryValueCode: 'RAL 6035', hexCode: '#194D25' },
  { factoryValueCode: 'RAL 6036', hexCode: '#04574B' },
  { factoryValueCode: 'RAL 6037', hexCode: '#008B29' },
  { factoryValueCode: 'RAL 6038', hexCode: '#00B51B' },
  { factoryValueCode: 'RAL 6039', hexCode: '#B3C43E' },
  { factoryValueCode: 'RAL 7000', hexCode: '#7A888E' },
  { factoryValueCode: 'RAL 7001', hexCode: '#8C979C' },
  { factoryValueCode: 'RAL 7002', hexCode: '#817863' },
  { factoryValueCode: 'RAL 7003', hexCode: '#797669' },
  { factoryValueCode: 'RAL 7004', hexCode: '#9A9B9B' },
  { factoryValueCode: 'RAL 7005', hexCode: '#6B6E6B' },
  { factoryValueCode: 'RAL 7006', hexCode: '#766A5E' },
  { factoryValueCode: 'RAL 7008', hexCode: '#745F3D' },
  { factoryValueCode: 'RAL 7009', hexCode: '#5D6058' },
  { factoryValueCode: 'RAL 7010', hexCode: '#585C56' },
  { factoryValueCode: 'RAL 7011', hexCode: '#52595D' },
  { factoryValueCode: 'RAL 7012', hexCode: '#575D5E' },
  { factoryValueCode: 'RAL 7013', hexCode: '#575044' },
  { factoryValueCode: 'RAL 7015', hexCode: '#4F5358' },
  { factoryValueCode: 'RAL 7016', hexCode: '#383E42' },
  { factoryValueCode: 'RAL 7021', hexCode: '#2F3234' },
  { factoryValueCode: 'RAL 7022', hexCode: '#4C4A44' },
  { factoryValueCode: 'RAL 7023', hexCode: '#808076' },
  { factoryValueCode: 'RAL 7024', hexCode: '#45494E' },
  { factoryValueCode: 'RAL 7026', hexCode: '#374345' },
  { factoryValueCode: 'RAL 7030', hexCode: '#928E85' },
  { factoryValueCode: 'RAL 7031', hexCode: '#5B686D' },
  { factoryValueCode: 'RAL 7032', hexCode: '#B5B0A1' },
  { factoryValueCode: 'RAL 7033', hexCode: '#7F8274' },
  { factoryValueCode: 'RAL 7034', hexCode: '#92886F' },
  { factoryValueCode: 'RAL 7035', hexCode: '#C5C7C4' },
  { factoryValueCode: 'RAL 7036', hexCode: '#979392' },
  { factoryValueCode: 'RAL 7037', hexCode: '#7A7B7A' },
  { factoryValueCode: 'RAL 7038', hexCode: '#B0B0A9' },
  { factoryValueCode: 'RAL 7039', hexCode: '#6B665E' },
  { factoryValueCode: 'RAL 7040', hexCode: '#989EA1' },
  { factoryValueCode: 'RAL 7042', hexCode: '#8E9291' },
  { factoryValueCode: 'RAL 7043', hexCode: '#4F5250' },
  { factoryValueCode: 'RAL 7044', hexCode: '#B7B3A8' },
  { factoryValueCode: 'RAL 7045', hexCode: '#8D9295' },
  { factoryValueCode: 'RAL 7046', hexCode: '#7E868A' },
  { factoryValueCode: 'RAL 7047', hexCode: '#C8C8C7' },
  { factoryValueCode: 'RAL 7048', hexCode: '#817B73' },
  { factoryValueCode: 'RAL 8000', hexCode: '#89693F' },
  { factoryValueCode: 'RAL 8001', hexCode: '#9D622B' },
  { factoryValueCode: 'RAL 8002', hexCode: '#794D3E' },
  { factoryValueCode: 'RAL 8003', hexCode: '#7E4B27' },
  { factoryValueCode: 'RAL 8004', hexCode: '#8D4931' },
  { factoryValueCode: 'RAL 8007', hexCode: '#70462B' },
  { factoryValueCode: 'RAL 8008', hexCode: '#724A25' },
  { factoryValueCode: 'RAL 8011', hexCode: '#5A3827' },
  { factoryValueCode: 'RAL 8012', hexCode: '#66332B' },
  { factoryValueCode: 'RAL 8014', hexCode: '#4A3526' },
  { factoryValueCode: 'RAL 8015', hexCode: '#5E2F26' },
  { factoryValueCode: 'RAL 8016', hexCode: '#4C2B20' },
  { factoryValueCode: 'RAL 8017', hexCode: '#442F29' },
  { factoryValueCode: 'RAL 8019', hexCode: '#3D3635' },
  { factoryValueCode: 'RAL 8022', hexCode: '#1A1719' },
  { factoryValueCode: 'RAL 8023', hexCode: '#A45729' },
  { factoryValueCode: 'RAL 8024', hexCode: '#795038' },
  { factoryValueCode: 'RAL 8025', hexCode: '#755847' },
  { factoryValueCode: 'RAL 8028', hexCode: '#513A2A' },
  { factoryValueCode: 'RAL 8029', hexCode: '#7F4031' },
  { factoryValueCode: 'RAL 9001', hexCode: '#E9E0D2' },
  { factoryValueCode: 'RAL 9002', hexCode: '#D6D5CB' },
  { factoryValueCode: 'RAL 9003', hexCode: '#ECECE7' },
  { factoryValueCode: 'RAL 9004', hexCode: '#2B2B2C' },
  { factoryValueCode: 'RAL 9005', hexCode: '#0E0E10' },
  { factoryValueCode: 'RAL 9006', hexCode: '#A1A1A0' },
  { factoryValueCode: 'RAL 9007', hexCode: '#868581' },
  { factoryValueCode: 'RAL 9010', hexCode: '#F1EDE1' },
  { factoryValueCode: 'RAL 9011', hexCode: '#27292B' },
  { factoryValueCode: 'RAL 9012', hexCode: '#F8F2E1' },
  { factoryValueCode: 'RAL 9016', hexCode: '#F1F1EA' },
  { factoryValueCode: 'RAL 9017', hexCode: '#29292A' },
  { factoryValueCode: 'RAL 9018', hexCode: '#C8CBC4' },
  { factoryValueCode: 'RAL 9022', hexCode: '#858583' },
  { factoryValueCode: 'RAL 9023', hexCode: '#787B7A' },
  { factoryValueCode: 'RAL 000 15 00', hexCode: '#414141' },
  { factoryValueCode: 'RAL 000 20 00', hexCode: '#474646' },
  { factoryValueCode: 'RAL 000 25 00', hexCode: '#504F4F' },
  { factoryValueCode: 'RAL 000 30 00', hexCode: '#565656' },
  { factoryValueCode: 'RAL 000 35 00', hexCode: '#5F5F5F' },
  { factoryValueCode: 'RAL 000 40 00', hexCode: '#696968' },
  { factoryValueCode: 'RAL 000 45 00', hexCode: '#757473' },
  { factoryValueCode: 'RAL 000 50 00', hexCode: '#7E7F7E' },
  { factoryValueCode: 'RAL 000 55 00', hexCode: '#898989' },
  { factoryValueCode: 'RAL 000 60 00', hexCode: '#959595' },
  { factoryValueCode: 'RAL 000 65 00', hexCode: '#A3A3A3' },
  { factoryValueCode: 'RAL 000 70 00', hexCode: '#B0B0B0' },
  { factoryValueCode: 'RAL 000 75 00', hexCode: '#BDBDBD' },
  { factoryValueCode: 'RAL 000 80 00', hexCode: '#CACAC9' },
  { factoryValueCode: 'RAL 000 85 00', hexCode: '#D7D7D5' },
  { factoryValueCode: 'RAL 000 90 00', hexCode: '#E2E3E1' },
  { factoryValueCode: 'RAL 010 20 10', hexCode: '#524446' },
  { factoryValueCode: 'RAL 010 20 15', hexCode: '#564144' },
  { factoryValueCode: 'RAL 010 20 20', hexCode: '#5B3F43' },
  { factoryValueCode: 'RAL 010 20 25', hexCode: '#5E3E43' },
  { factoryValueCode: 'RAL 010 30 10', hexCode: '#665255' },
  { factoryValueCode: 'RAL 010 30 15', hexCode: '#6A5054' },
  { factoryValueCode: 'RAL 010 30 20', hexCode: '#714E53' },
  { factoryValueCode: 'RAL 010 30 25', hexCode: '#774A52' },
  { factoryValueCode: 'RAL 010 30 30', hexCode: '#7C4851' },
  { factoryValueCode: 'RAL 010 30 35', hexCode: '#7E454F' },
  { factoryValueCode: 'RAL 010 30 40', hexCode: '#86404F' },
  { factoryValueCode: 'RAL 010 30 44', hexCode: '#8B3D4F' },
  { factoryValueCode: 'RAL 010 40 10', hexCode: '#796567' },
  { factoryValueCode: 'RAL 010 40 15', hexCode: '#806165' },
  { factoryValueCode: 'RAL 010 40 20', hexCode: '#875F64' },
  { factoryValueCode: 'RAL 010 40 25', hexCode: '#8D5C65' },
  { factoryValueCode: 'RAL 010 40 30', hexCode: '#945963' },
  { factoryValueCode: 'RAL 010 40 35', hexCode: '#975460' },
  { factoryValueCode: 'RAL 010 40 40', hexCode: '#9F5161' },
  { factoryValueCode: 'RAL 010 40 45', hexCode: '#A54D61' },
  { factoryValueCode: 'RAL 010 40 50', hexCode: '#AB4960' },
  { factoryValueCode: 'RAL 010 40 53', hexCode: '#AE465E' },
  { factoryValueCode: 'RAL 010 50 10', hexCode: '#8F797D' },
  { factoryValueCode: 'RAL 010 50 15', hexCode: '#96757A' },
  { factoryValueCode: 'RAL 010 50 20', hexCode: '#9D737A' },
  { factoryValueCode: 'RAL 010 50 25', hexCode: '#A67079' },
  { factoryValueCode: 'RAL 010 50 30', hexCode: '#AE6C78' },
  { factoryValueCode: 'RAL 010 50 35', hexCode: '#B36876' },
  { factoryValueCode: 'RAL 010 50 40', hexCode: '#B86576' },
  { factoryValueCode: 'RAL 010 50 45', hexCode: '#BD5F74' },
  { factoryValueCode: 'RAL 010 50 50', hexCode: '#C65C74' },
  { factoryValueCode: 'RAL 010 60 10', hexCode: '#A89093' },
  { factoryValueCode: 'RAL 010 60 15', hexCode: '#B18E93' },
  { factoryValueCode: 'RAL 010 60 20', hexCode: '#BA8B92' },
  { factoryValueCode: 'RAL 010 60 25', hexCode: '#C08690' },
  { factoryValueCode: 'RAL 010 60 30', hexCode: '#C7828F' },
  { factoryValueCode: 'RAL 010 60 35', hexCode: '#D07F8D' },
  { factoryValueCode: 'RAL 010 60 40', hexCode: '#D67B8C' },
  { factoryValueCode: 'RAL 010 60 45', hexCode: '#DF768B' },
  { factoryValueCode: 'RAL 010 70 10', hexCode: '#C3AAAE' },
  { factoryValueCode: 'RAL 010 70 15', hexCode: '#CAA7AB' },
  { factoryValueCode: 'RAL 010 70 20', hexCode: '#D4A3AB' },
  { factoryValueCode: 'RAL 010 70 25', hexCode: '#DC9FA9' },
  { factoryValueCode: 'RAL 010 70 30', hexCode: '#E39CA8' },
  { factoryValueCode: 'RAL 010 70 35', hexCode: '#EB96A5' },
  { factoryValueCode: 'RAL 010 80 10', hexCode: '#DEC3C5' },
  { factoryValueCode: 'RAL 010 80 15', hexCode: '#E5C0C4' },
  { factoryValueCode: 'RAL 010 80 20', hexCode: '#EFBCC3' },
  { factoryValueCode: 'RAL 010 85 05', hexCode: '#DED1D3' },
  { factoryValueCode: 'RAL 010 85 10', hexCode: '#E4CDD1' },
  { factoryValueCode: 'RAL 010 85 15', hexCode: '#EFCCD2' },
  { factoryValueCode: 'RAL 010 85 20', hexCode: '#F8CBD2' },
  { factoryValueCode: 'RAL 010 90 05', hexCode: '#EFE0DF' },
  { factoryValueCode: 'RAL 010 90 10', hexCode: '#F2DBD8' },
  { factoryValueCode: 'RAL 010 93 05', hexCode: '#F1E6E8' },
  { factoryValueCode: 'RAL 020 20 05', hexCode: '#4C4545' },
  { factoryValueCode: 'RAL 020 20 10', hexCode: '#524343' },
  { factoryValueCode: 'RAL 020 20 20', hexCode: '#5B4041' },
  { factoryValueCode: 'RAL 020 20 29', hexCode: '#633C40' },
  { factoryValueCode: 'RAL 020 30 05', hexCode: '#5D5454' },
  { factoryValueCode: 'RAL 020 30 10', hexCode: '#645151' },
  { factoryValueCode: 'RAL 020 30 20', hexCode: '#6F4B4C' },
  { factoryValueCode: 'RAL 020 30 30', hexCode: '#78464A' },
  { factoryValueCode: 'RAL 020 30 40', hexCode: '#844048' },
  { factoryValueCode: 'RAL 020 30 48', hexCode: '#8C3C46' },
  { factoryValueCode: 'RAL 020 40 05', hexCode: '#726868' },
  { factoryValueCode: 'RAL 020 40 10', hexCode: '#786464' },
  { factoryValueCode: 'RAL 020 40 20', hexCode: '#855E60' },
  { factoryValueCode: 'RAL 020 40 30', hexCode: '#92585C' },
  { factoryValueCode: 'RAL 020 40 40', hexCode: '#9B5157' },
  { factoryValueCode: 'RAL 020 40 50', hexCode: '#A74751' },
  { factoryValueCode: 'RAL 020 50 05', hexCode: '#897D7C' },
  { factoryValueCode: 'RAL 020 50 10', hexCode: '#907879' },
  { factoryValueCode: 'RAL 020 50 20', hexCode: '#9F7274' },
  { factoryValueCode: 'RAL 020 50 30', hexCode: '#AC6C70' },
  { factoryValueCode: 'RAL 020 50 40', hexCode: '#B6646B' },
  { factoryValueCode: 'RAL 020 50 50', hexCode: '#C25C67' },
  { factoryValueCode: 'RAL 020 50 58', hexCode: '#D25766' },
  { factoryValueCode: 'RAL 020 60 05', hexCode: '#9F9493' },
  { factoryValueCode: 'RAL 020 60 10', hexCode: '#A78E8F' },
  { factoryValueCode: 'RAL 020 60 20', hexCode: '#B88A8C' },
  { factoryValueCode: 'RAL 020 60 30', hexCode: '#C68186' },
  { factoryValueCode: 'RAL 020 60 40', hexCode: '#D37A82' },
  { factoryValueCode: 'RAL 020 70 05', hexCode: '#B9ADAC' },
  { factoryValueCode: 'RAL 020 70 10', hexCode: '#C0A7A8' },
  { factoryValueCode: 'RAL 020 70 20', hexCode: '#D4A2A5' },
  { factoryValueCode: 'RAL 020 70 30', hexCode: '#E49BA0' },
  { factoryValueCode: 'RAL 020 80 05', hexCode: '#D5C7C6' },
  { factoryValueCode: 'RAL 020 80 10', hexCode: '#DCC1C2' },
  { factoryValueCode: 'RAL 020 80 20', hexCode: '#EEBCBE' },
  { factoryValueCode: 'RAL 020 85 05', hexCode: '#DFD1D1' },
  { factoryValueCode: 'RAL 020 85 10', hexCode: '#E7CECE' },
  { factoryValueCode: 'RAL 020 85 20', hexCode: '#FBC9CA' },
  { factoryValueCode: 'RAL 020 90 05', hexCode: '#F0E2DE' },
  { factoryValueCode: 'RAL 020 90 10', hexCode: '#F3DDD9' },
  { factoryValueCode: 'RAL 020 93 05', hexCode: '#F6E6E3' },
  { factoryValueCode: 'RAL 030 30 10', hexCode: '#635351' },
  { factoryValueCode: 'RAL 030 30 20', hexCode: '#6E4D4B' },
  { factoryValueCode: 'RAL 030 30 30', hexCode: '#784845' },
  { factoryValueCode: 'RAL 030 30 40', hexCode: '#854343' },
  { factoryValueCode: 'RAL 030 30 45', hexCode: '#863E3F' },
  { factoryValueCode: 'RAL 030 40 10', hexCode: '#766361' },
  { factoryValueCode: 'RAL 030 40 20', hexCode: '#86605C' },
  { factoryValueCode: 'RAL 030 40 30', hexCode: '#925955' },
  { factoryValueCode: 'RAL 030 40 40', hexCode: '#9D5351' },
  { factoryValueCode: 'RAL 030 40 50', hexCode: '#A84C4C' },
  { factoryValueCode: 'RAL 030 40 60', hexCode: '#B14548' },
  { factoryValueCode: 'RAL 030 50 10', hexCode: '#8F7875' },
  { factoryValueCode: 'RAL 030 50 20', hexCode: '#9D736F' },
  { factoryValueCode: 'RAL 030 50 30', hexCode: '#AB6D68' },
  { factoryValueCode: 'RAL 030 50 40', hexCode: '#B86762' },
  { factoryValueCode: 'RAL 030 50 50', hexCode: '#C25F5C' },
  { factoryValueCode: 'RAL 030 50 60', hexCode: '#CF5654' },
  { factoryValueCode: 'RAL 030 60 10', hexCode: '#A6908E' },
  { factoryValueCode: 'RAL 030 60 20', hexCode: '#B78A86' },
  { factoryValueCode: 'RAL 030 60 30', hexCode: '#C5827C' },
  { factoryValueCode: 'RAL 030 60 40', hexCode: '#D37D77' },
  { factoryValueCode: 'RAL 030 60 50', hexCode: '#E0746E' },
  { factoryValueCode: 'RAL 030 70 10', hexCode: '#C0A8A6' },
  { factoryValueCode: 'RAL 030 70 20', hexCode: '#D2A19C' },
  { factoryValueCode: 'RAL 030 70 30', hexCode: '#E29A94' },
  { factoryValueCode: 'RAL 030 70 40', hexCode: '#F0938C' },
  { factoryValueCode: 'RAL 030 80 10', hexCode: '#DBC2BF' },
  { factoryValueCode: 'RAL 030 80 20', hexCode: '#ECBBB6' },
  { factoryValueCode: 'RAL 030 85 05', hexCode: '#DFD0CB' },
  { factoryValueCode: 'RAL 030 85 10', hexCode: '#E5CEC9' },
  { factoryValueCode: 'RAL 030 85 20', hexCode: '#F6CBC3' },
  { factoryValueCode: 'RAL 030 90 05', hexCode: '#EFE1DC' },
  { factoryValueCode: 'RAL 030 90 10', hexCode: '#F5DFD9' },
  { factoryValueCode: 'RAL 030 93 05', hexCode: '#F7E7E3' },
  { factoryValueCode: 'RAL 040 20 19', hexCode: '#5A433F' },
  { factoryValueCode: 'RAL 040 30 05', hexCode: '#5D5552' },
  { factoryValueCode: 'RAL 040 30 10', hexCode: '#62524E' },
  { factoryValueCode: 'RAL 040 30 20', hexCode: '#6D4E47' },
  { factoryValueCode: 'RAL 040 30 30', hexCode: '#774B43' },
  { factoryValueCode: 'RAL 040 30 40', hexCode: '#80463E' },
  { factoryValueCode: 'RAL 040 40 05', hexCode: '#726865' },
  { factoryValueCode: 'RAL 040 40 10', hexCode: '#776560' },
  { factoryValueCode: 'RAL 040 40 20', hexCode: '#84625A' },
  { factoryValueCode: 'RAL 040 40 30', hexCode: '#8D5A4E' },
  { factoryValueCode: 'RAL 040 40 40', hexCode: '#985447' },
  { factoryValueCode: 'RAL 040 40 50', hexCode: '#A35041' },
  { factoryValueCode: 'RAL 040 40 60', hexCode: '#AA473B' },
  { factoryValueCode: 'RAL 040 40 67', hexCode: '#B24539' },
  { factoryValueCode: 'RAL 040 50 05', hexCode: '#877C79' },
  { factoryValueCode: 'RAL 040 50 10', hexCode: '#8E7A74' },
  { factoryValueCode: 'RAL 040 50 20', hexCode: '#9C746A' },
  { factoryValueCode: 'RAL 040 50 30', hexCode: '#AA6F61' },
  { factoryValueCode: 'RAL 040 50 40', hexCode: '#B36857' },
  { factoryValueCode: 'RAL 040 50 50', hexCode: '#C0624F' },
  { factoryValueCode: 'RAL 040 50 60', hexCode: '#CE5E4A' },
  { factoryValueCode: 'RAL 040 50 70', hexCode: '#D55845' },
  { factoryValueCode: 'RAL 040 60 05', hexCode: '#9F9491' },
  { factoryValueCode: 'RAL 040 60 10', hexCode: '#A8918B' },
  { factoryValueCode: 'RAL 040 60 20', hexCode: '#B4897E' },
  { factoryValueCode: 'RAL 040 60 30', hexCode: '#C48677' },
  { factoryValueCode: 'RAL 040 60 40', hexCode: '#CF806E' },
  { factoryValueCode: 'RAL 040 60 50', hexCode: '#DC7B64' },
  { factoryValueCode: 'RAL 040 60 60', hexCode: '#E67359' },
  { factoryValueCode: 'RAL 040 70 05', hexCode: '#B7ACA9' },
  { factoryValueCode: 'RAL 040 70 10', hexCode: '#C2A9A3' },
  { factoryValueCode: 'RAL 040 70 20', hexCode: '#D2A499' },
  { factoryValueCode: 'RAL 040 70 30', hexCode: '#E09D8D' },
  { factoryValueCode: 'RAL 040 70 40', hexCode: '#E99885' },
  { factoryValueCode: 'RAL 040 70 50', hexCode: '#FA9079' },
  { factoryValueCode: 'RAL 040 80 05', hexCode: '#D4C7C3' },
  { factoryValueCode: 'RAL 040 80 10', hexCode: '#DEC4BC' },
  { factoryValueCode: 'RAL 040 80 20', hexCode: '#F1C1B4' },
  { factoryValueCode: 'RAL 040 80 30', hexCode: '#FEBAA9' },
  { factoryValueCode: 'RAL 040 85 05 ', hexCode: '#E1D2CE' },
  { factoryValueCode: 'RAL 040 85 10', hexCode: '#EAD2CA' },
  { factoryValueCode: 'RAL 040 85 20', hexCode: '#FACCBD' },
  { factoryValueCode: 'RAL 040 90 05', hexCode: '#F1E2DC' },
  { factoryValueCode: 'RAL 040 90 10', hexCode: '#F7E0D7' },
  { factoryValueCode: 'RAL 040 93 05', hexCode: '#F9EAE4' },
  { factoryValueCode: 'RAL 050 20 10', hexCode: '#504541' },
  { factoryValueCode: 'RAL 050 20 16', hexCode: '#56443E' },
  { factoryValueCode: 'RAL 050 30 10', hexCode: '#5F504A' },
  { factoryValueCode: 'RAL 050 30 20', hexCode: '#6A4F44' },
  { factoryValueCode: 'RAL 050 30 30', hexCode: '#744C3E' },
  { factoryValueCode: 'RAL 050 30 36', hexCode: '#7A4B3C' },
  { factoryValueCode: 'RAL 050 40 10', hexCode: '#76645D' },
  { factoryValueCode: 'RAL 050 40 20', hexCode: '#806153' },
  { factoryValueCode: 'RAL 050 40 30', hexCode: '#895E4D' },
  { factoryValueCode: 'RAL 050 40 40', hexCode: '#945943' },
  { factoryValueCode: 'RAL 050 40 50', hexCode: '#9D5640' },
  { factoryValueCode: 'RAL 050 50 10', hexCode: '#8D7B73' },
  { factoryValueCode: 'RAL 050 50 20', hexCode: '#997767' },
  { factoryValueCode: 'RAL 050 50 30', hexCode: '#A5725C' },
  { factoryValueCode: 'RAL 050 50 40', hexCode: '#AE6C50' },
  { factoryValueCode: 'RAL 050 50 50', hexCode: '#B96746' },
  { factoryValueCode: 'RAL 050 50 60', hexCode: '#BD623D' },
  { factoryValueCode: 'RAL 050 50 70', hexCode: '#CC5C36' },
  { factoryValueCode: 'RAL 050 50 78', hexCode: '#D16032' },
  { factoryValueCode: 'RAL 050 60 10', hexCode: '#A59188' },
  { factoryValueCode: 'RAL 050 60 20', hexCode: '#B18C7B' },
  { factoryValueCode: 'RAL 050 60 30', hexCode: '#C28971' },
  { factoryValueCode: 'RAL 050 60 40', hexCode: '#C98365' },
  { factoryValueCode: 'RAL 050 60 50', hexCode: '#D67F59' },
  { factoryValueCode: 'RAL 050 60 60', hexCode: '#E17B4E' },
  { factoryValueCode: 'RAL 050 60 70', hexCode: '#E67045' },
  { factoryValueCode: 'RAL 050 60 80', hexCode: '#F26D3F' },
  { factoryValueCode: 'RAL 050 70 10', hexCode: '#C0ACA2' },
  { factoryValueCode: 'RAL 050 70 20', hexCode: '#CEA796' },
  { factoryValueCode: 'RAL 050 70 30', hexCode: '#DBA188' },
  { factoryValueCode: 'RAL 050 70 40', hexCode: '#E99B7B' },
  { factoryValueCode: 'RAL 050 70 50', hexCode: '#F39670' },
  { factoryValueCode: 'RAL 050 70 60', hexCode: '#FE9063' },
  { factoryValueCode: 'RAL 050 80 10', hexCode: '#DBC5BB' },
  { factoryValueCode: 'RAL 050 80 20', hexCode: '#E9BFAC' },
  { factoryValueCode: 'RAL 050 80 30', hexCode: '#F6B99F' },
  { factoryValueCode: 'RAL 050 85 05', hexCode: '#E2D3CC' },
  { factoryValueCode: 'RAL 050 85 10', hexCode: '#E6CFC3' },
  { factoryValueCode: 'RAL 050 85 20', hexCode: '#F6CBB7' },
  { factoryValueCode: 'RAL 050 90 05', hexCode: '#EDE0D8' },
  { factoryValueCode: 'RAL 050 90 10', hexCode: '#FBE2D6' },
  { factoryValueCode: 'RAL 050 93 05', hexCode: '#F9EBE4' },
  { factoryValueCode: 'RAL 060 20 05', hexCode: '#4A4643' },
  { factoryValueCode: 'RAL 060 30 05', hexCode: '#5C5551' },
  { factoryValueCode: 'RAL 060 30 10', hexCode: '#60534B' },
  { factoryValueCode: 'RAL 060 30 20', hexCode: '#665042' },
  { factoryValueCode: 'RAL 060 30 27', hexCode: '#6F5141' },
  { factoryValueCode: 'RAL 060 40 05', hexCode: '#716863' },
  { factoryValueCode: 'RAL 060 40 10', hexCode: '#75655C' },
  { factoryValueCode: 'RAL 060 40 20', hexCode: '#7F6351' },
  { factoryValueCode: 'RAL 060 40 30', hexCode: '#876048' },
  { factoryValueCode: 'RAL 060 40 40', hexCode: '#915F41' },
  { factoryValueCode: 'RAL 060 50 05', hexCode: '#877D77' },
  { factoryValueCode: 'RAL 060 50 10', hexCode: '#8C7C71' },
  { factoryValueCode: 'RAL 060 50 20', hexCode: '#967965' },
  { factoryValueCode: 'RAL 060 50 30', hexCode: '#A2775A' },
  { factoryValueCode: 'RAL 060 50 40', hexCode: '#AA714D' },
  { factoryValueCode: 'RAL 060 50 50', hexCode: '#B37045' },
  { factoryValueCode: 'RAL 060 50 60', hexCode: '#B66838' },
  { factoryValueCode: 'RAL 060 50 70', hexCode: '#C16933' },
  { factoryValueCode: 'RAL 060 60 05', hexCode: '#A09790' },
  { factoryValueCode: 'RAL 060 60 10', hexCode: '#A59387' },
  { factoryValueCode: 'RAL 060 60 20', hexCode: '#B4907B' },
  { factoryValueCode: 'RAL 060 60 30', hexCode: '#BC8D6D' },
  { factoryValueCode: 'RAL 060 60 40', hexCode: '#CB8C5E' },
  { factoryValueCode: 'RAL 060 60 50', hexCode: '#CC814E' },
  { factoryValueCode: 'RAL 060 60 60', hexCode: '#D77F43' },
  { factoryValueCode: 'RAL 060 60 70', hexCode: '#DC7C37' },
  { factoryValueCode: 'RAL 060 60 80', hexCode: '#E6752A' },
  { factoryValueCode: 'RAL 060 70 05', hexCode: '#B9AFA9' },
  { factoryValueCode: 'RAL 060 70 10', hexCode: '#C0ADA1' },
  { factoryValueCode: 'RAL 060 70 20', hexCode: '#CBA891' },
  { factoryValueCode: 'RAL 060 70 30', hexCode: '#D3A281' },
  { factoryValueCode: 'RAL 060 70 40', hexCode: '#E1A074' },
  { factoryValueCode: 'RAL 060 70 50', hexCode: '#EB9C67' },
  { factoryValueCode: 'RAL 060 70 60', hexCode: '#F19758' },
  { factoryValueCode: 'RAL 060 70 70', hexCode: '#FC9348' },
  { factoryValueCode: 'RAL 060 80 05', hexCode: '#D3C9C1' },
  { factoryValueCode: 'RAL 060 80 10', hexCode: '#D8C6B9' },
  { factoryValueCode: 'RAL 060 80 20', hexCode: '#E7C2AA' },
  { factoryValueCode: 'RAL 060 80 30', hexCode: '#F4BE9A' },
  { factoryValueCode: 'RAL 060 80 40', hexCode: '#FDB889' },
  { factoryValueCode: 'RAL 060 85 05', hexCode: '#E0D4CC' },
  { factoryValueCode: 'RAL 060 85 10', hexCode: '#E8D3C5' },
  { factoryValueCode: 'RAL 060 85 20', hexCode: '#F3CFB6' },
  { factoryValueCode: 'RAL 060 85 30', hexCode: '#FFCCA5' },
  { factoryValueCode: 'RAL 060 90 05', hexCode: '#EFE3D9' },
  { factoryValueCode: 'RAL 060 90 10', hexCode: '#F7E0D2' },
  { factoryValueCode: 'RAL 060 90 15', hexCode: '#FCDCC9' },
  { factoryValueCode: 'RAL 060 93 05', hexCode: '#F7EBE2' },
  { factoryValueCode: 'RAL 070 30 10 ', hexCode: '#5C5148' },
  { factoryValueCode: 'RAL 070 30 20', hexCode: '#655444' },
  { factoryValueCode: 'RAL 070 40 10', hexCode: '#71655A' },
  { factoryValueCode: 'RAL 070 40 20', hexCode: '#7A634E' },
  { factoryValueCode: 'RAL 070 40 30', hexCode: '#826448' },
  { factoryValueCode: 'RAL 070 40 40', hexCode: '#88613D' },
  { factoryValueCode: 'RAL 070 50 10', hexCode: '#887B6E' },
  { factoryValueCode: 'RAL 070 50 20', hexCode: '#927961' },
  { factoryValueCode: 'RAL 070 50 30', hexCode: '#997552' },
  { factoryValueCode: 'RAL 070 50 40', hexCode: '#A17344' },
  { factoryValueCode: 'RAL 070 50 50', hexCode: '#A2723D' },
  { factoryValueCode: 'RAL 070 50 55', hexCode: '#AA7034' },
  { factoryValueCode: 'RAL 070 60 10', hexCode: '#A19285' },
  { factoryValueCode: 'RAL 070 60 20', hexCode: '#AB9178' },
  { factoryValueCode: 'RAL 070 60 30', hexCode: '#B38C67' },
  { factoryValueCode: 'RAL 070 60 40', hexCode: '#BB8B58' },
  { factoryValueCode: 'RAL 070 60 50', hexCode: '#C48949' },
  { factoryValueCode: 'RAL 070 60 60', hexCode: '#CC863B' },
  { factoryValueCode: 'RAL 070 60 70', hexCode: '#CF8432' },
  { factoryValueCode: 'RAL 070 60 75', hexCode: '#D1812A' },
  { factoryValueCode: 'RAL 070 70 10', hexCode: '#BAAC9D' },
  { factoryValueCode: 'RAL 070 70 20', hexCode: '#C5A98D' },
  { factoryValueCode: 'RAL 070 70 30', hexCode: '#D0A77E' },
  { factoryValueCode: 'RAL 070 70 40', hexCode: '#D19F6A' },
  { factoryValueCode: 'RAL 070 70 50', hexCode: '#DFA15F' },
  { factoryValueCode: 'RAL 070 70 60', hexCode: '#E9A04F' },
  { factoryValueCode: 'RAL 070 70 70', hexCode: '#EB9A3F' },
  { factoryValueCode: 'RAL 070 70 80', hexCode: '#F09630' },
  { factoryValueCode: 'RAL 070 80 10', hexCode: '#D5C5B6' },
  { factoryValueCode: 'RAL 070 80 20', hexCode: '#E4C5A8' },
  { factoryValueCode: 'RAL 070 80 30', hexCode: '#ECC196' },
  { factoryValueCode: 'RAL 070 80 40', hexCode: '#F6C088' },
  { factoryValueCode: 'RAL 070 80 50', hexCode: '#FEBC75' },
  { factoryValueCode: 'RAL 070 80 60', hexCode: '#FFBA65' },
  { factoryValueCode: 'RAL 070 85 05', hexCode: '#DED4CA' },
  { factoryValueCode: 'RAL 070 85 10', hexCode: '#E5D3C5' },
  { factoryValueCode: 'RAL 070 85 20', hexCode: '#EFD0B2' },
  { factoryValueCode: 'RAL 070 85 30', hexCode: '#FACFA2' },
  { factoryValueCode: 'RAL 070 90 05', hexCode: '#EDE3DA' },
  { factoryValueCode: 'RAL 070 90 10', hexCode: '#F3E2D2' },
  { factoryValueCode: 'RAL 070 90 20', hexCode: '#FEDEC0' },
  { factoryValueCode: 'RAL 070 93 05', hexCode: '#F7ECE2' },
  { factoryValueCode: 'RAL 075 40 10', hexCode: '#71685D' },
  { factoryValueCode: 'RAL 075 40 20', hexCode: '#786551' },
  { factoryValueCode: 'RAL 075 40 30', hexCode: '#7D6346' },
  { factoryValueCode: 'RAL 075 40 38', hexCode: '#81633E' },
  { factoryValueCode: 'RAL 075 50 10', hexCode: '#887D71' },
  { factoryValueCode: 'RAL 075 50 20', hexCode: '#907A62' },
  { factoryValueCode: 'RAL 075 50 30', hexCode: '#987954' },
  { factoryValueCode: 'RAL 075 50 40', hexCode: '#9E7749' },
  { factoryValueCode: 'RAL 075 50 50', hexCode: '#A3753C' },
  { factoryValueCode: 'RAL 075 50 58', hexCode: '#A47232' },
  { factoryValueCode: 'RAL 075 60 10', hexCode: '#A29487' },
  { factoryValueCode: 'RAL 075 60 20', hexCode: '#AA9278' },
  { factoryValueCode: 'RAL 075 60 30', hexCode: '#B29069' },
  { factoryValueCode: 'RAL 075 60 40', hexCode: '#B98E5A' },
  { factoryValueCode: 'RAL 075 60 50', hexCode: '#BE8C49' },
  { factoryValueCode: 'RAL 075 60 60', hexCode: '#C3893A' },
  { factoryValueCode: 'RAL 075 60 70', hexCode: '#CA872A' },
  { factoryValueCode: 'RAL 075 70 10', hexCode: '#BAAD9F' },
  { factoryValueCode: 'RAL 075 70 20', hexCode: '#C4AA8C' },
  { factoryValueCode: 'RAL 075 70 30', hexCode: '#CCA87E' },
  { factoryValueCode: 'RAL 075 70 40', hexCode: '#D3A56C' },
  { factoryValueCode: 'RAL 075 70 50', hexCode: '#DAA45E' },
  { factoryValueCode: 'RAL 075 70 60', hexCode: '#E2A14B' },
  { factoryValueCode: 'RAL 075 70 70', hexCode: '#EAA139' },
  { factoryValueCode: 'RAL 075 70 80', hexCode: '#EB9F2B' },
  { factoryValueCode: 'RAL 075 80 10', hexCode: '#D7C8B8' },
  { factoryValueCode: 'RAL 075 80 20', hexCode: '#E1C6A7' },
  { factoryValueCode: 'RAL 075 80 30', hexCode: '#E8C295' },
  { factoryValueCode: 'RAL 075 80 40', hexCode: '#F0C186' },
  { factoryValueCode: 'RAL 075 80 50', hexCode: '#F6BD73' },
  { factoryValueCode: 'RAL 075 80 60', hexCode: '#FFBB63' },
  { factoryValueCode: 'RAL 075 85 10', hexCode: '#E4D4C3' },
  { factoryValueCode: 'RAL 075 85 20', hexCode: '#EED2B2' },
  { factoryValueCode: 'RAL 075 85 30', hexCode: '#F7D0A2' },
  { factoryValueCode: 'RAL 075 85 40', hexCode: '#FECD90' },
  { factoryValueCode: 'RAL 075 90 10', hexCode: '#F5E5D2' },
  { factoryValueCode: 'RAL 075 90 20', hexCode: '#FCE0C0' },
  { factoryValueCode: 'RAL 075 93 05', hexCode: '#F4ECE3' },
  { factoryValueCode: 'RAL 080 20 05', hexCode: '#4A4743' },
  { factoryValueCode: 'RAL 080 20 10', hexCode: '#4D4740' },
  { factoryValueCode: 'RAL 080 30 05', hexCode: '#5A5550' },
  { factoryValueCode: 'RAL 080 30 10', hexCode: '#5C544A' },
  { factoryValueCode: 'RAL 080 30 20', hexCode: '#615341' },
  { factoryValueCode: 'RAL 080 30 26', hexCode: '#64533C' },
  { factoryValueCode: 'RAL 080 40 05', hexCode: '#6E6962' },
  { factoryValueCode: 'RAL 080 40 10', hexCode: '#71685B' },
  { factoryValueCode: 'RAL 080 40 20', hexCode: '#76654D' },
  { factoryValueCode: 'RAL 080 40 30', hexCode: '#7B6442' },
  { factoryValueCode: 'RAL 080 40 40', hexCode: '#82653A' },
  { factoryValueCode: 'RAL 080 50 05', hexCode: '#837E76' },
  { factoryValueCode: 'RAL 080 50 10', hexCode: '#877C6F' },
  { factoryValueCode: 'RAL 080 50 20', hexCode: '#8E7B60' },
  { factoryValueCode: 'RAL 080 50 30', hexCode: '#937A53' },
  { factoryValueCode: 'RAL 080 50 40', hexCode: '#977845' },
  { factoryValueCode: 'RAL 080 50 50', hexCode: '#9C7839' },
  { factoryValueCode: 'RAL 080 60 05', hexCode: '#9B958E' },
  { factoryValueCode: 'RAL 080 60 10', hexCode: '#9E9384' },
  { factoryValueCode: 'RAL 080 60 20', hexCode: '#A79375' },
  { factoryValueCode: 'RAL 080 60 30', hexCode: '#AD9165' },
  { factoryValueCode: 'RAL 080 60 40', hexCode: '#B18E58' },
  { factoryValueCode: 'RAL 080 60 50', hexCode: '#B78E49' },
  { factoryValueCode: 'RAL 080 60 60', hexCode: '#BD8E39' },
  { factoryValueCode: 'RAL 080 60 70', hexCode: '#C08D2D' },
  { factoryValueCode: 'RAL 080 70 05', hexCode: '#B3AEA6' },
  { factoryValueCode: 'RAL 080 70 10', hexCode: '#B8AC9C' },
  { factoryValueCode: 'RAL 080 70 20', hexCode: '#C1AB8B' },
  { factoryValueCode: 'RAL 080 70 30', hexCode: '#C7A97B' },
  { factoryValueCode: 'RAL 080 70 40', hexCode: '#CFA86A' },
  { factoryValueCode: 'RAL 080 70 50', hexCode: '#D4A75A' },
  { factoryValueCode: 'RAL 080 70 60', hexCode: '#DBA74B' },
  { factoryValueCode: 'RAL 080 70 70', hexCode: '#DFA639' },
  { factoryValueCode: 'RAL 080 70 80', hexCode: '#E0A226' },
  { factoryValueCode: 'RAL 080 70 88', hexCode: '#E5A10E' },
  { factoryValueCode: 'RAL 080 80 05', hexCode: '#CFC9C0' },
  { factoryValueCode: 'RAL 080 80 10', hexCode: '#D6C8B7' },
  { factoryValueCode: 'RAL 080 80 20', hexCode: '#DDC5A4' },
  { factoryValueCode: 'RAL 080 80 30', hexCode: '#E3C393' },
  { factoryValueCode: 'RAL 080 80 40', hexCode: '#EBC281' },
  { factoryValueCode: 'RAL 080 80 50', hexCode: '#F2C172' },
  { factoryValueCode: 'RAL 080 80 60', hexCode: '#F8C05F' },
  { factoryValueCode: 'RAL 080 80 70', hexCode: '#FBBD4E' },
  { factoryValueCode: 'RAL 080 80 80', hexCode: '#FFBA36' },
  { factoryValueCode: 'RAL 080 80 90', hexCode: '#FFBA1F' },
  { factoryValueCode: 'RAL 080 85 05', hexCode: '#DBD4CA' },
  { factoryValueCode: 'RAL 080 85 10', hexCode: '#E0D4C2' },
  { factoryValueCode: 'RAL 080 85 20', hexCode: '#EAD3B2' },
  { factoryValueCode: 'RAL 080 85 30', hexCode: '#F1D0A0' },
  { factoryValueCode: 'RAL 080 85 40', hexCode: '#F9CF8D' },
  { factoryValueCode: 'RAL 080 90 05', hexCode: '#EDE5DA' },
  { factoryValueCode: 'RAL 080 90 10', hexCode: '#EFE1CF' },
  { factoryValueCode: 'RAL 080 90 20', hexCode: '#ECD6B6' },
  { factoryValueCode: 'RAL 080 90 30', hexCode: '#FFDFAE' },
  { factoryValueCode: 'RAL 080 93 05', hexCode: '#F3EAE1' },
  { factoryValueCode: 'RAL 085 40 10', hexCode: '#716A5E' },
  { factoryValueCode: 'RAL 085 40 20', hexCode: '#74674F' },
  { factoryValueCode: 'RAL 085 40 30', hexCode: '#7A6847' },
  { factoryValueCode: 'RAL 085 50 10', hexCode: '#867E6F' },
  { factoryValueCode: 'RAL 085 50 20', hexCode: '#8C7D61' },
  { factoryValueCode: 'RAL 085 50 30', hexCode: '#927D54' },
  { factoryValueCode: 'RAL 085 50 40', hexCode: '#947B48' },
  { factoryValueCode: 'RAL 085 50 50', hexCode: '#987B3D' },
  { factoryValueCode: 'RAL 085 60 10', hexCode: '#9E9587' },
  { factoryValueCode: 'RAL 085 60 20', hexCode: '#A59476' },
  { factoryValueCode: 'RAL 085 60 30', hexCode: '#AB9367' },
  { factoryValueCode: 'RAL 085 60 40', hexCode: '#AF9358' },
  { factoryValueCode: 'RAL 085 60 50', hexCode: '#B4934A' },
  { factoryValueCode: 'RAL 085 60 60', hexCode: '#B9923B' },
  { factoryValueCode: 'RAL 085 70 10', hexCode: '#B6AD9C' },
  { factoryValueCode: 'RAL 085 70 20', hexCode: '#BFAC8C' },
  { factoryValueCode: 'RAL 085 70 30', hexCode: '#C5AC7A' },
  { factoryValueCode: 'RAL 085 70 40', hexCode: '#C9AA6B' },
  { factoryValueCode: 'RAL 085 70 50', hexCode: '#CEA95A' },
  { factoryValueCode: 'RAL 085 70 60', hexCode: '#D0A848' },
  { factoryValueCode: 'RAL 085 70 70', hexCode: '#D4A738' },
  { factoryValueCode: 'RAL 085 70 75', hexCode: '#DAA92D' },
  { factoryValueCode: 'RAL 085 80 10', hexCode: '#D1C7B5' },
  { factoryValueCode: 'RAL 085 80 20', hexCode: '#D8C6A4' },
  { factoryValueCode: 'RAL 085 80 30', hexCode: '#E1C692' },
  { factoryValueCode: 'RAL 085 80 40', hexCode: '#E6C582' },
  { factoryValueCode: 'RAL 085 80 50', hexCode: '#E9C370' },
  { factoryValueCode: 'RAL 085 80 60', hexCode: '#EEC25D' },
  { factoryValueCode: 'RAL 085 80 70', hexCode: '#F2C14B' },
  { factoryValueCode: 'RAL 085 80 80', hexCode: '#F4BF36' },
  { factoryValueCode: 'RAL 085 80 85', hexCode: '#F5BF2C' },
  { factoryValueCode: 'RAL 085 85 10', hexCode: '#DDD2BF' },
  { factoryValueCode: 'RAL 085 85 20', hexCode: '#E5D2B0' },
  { factoryValueCode: 'RAL 085 85 30', hexCode: '#EDD19E' },
  { factoryValueCode: 'RAL 085 85 40', hexCode: '#F4D28E' },
  { factoryValueCode: 'RAL 085 90 10', hexCode: '#F0E5D3' },
  { factoryValueCode: 'RAL 085 90 20', hexCode: '#F6E1BE' },
  { factoryValueCode: 'RAL 085 90 30', hexCode: '#FBDEAB' },
  { factoryValueCode: 'RAL 085 93 05', hexCode: '#F2ECE3' },
  { factoryValueCode: 'RAL 090 30 10', hexCode: '#5B554A' },
  { factoryValueCode: 'RAL 090 30 20', hexCode: '#5F5641' },
  { factoryValueCode: 'RAL 090 40 10', hexCode: '#706A5D' },
  { factoryValueCode: 'RAL 090 40 20', hexCode: '#73684D' },
  { factoryValueCode: 'RAL 090 40 30', hexCode: '#766843' },
  { factoryValueCode: 'RAL 090 50 10', hexCode: '#847E70' },
  { factoryValueCode: 'RAL 090 50 20', hexCode: '#887D61' },
  { factoryValueCode: 'RAL 090 50 30', hexCode: '#8E7E51' },
  { factoryValueCode: 'RAL 090 50 40', hexCode: '#917E45' },
  { factoryValueCode: 'RAL 090 60 10', hexCode: '#9B9485' },
  { factoryValueCode: 'RAL 090 60 20', hexCode: '#A29474' },
  { factoryValueCode: 'RAL 090 60 30', hexCode: '#A59467' },
  { factoryValueCode: 'RAL 090 60 40', hexCode: '#A89356' },
  { factoryValueCode: 'RAL 090 60 50', hexCode: '#A89043' },
  { factoryValueCode: 'RAL 090 60 60', hexCode: '#AF9538' },
  { factoryValueCode: 'RAL 090 70 10', hexCode: '#B5AE9D' },
  { factoryValueCode: 'RAL 090 70 20', hexCode: '#BBAD8A' },
  { factoryValueCode: 'RAL 090 70 30', hexCode: '#BEAB7B' },
  { factoryValueCode: 'RAL 090 70 40', hexCode: '#C5AE6A' },
  { factoryValueCode: 'RAL 090 70 50', hexCode: '#C8AD5A' },
  { factoryValueCode: 'RAL 090 70 60', hexCode: '#CAAC47' },
  { factoryValueCode: 'RAL 090 70 70', hexCode: '#CDAC33' },
  { factoryValueCode: 'RAL 090 70 80', hexCode: '#CFAB22' },
  { factoryValueCode: 'RAL 090 80 10', hexCode: '#D0C7B3' },
  { factoryValueCode: 'RAL 090 80 20', hexCode: '#D5C6A3' },
  { factoryValueCode: 'RAL 090 80 30', hexCode: '#DCC894' },
  { factoryValueCode: 'RAL 090 80 40', hexCode: '#E0C984' },
  { factoryValueCode: 'RAL 090 80 50', hexCode: '#E5C76D' },
  { factoryValueCode: 'RAL 090 80 60', hexCode: '#E7C558' },
  { factoryValueCode: 'RAL 090 80 70', hexCode: '#EBC648' },
  { factoryValueCode: 'RAL 090 80 80', hexCode: '#EAC42C' },
  { factoryValueCode: 'RAL 090 80 90', hexCode: '#F0C503' },
  { factoryValueCode: 'RAL 090 85 05', hexCode: '#DAD4CA' },
  { factoryValueCode: 'RAL 090 85 10', hexCode: '#DFD5C2' },
  { factoryValueCode: 'RAL 090 85 20', hexCode: '#E4D5B0' },
  { factoryValueCode: 'RAL 090 85 30', hexCode: '#EAD59F' },
  { factoryValueCode: 'RAL 090 85 40', hexCode: '#EDD38C' },
  { factoryValueCode: 'RAL 090 85 50', hexCode: '#F2D479' },
  { factoryValueCode: 'RAL 090 90 05', hexCode: '#EAE4D9' },
  { factoryValueCode: 'RAL 090 90 10', hexCode: '#EBE4D1' },
  { factoryValueCode: 'RAL 090 90 20', hexCode: '#F2E3BD' },
  { factoryValueCode: 'RAL 090 90 30', hexCode: '#F6E2AC' },
  { factoryValueCode: 'RAL 090 90 40', hexCode: '#FCE299' },
  { factoryValueCode: 'RAL 090 90 50', hexCode: '#FDDE82' },
  { factoryValueCode: 'RAL 090 90 60', hexCode: '#FEDC70' },
  { factoryValueCode: 'RAL 090 93 05', hexCode: '#F0EBE0' },
  { factoryValueCode: 'RAL 095 40 10', hexCode: '#6E6A5D' },
  { factoryValueCode: 'RAL 095 40 20', hexCode: '#71684E' },
  { factoryValueCode: 'RAL 095 40 30', hexCode: '#726843' },
  { factoryValueCode: 'RAL 095 50 10', hexCode: '#837E70' },
  { factoryValueCode: 'RAL 095 50 20', hexCode: '#877E62' },
  { factoryValueCode: 'RAL 095 50 30', hexCode: '#8B7F54' },
  { factoryValueCode: 'RAL 095 50 40', hexCode: '#8D7E45' },
  { factoryValueCode: 'RAL 095 50 50', hexCode: '#8F813C' },
  { factoryValueCode: 'RAL 095 60 10', hexCode: '#9C9686' },
  { factoryValueCode: 'RAL 095 60 20', hexCode: '#9F9676' },
  { factoryValueCode: 'RAL 095 60 30', hexCode: '#A39565' },
  { factoryValueCode: 'RAL 095 60 40', hexCode: '#A59556' },
  { factoryValueCode: 'RAL 095 60 50', hexCode: '#A69746' },
  { factoryValueCode: 'RAL 095 60 60', hexCode: '#A59439' },
  { factoryValueCode: 'RAL 095 60 70', hexCode: '#A7962A' },
  { factoryValueCode: 'RAL 095 70 10', hexCode: '#B6B09E' },
  { factoryValueCode: 'RAL 095 70 20', hexCode: '#BAB08F' },
  { factoryValueCode: 'RAL 095 70 30', hexCode: '#BEB07E' },
  { factoryValueCode: 'RAL 095 70 40', hexCode: '#C0AF6A' },
  { factoryValueCode: 'RAL 095 70 50', hexCode: '#C0AF5C' },
  { factoryValueCode: 'RAL 095 70 60', hexCode: '#C0AE4C' },
  { factoryValueCode: 'RAL 095 70 70', hexCode: '#C5B037' },
  { factoryValueCode: 'RAL 095 80 10', hexCode: '#CFC9B8' },
  { factoryValueCode: 'RAL 095 80 20', hexCode: '#D5CAA7' },
  { factoryValueCode: 'RAL 095 80 30', hexCode: '#DBCC96' },
  { factoryValueCode: 'RAL 095 80 40', hexCode: '#DECB83' },
  { factoryValueCode: 'RAL 095 80 50', hexCode: '#DECA72' },
  { factoryValueCode: 'RAL 095 80 60', hexCode: '#DCC75F' },
  { factoryValueCode: 'RAL 095 80 70', hexCode: '#DFC94B' },
  { factoryValueCode: 'RAL 095 80 80', hexCode: '#DAC438' },
  { factoryValueCode: 'RAL 095 85 10', hexCode: '#DCD6C4' },
  { factoryValueCode: 'RAL 095 85 20', hexCode: '#E2D7B4' },
  { factoryValueCode: 'RAL 095 85 30', hexCode: '#E6D6A0' },
  { factoryValueCode: 'RAL 095 85 40', hexCode: '#EBD78D' },
  { factoryValueCode: 'RAL 095 85 50', hexCode: '#ECD67C' },
  { factoryValueCode: 'RAL 095 90 10', hexCode: '#ECE5D0' },
  { factoryValueCode: 'RAL 095 90 20', hexCode: '#F1E4C0' },
  { factoryValueCode: 'RAL 095 90 30', hexCode: '#F6E3AC' },
  { factoryValueCode: 'RAL 095 90 40', hexCode: '#F7E297' },
  { factoryValueCode: 'RAL 095 90 50', hexCode: '#FDE588' },
  { factoryValueCode: 'RAL 095 90 59', hexCode: '#FFE479' },
  { factoryValueCode: 'RAL 095 93 05', hexCode: '#EEEBE2' },
  { factoryValueCode: 'RAL 100 20 05', hexCode: '#4A4945' },
  { factoryValueCode: 'RAL 100 30 05', hexCode: '#56554F' },
  { factoryValueCode: 'RAL 100 30 10', hexCode: '#585449' },
  { factoryValueCode: 'RAL 100 30 20', hexCode: '#5A5741' },
  { factoryValueCode: 'RAL 100 40 05', hexCode: '#6A6962' },
  { factoryValueCode: 'RAL 100 40 10', hexCode: '#6C695B' },
  { factoryValueCode: 'RAL 100 40 20', hexCode: '#6D694F' },
  { factoryValueCode: 'RAL 100 40 30', hexCode: '#706A43' },
  { factoryValueCode: 'RAL 100 40 40', hexCode: '#716B3B' },
  { factoryValueCode: 'RAL 100 50 05', hexCode: '#817F77' },
  { factoryValueCode: 'RAL 100 50 10', hexCode: '#827E6E' },
  { factoryValueCode: 'RAL 100 50 20', hexCode: '#848060' },
  { factoryValueCode: 'RAL 100 50 30', hexCode: '#847E52' },
  { factoryValueCode: 'RAL 100 50 40', hexCode: '#888045' },
  { factoryValueCode: 'RAL 100 50 50', hexCode: '#868039' },
  { factoryValueCode: 'RAL 100 60 05', hexCode: '#99978E' },
  { factoryValueCode: 'RAL 100 60 10', hexCode: '#979483' },
  { factoryValueCode: 'RAL 100 60 20', hexCode: '#9D9776' },
  { factoryValueCode: 'RAL 100 60 30', hexCode: '#9D9664' },
  { factoryValueCode: 'RAL 100 60 40', hexCode: '#9F9857' },
  { factoryValueCode: 'RAL 100 60 50', hexCode: '#9F9946' },
  { factoryValueCode: 'RAL 100 60 60', hexCode: '#9B9532' },
  { factoryValueCode: 'RAL 100 70 05', hexCode: '#B3B1A8' },
  { factoryValueCode: 'RAL 100 70 10', hexCode: '#B4B09E' },
  { factoryValueCode: 'RAL 100 70 20', hexCode: '#B6B08D' },
  { factoryValueCode: 'RAL 100 70 30', hexCode: '#B6B07B' },
  { factoryValueCode: 'RAL 100 70 40', hexCode: '#BAB26C' },
  { factoryValueCode: 'RAL 100 70 50', hexCode: '#B8AF57' },
  { factoryValueCode: 'RAL 100 70 60', hexCode: '#B6AF44' },
  { factoryValueCode: 'RAL 100 80 05', hexCode: '#CAC9BF' },
  { factoryValueCode: 'RAL 100 80 10', hexCode: '#CECAB5' },
  { factoryValueCode: 'RAL 100 80 20', hexCode: '#D4CCA7' },
  { factoryValueCode: 'RAL 100 80 30', hexCode: '#D3CA93' },
  { factoryValueCode: 'RAL 100 80 40', hexCode: '#D4CB81' },
  { factoryValueCode: 'RAL 100 80 50', hexCode: '#D4CB6E' },
  { factoryValueCode: 'RAL 100 80 60', hexCode: '#D9CD5B' },
  { factoryValueCode: 'RAL 100 80 70', hexCode: '#D8CD48' },
  { factoryValueCode: 'RAL 100 80 80', hexCode: '#D5CE33' },
  { factoryValueCode: 'RAL 100 85 05', hexCode: '#D9D7CD' },
  { factoryValueCode: 'RAL 100 85 10', hexCode: '#DBD6C2' },
  { factoryValueCode: 'RAL 100 85 20', hexCode: '#DDD6B0' },
  { factoryValueCode: 'RAL 100 85 30', hexCode: '#E1D7A0' },
  { factoryValueCode: 'RAL 100 90 05', hexCode: '#E8E5D9' },
  { factoryValueCode: 'RAL 100 90 10', hexCode: '#EAE5D1' },
  { factoryValueCode: 'RAL 100 90 20', hexCode: '#EEE5BF' },
  { factoryValueCode: 'RAL 100 90 30', hexCode: '#EEE4AA' },
  { factoryValueCode: 'RAL 100 90 40', hexCode: '#F3E699' },
  { factoryValueCode: 'RAL 100 90 50', hexCode: '#F1E586' },
  { factoryValueCode: 'RAL 100 93 05', hexCode: '#EFEDE3' },
  { factoryValueCode: 'RAL 110 20 10', hexCode: '#484840' },
  { factoryValueCode: 'RAL 110 30 10', hexCode: '#57574C' },
  { factoryValueCode: 'RAL 110 30 20', hexCode: '#585945' },
  { factoryValueCode: 'RAL 110 40 10', hexCode: '#6A6B5D' },
  { factoryValueCode: 'RAL 110 40 20', hexCode: '#67694D' },
  { factoryValueCode: 'RAL 110 40 30', hexCode: '#696C46' },
  { factoryValueCode: 'RAL 110 40 40', hexCode: '#686E3C' },
  { factoryValueCode: 'RAL 110 50 10', hexCode: '#7F7F70' },
  { factoryValueCode: 'RAL 110 50 20', hexCode: '#7E8061' },
  { factoryValueCode: 'RAL 110 50 30', hexCode: '#7D8153' },
  { factoryValueCode: 'RAL 110 50 40', hexCode: '#7B8244' },
  { factoryValueCode: 'RAL 110 50 50', hexCode: '#79833A' },
  { factoryValueCode: 'RAL 110 50 55', hexCode: '#798533' },
  { factoryValueCode: 'RAL 110 60 10', hexCode: '#959685' },
  { factoryValueCode: 'RAL 110 60 20', hexCode: '#939777' },
  { factoryValueCode: 'RAL 110 60 30', hexCode: '#969A69' },
  { factoryValueCode: 'RAL 110 60 40', hexCode: '#929A58' },
  { factoryValueCode: 'RAL 110 60 50', hexCode: '#909C49' },
  { factoryValueCode: 'RAL 110 60 60', hexCode: '#909F3B' },
  { factoryValueCode: 'RAL 110 60 65', hexCode: '#91A033' },
  { factoryValueCode: 'RAL 110 70 10', hexCode: '#B0B19E' },
  { factoryValueCode: 'RAL 110 70 20', hexCode: '#AFB28E' },
  { factoryValueCode: 'RAL 110 70 30', hexCode: '#ACB17D' },
  { factoryValueCode: 'RAL 110 70 40', hexCode: '#ACB46E' },
  { factoryValueCode: 'RAL 110 70 50', hexCode: '#ACB65D' },
  { factoryValueCode: 'RAL 110 70 60', hexCode: '#A8B64C' },
  { factoryValueCode: 'RAL 110 70 70', hexCode: '#A1B62B' },
  { factoryValueCode: 'RAL 110 70 77', hexCode: '#A0B42D' },
  { factoryValueCode: 'RAL 110 80 10', hexCode: '#C7C9B7' },
  { factoryValueCode: 'RAL 110 80 20', hexCode: '#CBCCA7' },
  { factoryValueCode: 'RAL 110 80 30', hexCode: '#C9CE95' },
  { factoryValueCode: 'RAL 110 80 40', hexCode: '#C7CF84' },
  { factoryValueCode: 'RAL 110 80 50', hexCode: '#C8D172' },
  { factoryValueCode: 'RAL 110 80 60', hexCode: '#C4D160' },
  { factoryValueCode: 'RAL 110 80 70', hexCode: '#C2D24C' },
  { factoryValueCode: 'RAL 110 85 10', hexCode: '#D5D6C3' },
  { factoryValueCode: 'RAL 110 85 20', hexCode: '#D5D7B1' },
  { factoryValueCode: 'RAL 110 85 30', hexCode: '#D7DAA1' },
  { factoryValueCode: 'RAL 110 85 40', hexCode: '#D5DA8E' },
  { factoryValueCode: 'RAL 110 85 50', hexCode: '#D2DA7A' },
  { factoryValueCode: 'RAL 110 90 05', hexCode: '#E4E2D7' },
  { factoryValueCode: 'RAL 110 90 10', hexCode: '#E6E6D2' },
  { factoryValueCode: 'RAL 110 90 20', hexCode: '#E6E7BF' },
  { factoryValueCode: 'RAL 110 90 30', hexCode: '#E5E7AC' },
  { factoryValueCode: 'RAL 110 90 40', hexCode: '#E4E99B' },
  { factoryValueCode: 'RAL 110 93 05', hexCode: '#EBEBE1' },
  { factoryValueCode: 'RAL 110 96 02', hexCode: '#F4F3EF' },
  { factoryValueCode: 'RAL 120 30 05', hexCode: '#545650' },
  { factoryValueCode: 'RAL 120 30 10', hexCode: '#53574B' },
  { factoryValueCode: 'RAL 120 30 20', hexCode: '#515842' },
  { factoryValueCode: 'RAL 120 40 05', hexCode: '#686962' },
  { factoryValueCode: 'RAL 120 40 10', hexCode: '#66695B' },
  { factoryValueCode: 'RAL 120 40 20', hexCode: '#636B51' },
  { factoryValueCode: 'RAL 120 40 30', hexCode: '#626E48' },
  { factoryValueCode: 'RAL 120 40 40', hexCode: '#5C703B' },
  { factoryValueCode: 'RAL 120 50 05', hexCode: '#7E7F77' },
  { factoryValueCode: 'RAL 120 50 10', hexCode: '#7B8071' },
  { factoryValueCode: 'RAL 120 50 20', hexCode: '#788262' },
  { factoryValueCode: 'RAL 120 50 30', hexCode: '#758254' },
  { factoryValueCode: 'RAL 120 50 40', hexCode: '#72864C' },
  { factoryValueCode: 'RAL 120 50 50', hexCode: '#6C863E' },
  { factoryValueCode: 'RAL 120 60 05', hexCode: '#979A90' },
  { factoryValueCode: 'RAL 120 60 10', hexCode: '#929787' },
  { factoryValueCode: 'RAL 120 60 20', hexCode: '#909978' },
  { factoryValueCode: 'RAL 120 60 30', hexCode: '#8C9D6B' },
  { factoryValueCode: 'RAL 120 60 40', hexCode: '#899F5D' },
  { factoryValueCode: 'RAL 120 60 50', hexCode: '#83A04D' },
  { factoryValueCode: 'RAL 120 60 60', hexCode: '#7DA03E' },
  { factoryValueCode: 'RAL 120 60 63', hexCode: '#7CA23D' },
  { factoryValueCode: 'RAL 120 70 05', hexCode: '#AFB1A7' },
  { factoryValueCode: 'RAL 120 70 10', hexCode: '#ACB19E' },
  { factoryValueCode: 'RAL 120 70 20', hexCode: '#A8B38F' },
  { factoryValueCode: 'RAL 120 70 30', hexCode: '#A6B682' },
  { factoryValueCode: 'RAL 120 70 40', hexCode: '#A1B872' },
  { factoryValueCode: 'RAL 120 70 50', hexCode: '#9CB960' },
  { factoryValueCode: 'RAL 120 70 60', hexCode: '#95B751' },
  { factoryValueCode: 'RAL 120 70 70', hexCode: '#92BC42' },
  { factoryValueCode: 'RAL 120 70 75', hexCode: '#8DB836' },
  { factoryValueCode: 'RAL 120 80 05', hexCode: '#C8CBC1' },
  { factoryValueCode: 'RAL 120 80 10', hexCode: '#C5CAB6' },
  { factoryValueCode: 'RAL 120 80 20', hexCode: '#C4CEA9' },
  { factoryValueCode: 'RAL 120 80 30', hexCode: '#BECF97' },
  { factoryValueCode: 'RAL 120 80 40', hexCode: '#BBD289' },
  { factoryValueCode: 'RAL 120 80 50', hexCode: '#B6D478' },
  { factoryValueCode: 'RAL 120 80 60', hexCode: '#B1D669' },
  { factoryValueCode: 'RAL 120 85 05', hexCode: '#D4D6CC' },
  { factoryValueCode: 'RAL 120 85 10 ', hexCode: '#D1D7C4' },
  { factoryValueCode: 'RAL 120 85 20', hexCode: '#D0DAB4' },
  { factoryValueCode: 'RAL 120 85 30', hexCode: '#CCDBA2' },
  { factoryValueCode: 'RAL 120 90 05', hexCode: '#E2E4D9' },
  { factoryValueCode: 'RAL 120 90 10', hexCode: '#E4E7D3' },
  { factoryValueCode: 'RAL 120 90 20', hexCode: '#DEE8C2' },
  { factoryValueCode: 'RAL 120 90 30', hexCode: '#DAEBB1' },
  { factoryValueCode: 'RAL 120 93 05', hexCode: '#E9ECE1' },
  { factoryValueCode: 'RAL 130 30 10', hexCode: '#53584D' },
  { factoryValueCode: 'RAL 130 30 20', hexCode: '#4E5945' },
  { factoryValueCode: 'RAL 130 40 10', hexCode: '#666C5F' },
  { factoryValueCode: 'RAL 130 40 20', hexCode: '#5D6C53' },
  { factoryValueCode: 'RAL 130 40 30', hexCode: '#5A6F4B' },
  { factoryValueCode: 'RAL 130 50 10', hexCode: '#788072' },
  { factoryValueCode: 'RAL 130 50 20', hexCode: '#758468' },
  { factoryValueCode: 'RAL 130 50 30', hexCode: '#6C855B' },
  { factoryValueCode: 'RAL 130 50 40', hexCode: '#65884F' },
  { factoryValueCode: 'RAL 130 50 50', hexCode: '#5D8947' },
  { factoryValueCode: 'RAL 130 60 10', hexCode: '#909989' },
  { factoryValueCode: 'RAL 130 60 20', hexCode: '#8A9B7D' },
  { factoryValueCode: 'RAL 130 60 30', hexCode: '#839D71' },
  { factoryValueCode: 'RAL 130 60 40', hexCode: '#7C9F64' },
  { factoryValueCode: 'RAL 130 60 50', hexCode: '#74A256' },
  { factoryValueCode: 'RAL 130 60 60', hexCode: '#69A449' },
  { factoryValueCode: 'RAL 130 70 10', hexCode: '#A9B3A3' },
  { factoryValueCode: 'RAL 130 70 20', hexCode: '#A4B695' },
  { factoryValueCode: 'RAL 130 70 30', hexCode: '#9BB787' },
  { factoryValueCode: 'RAL 130 70 40', hexCode: '#94B979' },
  { factoryValueCode: 'RAL 130 70 50', hexCode: '#8DBC6E' },
  { factoryValueCode: 'RAL 130 70 60', hexCode: '#84BE5F' },
  { factoryValueCode: 'RAL 130 80 10', hexCode: '#C3CCBB' },
  { factoryValueCode: 'RAL 130 80 20', hexCode: '#BDCEAD' },
  { factoryValueCode: 'RAL 130 80 30', hexCode: '#B6D1A0' },
  { factoryValueCode: 'RAL 130 80 40', hexCode: '#AFD592' },
  { factoryValueCode: 'RAL 130 80 50', hexCode: '#A7D683' },
  { factoryValueCode: 'RAL 130 85 05', hexCode: '#D1D7CD' },
  { factoryValueCode: 'RAL 130 85 10', hexCode: '#CFD9C6' },
  { factoryValueCode: 'RAL 130 85 20', hexCode: '#C9DBB8' },
  { factoryValueCode: 'RAL 130 85 30', hexCode: '#C5DEAC' },
  { factoryValueCode: 'RAL 130 90 05', hexCode: '#E0E4DA' },
  { factoryValueCode: 'RAL 130 90 10', hexCode: '#E0E3D9' },
  { factoryValueCode: 'RAL 130 90 20', hexCode: '#D8E9C6' },
  { factoryValueCode: 'RAL 130 93 05', hexCode: '#E8ECE3' },
  { factoryValueCode: 'RAL 140 20 05', hexCode: '#454845' },
  { factoryValueCode: 'RAL 140 20 10', hexCode: '#424941' },
  { factoryValueCode: 'RAL 140 20 20', hexCode: '#414B3E' },
  { factoryValueCode: 'RAL 140 30 05', hexCode: '#555954' },
  { factoryValueCode: 'RAL 140 30 10', hexCode: '#51594F' },
  { factoryValueCode: 'RAL 140 30 20', hexCode: '#4B5C48' },
  { factoryValueCode: 'RAL 140 30 30', hexCode: '#425E3F' },
  { factoryValueCode: 'RAL 140 30 40', hexCode: '#395E3C' },
  { factoryValueCode: 'RAL 140 40 05', hexCode: '#676C66' },
  { factoryValueCode: 'RAL 140 40 10', hexCode: '#626C60' },
  { factoryValueCode: 'RAL 140 40 20', hexCode: '#586D55' },
  { factoryValueCode: 'RAL 140 40 30', hexCode: '#51704C' },
  { factoryValueCode: 'RAL 140 40 40', hexCode: '#487547' },
  { factoryValueCode: 'RAL 140 40 50', hexCode: '#407740' },
  { factoryValueCode: 'RAL 140 50 05', hexCode: '#7A8079' },
  { factoryValueCode: 'RAL 140 50 10', hexCode: '#768174' },
  { factoryValueCode: 'RAL 140 50 20', hexCode: '#6E8368' },
  { factoryValueCode: 'RAL 140 50 30', hexCode: '#65875F' },
  { factoryValueCode: 'RAL 140 50 40', hexCode: '#588853' },
  { factoryValueCode: 'RAL 140 50 50', hexCode: '#4F8C4C' },
  { factoryValueCode: 'RAL 140 50 60', hexCode: '#408E42' },
  { factoryValueCode: 'RAL 140 60 05', hexCode: '#919791' },
  { factoryValueCode: 'RAL 140 60 10', hexCode: '#8B9889' },
  { factoryValueCode: 'RAL 140 60 20', hexCode: '#859E80' },
  { factoryValueCode: 'RAL 140 60 30', hexCode: '#7BA174' },
  { factoryValueCode: 'RAL 140 60 40', hexCode: '#72A369' },
  { factoryValueCode: 'RAL 140 60 50', hexCode: '#64A45E' },
  { factoryValueCode: 'RAL 140 60 60', hexCode: '#59A754' },
  { factoryValueCode: 'RAL 140 60 70', hexCode: '#4AA74B' },
  { factoryValueCode: 'RAL 140 70 05', hexCode: '#AAB0A9' },
  { factoryValueCode: 'RAL 140 70 10', hexCode: '#A3B1A3' },
  { factoryValueCode: 'RAL 140 70 20', hexCode: '#9CB697' },
  { factoryValueCode: 'RAL 140 70 30', hexCode: '#91B98C' },
  { factoryValueCode: 'RAL 140 70 40', hexCode: '#89BD80' },
  { factoryValueCode: 'RAL 140 70 50', hexCode: '#7CBF74' },
  { factoryValueCode: 'RAL 140 70 60', hexCode: '#71C067' },
  { factoryValueCode: 'RAL 140 80 05', hexCode: '#C5CCC2' },
  { factoryValueCode: 'RAL 140 80 10', hexCode: '#BFCCBC' },
  { factoryValueCode: 'RAL 140 80 20', hexCode: '#B6D0B0' },
  { factoryValueCode: 'RAL 140 80 30', hexCode: '#ABD3A4' },
  { factoryValueCode: 'RAL 140 80 40', hexCode: '#9DD697' },
  { factoryValueCode: 'RAL 140 85 05', hexCode: '#D0D8CF' },
  { factoryValueCode: 'RAL 140 85 10', hexCode: '#CCDACA' },
  { factoryValueCode: 'RAL 140 85 20', hexCode: '#C3DEBD' },
  { factoryValueCode: 'RAL 140 85 30', hexCode: '#B6DFB0' },
  { factoryValueCode: 'RAL 140 90 05', hexCode: '#E0E6DB' },
  { factoryValueCode: 'RAL 140 90 10', hexCode: '#DCE8D6' },
  { factoryValueCode: 'RAL 140 93 05', hexCode: '#E8EEE4' },
  { factoryValueCode: 'RAL 150 30 10', hexCode: '#515C53' },
  { factoryValueCode: 'RAL 150 30 20', hexCode: '#475E4E' },
  { factoryValueCode: 'RAL 150 30 30', hexCode: '#3D5E46' },
  { factoryValueCode: 'RAL 150 40 10', hexCode: '#616D63' },
  { factoryValueCode: 'RAL 150 40 20', hexCode: '#58715C' },
  { factoryValueCode: 'RAL 150 40 30', hexCode: '#4A7254' },
  { factoryValueCode: 'RAL 150 40 40', hexCode: '#3C744C' },
  { factoryValueCode: 'RAL 150 40 50', hexCode: '#307649' },
  { factoryValueCode: 'RAL 150 50 10', hexCode: '#738176' },
  { factoryValueCode: 'RAL 150 50 20', hexCode: '#69866E' },
  { factoryValueCode: 'RAL 150 50 30', hexCode: '#608866' },
  { factoryValueCode: 'RAL 150 50 40', hexCode: '#518D63' },
  { factoryValueCode: 'RAL 150 50 50', hexCode: '#3E8F58' },
  { factoryValueCode: 'RAL 150 50 60', hexCode: '#239151' },
  { factoryValueCode: 'RAL 150 60 10', hexCode: '#8C9B8E' },
  { factoryValueCode: 'RAL 150 60 20', hexCode: '#7F9E86' },
  { factoryValueCode: 'RAL 150 60 30', hexCode: '#73A07D' },
  { factoryValueCode: 'RAL 150 60 40', hexCode: '#65A474' },
  { factoryValueCode: 'RAL 150 60 50', hexCode: '#58A96F' },
  { factoryValueCode: 'RAL 150 60 60', hexCode: '#3AA861' },
  { factoryValueCode: 'RAL 150 70 10', hexCode: '#A3B3A6' },
  { factoryValueCode: 'RAL 150 70 20', hexCode: '#98B89F' },
  { factoryValueCode: 'RAL 150 70 30', hexCode: '#8ABD95' },
  { factoryValueCode: 'RAL 150 70 40', hexCode: '#7CBE8C' },
  { factoryValueCode: 'RAL 150 70 50', hexCode: '#6CC181' },
  { factoryValueCode: 'RAL 150 80 10', hexCode: '#BDCEC0' },
  { factoryValueCode: 'RAL 150 80 20', hexCode: '#B1D2B7' },
  { factoryValueCode: 'RAL 150 80 30', hexCode: '#A3D6AF' },
  { factoryValueCode: 'RAL 150 80 40', hexCode: '#95DAA5' },
  { factoryValueCode: 'RAL 150 85 05', hexCode: '#CCD7CE' },
  { factoryValueCode: 'RAL 150 85 10', hexCode: '#C9DACA' },
  { factoryValueCode: 'RAL 150 85 20', hexCode: '#BFDEC1' },
  { factoryValueCode: 'RAL 150 90 05', hexCode: '#DCE5DA' },
  { factoryValueCode: 'RAL 150 90 10', hexCode: '#D9E9D8' },
  { factoryValueCode: 'RAL 150 93 05', hexCode: '#E4EDE4' },
  { factoryValueCode: 'RAL 160 20 05', hexCode: '#464A48' },
  { factoryValueCode: 'RAL 160 20 10', hexCode: '#404B45' },
  { factoryValueCode: 'RAL 160 20 15', hexCode: '#394A43' },
  { factoryValueCode: 'RAL 160 20 20', hexCode: '#394942' },
  { factoryValueCode: 'RAL 160 30 05', hexCode: '#535955' },
  { factoryValueCode: 'RAL 160 30 10', hexCode: '#4E5A53' },
  { factoryValueCode: 'RAL 160 30 15', hexCode: '#485A4F' },
  { factoryValueCode: 'RAL 160 30 20', hexCode: '#415A4D' },
  { factoryValueCode: 'RAL 160 30 25', hexCode: '#3B5C4A' },
  { factoryValueCode: 'RAL 160 30 30', hexCode: '#345E48' },
  { factoryValueCode: 'RAL 160 30 35', hexCode: '#2C5E45' },
  { factoryValueCode: 'RAL 160 30 40', hexCode: '#235F44' },
  { factoryValueCode: 'RAL 160 40 05', hexCode: '#656C68' },
  { factoryValueCode: 'RAL 160 40 10', hexCode: '#5D6D65' },
  { factoryValueCode: 'RAL 160 40 15', hexCode: '#576E62' },
  { factoryValueCode: 'RAL 160 40 20', hexCode: '#506F5F' },
  { factoryValueCode: 'RAL 160 40 25', hexCode: '#49705B' },
  { factoryValueCode: 'RAL 160 40 30', hexCode: '#427259' },
  { factoryValueCode: 'RAL 160 40 35', hexCode: '#3A7457' },
  { factoryValueCode: 'RAL 160 40 40', hexCode: '#317656' },
  { factoryValueCode: 'RAL 160 40 45', hexCode: '#287451' },
  { factoryValueCode: 'RAL 160 40 50', hexCode: '#16754E' },
  { factoryValueCode: 'RAL 160 40 55', hexCode: '#05784D' },
  { factoryValueCode: 'RAL 160 50 05', hexCode: '#79817C' },
  { factoryValueCode: 'RAL 160 50 10', hexCode: '#708278' },
  { factoryValueCode: 'RAL 160 50 15', hexCode: '#6A8476' },
  { factoryValueCode: 'RAL 160 50 20', hexCode: '#638674' },
  { factoryValueCode: 'RAL 160 50 25', hexCode: '#5B8770' },
  { factoryValueCode: 'RAL 160 50 30', hexCode: '#54896E' },
  { factoryValueCode: 'RAL 160 50 35', hexCode: '#4E8B6B' },
  { factoryValueCode: 'RAL 160 50 40', hexCode: '#3F8C68' },
  { factoryValueCode: 'RAL 160 50 45', hexCode: '#398F68' },
  { factoryValueCode: 'RAL 160 50 50', hexCode: '#298E62' },
  { factoryValueCode: 'RAL 160 50 55', hexCode: '#109161' },
  { factoryValueCode: 'RAL 160 50 60', hexCode: '#00905C' },
  { factoryValueCode: 'RAL 160 60 05', hexCode: '#8F9893' },
  { factoryValueCode: 'RAL 160 60 10', hexCode: '#86998F' },
  { factoryValueCode: 'RAL 160 60 15', hexCode: '#809D8D' },
  { factoryValueCode: 'RAL 160 60 20', hexCode: '#779E89' },
  { factoryValueCode: 'RAL 160 60 25', hexCode: '#709F84' },
  { factoryValueCode: 'RAL 160 60 30', hexCode: '#68A183' },
  { factoryValueCode: 'RAL 160 60 35', hexCode: '#5FA582' },
  { factoryValueCode: 'RAL 160 60 40', hexCode: '#55A47E' },
  { factoryValueCode: 'RAL 160 60 45', hexCode: '#4CA77C' },
  { factoryValueCode: 'RAL 160 60 50', hexCode: '#3BA878' },
  { factoryValueCode: 'RAL 160 60 55', hexCode: '#32A774' },
  { factoryValueCode: 'RAL 160 60 58', hexCode: '#1CA971' },
  { factoryValueCode: 'RAL 160 70 05', hexCode: '#A7B2AC' },
  { factoryValueCode: 'RAL 160 70 10', hexCode: '#9EB3A7' },
  { factoryValueCode: 'RAL 160 70 15', hexCode: '#96B4A3' },
  { factoryValueCode: 'RAL 160 70 20', hexCode: '#90B7A1' },
  { factoryValueCode: 'RAL 160 70 25', hexCode: '#88BB9F' },
  { factoryValueCode: 'RAL 160 70 30', hexCode: '#7DBC9C' },
  { factoryValueCode: 'RAL 160 70 35', hexCode: '#74BD99' },
  { factoryValueCode: 'RAL 160 70 40', hexCode: '#6AC096' },
  { factoryValueCode: 'RAL 160 70 45', hexCode: '#5EC292' },
  { factoryValueCode: 'RAL 160 70 50', hexCode: '#54C391' },
  { factoryValueCode: 'RAL 160 80 05', hexCode: '#BFCAC4' },
  { factoryValueCode: 'RAL 160 80 10', hexCode: '#B8CDC0' },
  { factoryValueCode: 'RAL 160 80 15', hexCode: '#AFCFBD' },
  { factoryValueCode: 'RAL 160 80 20', hexCode: '#A7D2BA' },
  { factoryValueCode: 'RAL 160 80 25', hexCode: '#A1D4B8' },
  { factoryValueCode: 'RAL 160 80 30', hexCode: '#99D7B6' },
  { factoryValueCode: 'RAL 160 85 05', hexCode: '#CAD6CF' },
  { factoryValueCode: 'RAL 160 85 10', hexCode: '#C3D8CC' },
  { factoryValueCode: 'RAL 160 85 15', hexCode: '#BBDBC7' },
  { factoryValueCode: 'RAL 160 90 05', hexCode: '#DBE5DC' },
  { factoryValueCode: 'RAL 160 90 10', hexCode: '#D3E8D9' },
  { factoryValueCode: 'RAL 160 90 15', hexCode: '#CCEAD6' },
  { factoryValueCode: 'RAL 160 93 05', hexCode: '#E0ECE6' },
  { factoryValueCode: 'RAL 170 20 10', hexCode: '#3E4A46' },
  { factoryValueCode: 'RAL 170 20 15', hexCode: '#394A45' },
  { factoryValueCode: 'RAL 170 20 20', hexCode: '#334C45' },
  { factoryValueCode: 'RAL 170 20 25', hexCode: '#2F4C42' },
  { factoryValueCode: 'RAL 170 30 10', hexCode: '#4C5B55' },
  { factoryValueCode: 'RAL 170 30 15', hexCode: '#435B52' },
  { factoryValueCode: 'RAL 170 30 20', hexCode: '#3E5B51' },
  { factoryValueCode: 'RAL 170 30 25', hexCode: '#355E50' },
  { factoryValueCode: 'RAL 170 30 30', hexCode: '#2F5E50' },
  { factoryValueCode: 'RAL 170 30 35', hexCode: '#26604F' },
  { factoryValueCode: 'RAL 170 30 40', hexCode: '#16624E' },
  { factoryValueCode: 'RAL 170 40 10', hexCode: '#5B6C65' },
  { factoryValueCode: 'RAL 170 40 15', hexCode: '#536D63' },
  { factoryValueCode: 'RAL 170 40 20', hexCode: '#4B7063' },
  { factoryValueCode: 'RAL 170 40 25', hexCode: '#457060' },
  { factoryValueCode: 'RAL 170 40 30', hexCode: '#3D7561' },
  { factoryValueCode: 'RAL 170 40 35', hexCode: '#2F745E' },
  { factoryValueCode: 'RAL 170 40 40', hexCode: '#20755E' },
  { factoryValueCode: 'RAL 170 40 45', hexCode: '#08765D' },
  { factoryValueCode: 'RAL 170 40 50', hexCode: '#00765A' },
  { factoryValueCode: 'RAL 170 50 10', hexCode: '#6E827B' },
  { factoryValueCode: 'RAL 170 50 15', hexCode: '#67867A' },
  { factoryValueCode: 'RAL 170 50 20', hexCode: '#5F8678' },
  { factoryValueCode: 'RAL 170 50 25', hexCode: '#568876' },
  { factoryValueCode: 'RAL 170 50 30', hexCode: '#4A8A75' },
  { factoryValueCode: 'RAL 170 50 35', hexCode: '#3E8B73' },
  { factoryValueCode: 'RAL 170 50 40', hexCode: '#308D71' },
  { factoryValueCode: 'RAL 170 50 45', hexCode: '#1E8E71' },
  { factoryValueCode: 'RAL 170 50 50', hexCode: '#00916F' },
  { factoryValueCode: 'RAL 170 50 55', hexCode: '#00906D' },
  { factoryValueCode: 'RAL 170 60 10', hexCode: '#849A92' },
  { factoryValueCode: 'RAL 170 60 15', hexCode: '#7E9D90' },
  { factoryValueCode: 'RAL 170 60 20', hexCode: '#739F8F' },
  { factoryValueCode: 'RAL 170 60 25', hexCode: '#6AA08E' },
  { factoryValueCode: 'RAL 170 60 30', hexCode: '#5EA28C' },
  { factoryValueCode: 'RAL 170 60 35', hexCode: '#50A68A' },
  { factoryValueCode: 'RAL 170 60 40', hexCode: '#44A689' },
  { factoryValueCode: 'RAL 170 60 45', hexCode: '#33A685' },
  { factoryValueCode: 'RAL 170 60 50', hexCode: '#1BAA87' },
  { factoryValueCode: 'RAL 170 70 10', hexCode: '#9DB4AB' },
  { factoryValueCode: 'RAL 170 70 15', hexCode: '#95B6A8' },
  { factoryValueCode: 'RAL 170 70 20', hexCode: '#8BB9A7' },
  { factoryValueCode: 'RAL 170 70 25', hexCode: '#83BBA6' },
  { factoryValueCode: 'RAL 170 70 30', hexCode: '#75BEA5' },
  { factoryValueCode: 'RAL 170 70 35', hexCode: '#6ABEA2' },
  { factoryValueCode: 'RAL 170 70 40', hexCode: '#5FBFA0' },
  { factoryValueCode: 'RAL 170 80 10', hexCode: '#B7CEC5' },
  { factoryValueCode: 'RAL 170 80 15', hexCode: '#ACD0C3' },
  { factoryValueCode: 'RAL 170 80 20', hexCode: '#A4D5C2' },
  { factoryValueCode: 'RAL 170 80 25', hexCode: '#99D4BF' },
  { factoryValueCode: 'RAL 170 85 05', hexCode: '#CBD7D2' },
  { factoryValueCode: 'RAL 170 85 10', hexCode: '#C3DAD0' },
  { factoryValueCode: 'RAL 170 85 15', hexCode: '#B8DDCD' },
  { factoryValueCode: 'RAL 170 85 20', hexCode: '#B0E0CB' },
  { factoryValueCode: 'RAL 170 90 05', hexCode: '#DAE5DE' },
  { factoryValueCode: 'RAL 170 90 10', hexCode: '#D1E9DD' },
  { factoryValueCode: 'RAL 170 93 05', hexCode: '#E2EDE7' },
  { factoryValueCode: 'RAL 180 20 05', hexCode: '#454C4B' },
  { factoryValueCode: 'RAL 180 20 10', hexCode: '#3E4A47' },
  { factoryValueCode: 'RAL 180 20 15', hexCode: '#374B48' },
  { factoryValueCode: 'RAL 180 20 20', hexCode: '#304C48' },
  { factoryValueCode: 'RAL 180 30 05', hexCode: '#535B59' },
  { factoryValueCode: 'RAL 180 30 10', hexCode: '#4A5A56' },
  { factoryValueCode: 'RAL 180 30 15', hexCode: '#435C57' },
  { factoryValueCode: 'RAL 180 30 20', hexCode: '#3C5D56' },
  { factoryValueCode: 'RAL 180 30 25', hexCode: '#335E56' },
  { factoryValueCode: 'RAL 180 30 30', hexCode: '#295F56' },
  { factoryValueCode: 'RAL 180 30 35', hexCode: '#196054' },
  { factoryValueCode: 'RAL 180 40 05', hexCode: '#626C69' },
  { factoryValueCode: 'RAL 180 40 10', hexCode: '#5A6E69' },
  { factoryValueCode: 'RAL 180 40 15', hexCode: '#516F68' },
  { factoryValueCode: 'RAL 180 40 20', hexCode: '#477168' },
  { factoryValueCode: 'RAL 180 40 25', hexCode: '#3E7268' },
  { factoryValueCode: 'RAL 180 40 30', hexCode: '#2F7469' },
  { factoryValueCode: 'RAL 180 40 35', hexCode: '#1C7566' },
  { factoryValueCode: 'RAL 180 40 40', hexCode: '#007565' },
  { factoryValueCode: 'RAL 180 40 45', hexCode: '#007666' },
  { factoryValueCode: 'RAL 180 50 05', hexCode: '#788280' },
  { factoryValueCode: 'RAL 180 50 10', hexCode: '#6D827D' },
  { factoryValueCode: 'RAL 180 50 15', hexCode: '#63857D' },
  { factoryValueCode: 'RAL 180 50 20', hexCode: '#59867D' },
  { factoryValueCode: 'RAL 180 50 25', hexCode: '#4D897E' },
  { factoryValueCode: 'RAL 180 50 30', hexCode: '#408B7C' },
  { factoryValueCode: 'RAL 180 50 35', hexCode: '#318C7D' },
  { factoryValueCode: 'RAL 180 50 40', hexCode: '#1B8C7B' },
  { factoryValueCode: 'RAL 180 50 45', hexCode: '#00907B' },
  { factoryValueCode: 'RAL 180 50 50', hexCode: '#00907A' },
  { factoryValueCode: 'RAL 180 60 05', hexCode: '#8D9996' },
  { factoryValueCode: 'RAL 180 60 10', hexCode: '#829A95' },
  { factoryValueCode: 'RAL 180 60 15', hexCode: '#789D94' },
  { factoryValueCode: 'RAL 180 60 20', hexCode: '#6E9F94' },
  { factoryValueCode: 'RAL 180 60 25', hexCode: '#61A093' },
  { factoryValueCode: 'RAL 180 60 30', hexCode: '#54A394' },
  { factoryValueCode: 'RAL 180 60 35', hexCode: '#46A593' },
  { factoryValueCode: 'RAL 180 60 40', hexCode: '#2FA794' },
  { factoryValueCode: 'RAL 180 60 45', hexCode: '#02A994' },
  { factoryValueCode: 'RAL 180 60 50', hexCode: '#00AA93' },
  { factoryValueCode: 'RAL 180 70 05', hexCode: '#A6B1AE' },
  { factoryValueCode: 'RAL 180 70 10', hexCode: '#98B3AD' },
  { factoryValueCode: 'RAL 180 70 15', hexCode: '#8FB6AD' },
  { factoryValueCode: 'RAL 180 70 20', hexCode: '#85B9AD' },
  { factoryValueCode: 'RAL 180 70 25', hexCode: '#78BAAC' },
  { factoryValueCode: 'RAL 180 70 30', hexCode: '#6DBDAD' },
  { factoryValueCode: 'RAL 180 70 35', hexCode: '#5BBFAC' },
  { factoryValueCode: 'RAL 180 70 40', hexCode: '#4AC2AD' },
  { factoryValueCode: 'RAL 180 80 05', hexCode: '#BFCBC6' },
  { factoryValueCode: 'RAL 180 80 10', hexCode: '#B4CEC7' },
  { factoryValueCode: 'RAL 180 80 15', hexCode: '#ABD2C8' },
  { factoryValueCode: 'RAL 180 80 20', hexCode: '#9CD3C6' },
  { factoryValueCode: 'RAL 180 80 25', hexCode: '#91D5C6' },
  { factoryValueCode: 'RAL 180 80 30', hexCode: '#89DAC8' },
  { factoryValueCode: 'RAL 180 85 05', hexCode: '#CAD7D3' },
  { factoryValueCode: 'RAL 180 85 10', hexCode: '#C0DAD3' },
  { factoryValueCode: 'RAL 180 85 15', hexCode: '#B8DED2' },
  { factoryValueCode: 'RAL 180 85 20', hexCode: '#AADFCF' },
  { factoryValueCode: 'RAL 180 90 05', hexCode: '#DBE7E2' },
  { factoryValueCode: 'RAL 180 90 10', hexCode: '#D0ECE3' },
  { factoryValueCode: 'RAL 180 93 05', hexCode: '#E2EEEA' },
  { factoryValueCode: 'RAL 190 20 20', hexCode: '#2F4D4A' },
  { factoryValueCode: 'RAL 190 30 15', hexCode: '#415C5A' },
  { factoryValueCode: 'RAL 190 30 20', hexCode: '#375D5B' },
  { factoryValueCode: 'RAL 190 30 25', hexCode: '#2D5E5B' },
  { factoryValueCode: 'RAL 190 30 30', hexCode: '#20605D' },
  { factoryValueCode: 'RAL 190 30 35', hexCode: '#0E605D' },
  { factoryValueCode: 'RAL 190 40 10', hexCode: '#586C6A' },
  { factoryValueCode: 'RAL 190 40 15', hexCode: '#4F6F6D' },
  { factoryValueCode: 'RAL 190 40 20', hexCode: '#44716E' },
  { factoryValueCode: 'RAL 190 40 25', hexCode: '#37726F' },
  { factoryValueCode: 'RAL 190 40 30', hexCode: '#267470' },
  { factoryValueCode: 'RAL 190 40 35', hexCode: '#097671' },
  { factoryValueCode: 'RAL 190 40 40', hexCode: '#007771' },
  { factoryValueCode: 'RAL 190 40 45', hexCode: '#007A73' },
  { factoryValueCode: 'RAL 190 50 10', hexCode: '#6D8481' },
  { factoryValueCode: 'RAL 190 50 15', hexCode: '#628682' },
  { factoryValueCode: 'RAL 190 50 20', hexCode: '#578884' },
  { factoryValueCode: 'RAL 190 50 25', hexCode: '#488984' },
  { factoryValueCode: 'RAL 190 50 30', hexCode: '#368B86' },
  { factoryValueCode: 'RAL 190 50 35', hexCode: '#208C86' },
  { factoryValueCode: 'RAL 190 50 40', hexCode: '#008F89' },
  { factoryValueCode: 'RAL 190 50 45', hexCode: '#00908A' },
  { factoryValueCode: 'RAL 190 60 10', hexCode: '#829B98' },
  { factoryValueCode: 'RAL 190 60 15', hexCode: '#779D98' },
  { factoryValueCode: 'RAL 190 60 20', hexCode: '#6EA09B' },
  { factoryValueCode: 'RAL 190 60 25', hexCode: '#5EA39D' },
  { factoryValueCode: 'RAL 190 60 30', hexCode: '#4DA49E' },
  { factoryValueCode: 'RAL 190 60 35', hexCode: '#39A6A0' },
  { factoryValueCode: 'RAL 190 60 40', hexCode: '#0CA8A1' },
  { factoryValueCode: 'RAL 190 60 45', hexCode: '#00A8A0' },
  { factoryValueCode: 'RAL 190 70 10', hexCode: '#9AB4B1' },
  { factoryValueCode: 'RAL 190 70 15', hexCode: '#8FB6B1' },
  { factoryValueCode: 'RAL 190 70 20', hexCode: '#82B8B2' },
  { factoryValueCode: 'RAL 190 70 25', hexCode: '#75BBB5' },
  { factoryValueCode: 'RAL 190 70 30', hexCode: '#69BEB8' },
  { factoryValueCode: 'RAL 190 70 35', hexCode: '#55BFB7' },
  { factoryValueCode: 'RAL 190 80 10', hexCode: '#B3CFCA' },
  { factoryValueCode: 'RAL 190 80 15', hexCode: '#A9D2CD' },
  { factoryValueCode: 'RAL 190 80 20', hexCode: '#9BD2CD' },
  { factoryValueCode: 'RAL 190 80 25', hexCode: '#8FD5CF' },
  { factoryValueCode: 'RAL 190 85 05', hexCode: '#C5D9D6' },
  { factoryValueCode: 'RAL 190 85 10', hexCode: '#BADCD6' },
  { factoryValueCode: 'RAL 190 85 15', hexCode: '#AADFD6' },
  { factoryValueCode: 'RAL 190 85 20', hexCode: '#9CE2D7' },
  { factoryValueCode: 'RAL 190 90 05', hexCode: '#DBE6E2' },
  { factoryValueCode: 'RAL 190 90 10', hexCode: '#CFEAE5' },
  { factoryValueCode: 'RAL 190 93 05', hexCode: '#E3EDEB' },
  { factoryValueCode: 'RAL 200 20 05', hexCode: '#444A4A' },
  { factoryValueCode: 'RAL 200 20 10', hexCode: '#3C4A4B' },
  { factoryValueCode: 'RAL 200 20 15', hexCode: '#374A4B' },
  { factoryValueCode: 'RAL 200 20 20', hexCode: '#304C4E' },
  { factoryValueCode: 'RAL 200 20 23', hexCode: '#264D4F' },
  { factoryValueCode: 'RAL 200 30 05', hexCode: '#4F5858' },
  { factoryValueCode: 'RAL 200 30 10', hexCode: '#485B5B' },
  { factoryValueCode: 'RAL 200 30 15', hexCode: '#405D5D' },
  { factoryValueCode: 'RAL 200 30 20', hexCode: '#385E5F' },
  { factoryValueCode: 'RAL 200 30 25', hexCode: '#285D5E' },
  { factoryValueCode: 'RAL 200 30 30', hexCode: '#1A5F62' },
  { factoryValueCode: 'RAL 200 30 33', hexCode: '#006164' },
  { factoryValueCode: 'RAL 200 40 05', hexCode: '#616C6C' },
  { factoryValueCode: 'RAL 200 40 10', hexCode: '#596D6E' },
  { factoryValueCode: 'RAL 200 40 15', hexCode: '#4F6F6F' },
  { factoryValueCode: 'RAL 200 40 20', hexCode: '#427172' },
  { factoryValueCode: 'RAL 200 40 25', hexCode: '#377374' },
  { factoryValueCode: 'RAL 200 40 30', hexCode: '#237477' },
  { factoryValueCode: 'RAL 200 40 35', hexCode: '#007579' },
  { factoryValueCode: 'RAL 200 40 40', hexCode: '#00787D' },
  { factoryValueCode: 'RAL 200 50 05', hexCode: '#748080' },
  { factoryValueCode: 'RAL 200 50 10', hexCode: '#6C8384' },
  { factoryValueCode: 'RAL 200 50 15', hexCode: '#618686' },
  { factoryValueCode: 'RAL 200 50 20', hexCode: '#548788' },
  { factoryValueCode: 'RAL 200 50 25', hexCode: '#46898C' },
  { factoryValueCode: 'RAL 200 50 30', hexCode: '#308B8D' },
  { factoryValueCode: 'RAL 200 50 35', hexCode: '#118E92' },
  { factoryValueCode: 'RAL 200 50 40', hexCode: '#008F93' },
  { factoryValueCode: 'RAL 200 50 45', hexCode: '#009096' },
  { factoryValueCode: 'RAL 200 60 05', hexCode: '#8C9999' },
  { factoryValueCode: 'RAL 200 60 10', hexCode: '#829A9B' },
  { factoryValueCode: 'RAL 200 60 15', hexCode: '#769D9E' },
  { factoryValueCode: 'RAL 200 60 20', hexCode: '#6AA0A1' },
  { factoryValueCode: 'RAL 200 60 25', hexCode: '#59A1A2' },
  { factoryValueCode: 'RAL 200 60 30', hexCode: '#48A4A5' },
  { factoryValueCode: 'RAL 200 60 35', hexCode: '#33A5A9' },
  { factoryValueCode: 'RAL 200 60 40', hexCode: '#05A8AC' },
  { factoryValueCode: 'RAL 200 70 05', hexCode: '#A5B1B1' },
  { factoryValueCode: 'RAL 200 70 10', hexCode: '#9AB5B5' },
  { factoryValueCode: 'RAL 200 70 15', hexCode: '#8CB6B6' },
  { factoryValueCode: 'RAL 200 70 20', hexCode: '#82B9B9' },
  { factoryValueCode: 'RAL 200 70 25', hexCode: '#74BCBF' },
  { factoryValueCode: 'RAL 200 80 05', hexCode: '#BFCBCA' },
  { factoryValueCode: 'RAL 200 80 10', hexCode: '#B2CECE' },
  { factoryValueCode: 'RAL 200 80 15', hexCode: '#A6CFCE' },
  { factoryValueCode: 'RAL 200 80 20', hexCode: '#9AD4D3' },
  { factoryValueCode: 'RAL 200 80 25', hexCode: '#8CD5D6' },
  { factoryValueCode: 'RAL 200 85 05', hexCode: '#CAD7D7' },
  { factoryValueCode: 'RAL 200 85 10', hexCode: '#C0DADA' },
  { factoryValueCode: 'RAL 200 85 15', hexCode: '#B3DDDD' },
  { factoryValueCode: 'RAL 200 85 20', hexCode: '#A6E0DF' },
  { factoryValueCode: 'RAL 200 90 05', hexCode: '#DBE8E5' },
  { factoryValueCode: 'RAL 200 90 10', hexCode: '#CEE9E5' },
  { factoryValueCode: 'RAL 200 93 05', hexCode: '#E2EEEB' },
  { factoryValueCode: 'RAL 210 30 10', hexCode: '#4A5A5C' },
  { factoryValueCode: 'RAL 210 30 15', hexCode: '#415C60' },
  { factoryValueCode: 'RAL 210 30 20', hexCode: '#365E64' },
  { factoryValueCode: 'RAL 210 30 25', hexCode: '#2B5E65' },
  { factoryValueCode: 'RAL 210 30 30', hexCode: '#175F68' },
  { factoryValueCode: 'RAL 210 40 10', hexCode: '#586C6F' },
  { factoryValueCode: 'RAL 210 40 15', hexCode: '#4F6F74' },
  { factoryValueCode: 'RAL 210 40 20', hexCode: '#437177' },
  { factoryValueCode: 'RAL 210 40 25', hexCode: '#347178' },
  { factoryValueCode: 'RAL 210 40 30', hexCode: '#1E737D' },
  { factoryValueCode: 'RAL 210 40 35', hexCode: '#007681' },
  { factoryValueCode: 'RAL 210 40 38', hexCode: '#007481' },
  { factoryValueCode: 'RAL 210 50 10', hexCode: '#6B8386' },
  { factoryValueCode: 'RAL 210 50 15', hexCode: '#628488' },
  { factoryValueCode: 'RAL 210 50 20', hexCode: '#54868D' },
  { factoryValueCode: 'RAL 210 50 25', hexCode: '#458990' },
  { factoryValueCode: 'RAL 210 50 30', hexCode: '#2D8A94' },
  { factoryValueCode: 'RAL 210 50 35', hexCode: '#148C98' },
  { factoryValueCode: 'RAL 210 50 40', hexCode: '#008E9B' },
  { factoryValueCode: 'RAL 210 50 45', hexCode: '#008F9E' },
  { factoryValueCode: 'RAL 210 60 10', hexCode: '#829A9D' },
  { factoryValueCode: 'RAL 210 60 15', hexCode: '#769CA0' },
  { factoryValueCode: 'RAL 210 60 20', hexCode: '#6BA1A7' },
  { factoryValueCode: 'RAL 210 60 25', hexCode: '#5AA4AB' },
  { factoryValueCode: 'RAL 210 60 30', hexCode: '#48A5AF' },
  { factoryValueCode: 'RAL 210 60 35', hexCode: '#2CA5B1' },
  { factoryValueCode: 'RAL 210 60 40', hexCode: '#00A8B5' },
  { factoryValueCode: 'RAL 210 70 10', hexCode: '#9BB4B7' },
  { factoryValueCode: 'RAL 210 70 15', hexCode: '#8FB6BA' },
  { factoryValueCode: 'RAL 210 70 20', hexCode: '#81B9BF' },
  { factoryValueCode: 'RAL 210 70 25', hexCode: '#73BBC3' },
  { factoryValueCode: 'RAL 210 70 30', hexCode: '#61BEC8' },
  { factoryValueCode: 'RAL 210 70 35', hexCode: '#4CC0CB' },
  { factoryValueCode: 'RAL 210 80 10', hexCode: '#B7D0D1' },
  { factoryValueCode: 'RAL 210 80 15', hexCode: '#AAD2D4' },
  { factoryValueCode: 'RAL 210 80 20', hexCode: '#9CD3D8' },
  { factoryValueCode: 'RAL 210 80 25', hexCode: '#8FD6DD' },
  { factoryValueCode: 'RAL 210 85 05', hexCode: '#C9D8D9' },
  { factoryValueCode: 'RAL 210 85 10', hexCode: '#BADDDE' },
  { factoryValueCode: 'RAL 210 85 15', hexCode: '#B5DEDF' },
  { factoryValueCode: 'RAL 210 85 20', hexCode: '#A7E0E1' },
  { factoryValueCode: 'RAL 210 90 05', hexCode: '#DAE7E5' },
  { factoryValueCode: 'RAL 210 90 10', hexCode: '#CDE9E7' },
  { factoryValueCode: 'RAL 220 20 05', hexCode: '#43494B' },
  { factoryValueCode: 'RAL 220 20 10', hexCode: '#3C4A4E' },
  { factoryValueCode: 'RAL 220 20 15', hexCode: '#344A50' },
  { factoryValueCode: 'RAL 220 20 20', hexCode: '#2D4B53' },
  { factoryValueCode: 'RAL 220 30 05', hexCode: '#51595A' },
  { factoryValueCode: 'RAL 220 30 10', hexCode: '#4A5B5E' },
  { factoryValueCode: 'RAL 220 30 15', hexCode: '#435D64' },
  { factoryValueCode: 'RAL 220 30 20', hexCode: '#385E66' },
  { factoryValueCode: 'RAL 220 30 25', hexCode: '#2E606B' },
  { factoryValueCode: 'RAL 220 30 30', hexCode: '#155F6D' },
  { factoryValueCode: 'RAL 220 40 05', hexCode: '#626C6E' },
  { factoryValueCode: 'RAL 220 40 10', hexCode: '#5A6E72' },
  { factoryValueCode: 'RAL 220 40 15', hexCode: '#4F6F77' },
  { factoryValueCode: 'RAL 220 40 20', hexCode: '#45717B' },
  { factoryValueCode: 'RAL 220 40 25', hexCode: '#37737F' },
  { factoryValueCode: 'RAL 220 40 30', hexCode: '#1F7586' },
  { factoryValueCode: 'RAL 220 40 35', hexCode: '#007689' },
  { factoryValueCode: 'RAL 220 40 40', hexCode: '#00788E' },
  { factoryValueCode: 'RAL 220 50 05', hexCode: '#788284' },
  { factoryValueCode: 'RAL 220 50 10', hexCode: '#6F8388' },
  { factoryValueCode: 'RAL 220 50 15', hexCode: '#62858D' },
  { factoryValueCode: 'RAL 220 50 20', hexCode: '#558791' },
  { factoryValueCode: 'RAL 220 50 25', hexCode: '#488895' },
  { factoryValueCode: 'RAL 220 50 30', hexCode: '#318899' },
  { factoryValueCode: 'RAL 220 50 35', hexCode: '#198CA0' },
  { factoryValueCode: 'RAL 220 50 40', hexCode: '#008EA5' },
  { factoryValueCode: 'RAL 220 60 05', hexCode: '#8E989A' },
  { factoryValueCode: 'RAL 220 60 10', hexCode: '#839BA0' },
  { factoryValueCode: 'RAL 220 60 15', hexCode: '#799DA5' },
  { factoryValueCode: 'RAL 220 60 20', hexCode: '#699FAB' },
  { factoryValueCode: 'RAL 220 60 25', hexCode: '#5BA1B0' },
  { factoryValueCode: 'RAL 220 60 30', hexCode: '#4AA4B5' },
  { factoryValueCode: 'RAL 220 60 35', hexCode: '#36A3B8' },
  { factoryValueCode: 'RAL 220 60 40', hexCode: '#00A5BD' },
  { factoryValueCode: 'RAL 220 70 05', hexCode: '#A6B2B5' },
  { factoryValueCode: 'RAL 220 70 10', hexCode: '#9DB5BB' },
  { factoryValueCode: 'RAL 220 70 15', hexCode: '#90B8C0' },
  { factoryValueCode: 'RAL 220 70 20', hexCode: '#84B9C4' },
  { factoryValueCode: 'RAL 220 70 25', hexCode: '#72BAC9' },
  { factoryValueCode: 'RAL 220 70 30', hexCode: '#61BACC' },
  { factoryValueCode: 'RAL 220 70 35', hexCode: '#4BBFD4' },
  { factoryValueCode: 'RAL 220 80 05', hexCode: '#BFCCCD' },
  { factoryValueCode: 'RAL 220 80 10', hexCode: '#B5D0D5' },
  { factoryValueCode: 'RAL 220 80 15', hexCode: '#A6CFD8' },
  { factoryValueCode: 'RAL 220 80 20', hexCode: '#9ED4E0' },
  { factoryValueCode: 'RAL 220 80 25', hexCode: '#92D7E3' },
  { factoryValueCode: 'RAL 220 85 05', hexCode: '#CCD9DC' },
  { factoryValueCode: 'RAL 220 85 10', hexCode: '#C0DCE1' },
  { factoryValueCode: 'RAL 220 85 15', hexCode: '#B3DEE6' },
  { factoryValueCode: 'RAL 220 90 05', hexCode: '#DAE7E6' },
  { factoryValueCode: 'RAL 220 90 10', hexCode: '#CDE7E7' },
  { factoryValueCode: 'RAL 230 20 10', hexCode: '#3F4B50' },
  { factoryValueCode: 'RAL 230 20 15', hexCode: '#384B53' },
  { factoryValueCode: 'RAL 230 20 20', hexCode: '#2D4955' },
  { factoryValueCode: 'RAL 230 30 10', hexCode: '#4D5B61' },
  { factoryValueCode: 'RAL 230 30 15', hexCode: '#435B65' },
  { factoryValueCode: 'RAL 230 30 20', hexCode: '#3A5D6A' },
  { factoryValueCode: 'RAL 230 30 25', hexCode: '#2D5E6F' },
  { factoryValueCode: 'RAL 230 40 10', hexCode: '#5B6D74' },
  { factoryValueCode: 'RAL 230 40 15', hexCode: '#536E79' },
  { factoryValueCode: 'RAL 230 40 20', hexCode: '#48717F' },
  { factoryValueCode: 'RAL 230 40 25', hexCode: '#387184' },
  { factoryValueCode: 'RAL 230 40 30', hexCode: '#2C738A' },
  { factoryValueCode: 'RAL 230 40 35', hexCode: '#007590' },
  { factoryValueCode: 'RAL 230 40 40', hexCode: '#007593' },
  { factoryValueCode: 'RAL 230 50 10', hexCode: '#6F838A' },
  { factoryValueCode: 'RAL 230 50 15', hexCode: '#658690' },
  { factoryValueCode: 'RAL 230 50 20', hexCode: '#5A8797' },
  { factoryValueCode: 'RAL 230 50 25', hexCode: '#4D889B' },
  { factoryValueCode: 'RAL 230 50 30', hexCode: '#378BA3' },
  { factoryValueCode: 'RAL 230 50 35', hexCode: '#1F8BA6' },
  { factoryValueCode: 'RAL 230 50 40', hexCode: '#008CAD' },
  { factoryValueCode: 'RAL 230 60 10', hexCode: '#869CA4' },
  { factoryValueCode: 'RAL 230 60 15', hexCode: '#7B9CA7' },
  { factoryValueCode: 'RAL 230 60 20', hexCode: '#6E9EAE' },
  { factoryValueCode: 'RAL 230 60 25', hexCode: '#5E9FB4' },
  { factoryValueCode: 'RAL 230 60 30', hexCode: '#4FA0B9' },
  { factoryValueCode: 'RAL 230 60 35', hexCode: '#37A3C1' },
  { factoryValueCode: 'RAL 230 60 40', hexCode: '#00A4C7' },
  { factoryValueCode: 'RAL 230 70 10', hexCode: '#A0B6BE' },
  { factoryValueCode: 'RAL 230 70 15', hexCode: '#91B6C2' },
  { factoryValueCode: 'RAL 230 70 20', hexCode: '#85B8C9' },
  { factoryValueCode: 'RAL 230 70 25', hexCode: '#7ABACF' },
  { factoryValueCode: 'RAL 230 70 30', hexCode: '#68BBD4' },
  { factoryValueCode: 'RAL 230 80 10', hexCode: '#B7CFD6' },
  { factoryValueCode: 'RAL 230 80 15', hexCode: '#ABCEDA' },
  { factoryValueCode: 'RAL 230 80 20', hexCode: '#A1D2E2' },
  { factoryValueCode: 'RAL 230 85 05', hexCode: '#CED9DD' },
  { factoryValueCode: 'RAL 230 85 10', hexCode: '#C1D9E1' },
  { factoryValueCode: 'RAL 230 85 15', hexCode: '#B8DCE7' },
  { factoryValueCode: 'RAL 230 85 20', hexCode: '#ABDEEE' },
  { factoryValueCode: 'RAL 230 90 05', hexCode: '#DBE6E6' },
  { factoryValueCode: 'RAL 240 20 05', hexCode: '#454A4D' },
  { factoryValueCode: 'RAL 240 20 10', hexCode: '#3F4A51' },
  { factoryValueCode: 'RAL 240 20 15', hexCode: '#394A55' },
  { factoryValueCode: 'RAL 240 20 20', hexCode: '#334B59' },
  { factoryValueCode: 'RAL 240 20 22', hexCode: '#294A5B' },
  { factoryValueCode: 'RAL 240 30 05', hexCode: '#52595C' },
  { factoryValueCode: 'RAL 240 30 10', hexCode: '#4C5A62' },
  { factoryValueCode: 'RAL 240 30 15', hexCode: '#455B67' },
  { factoryValueCode: 'RAL 240 30 20', hexCode: '#3C5C6C' },
  { factoryValueCode: 'RAL 240 30 25', hexCode: '#2F5C72' },
  { factoryValueCode: 'RAL 240 30 30', hexCode: '#215D77' },
  { factoryValueCode: 'RAL 240 30 35', hexCode: '#065F7C' },
  { factoryValueCode: 'RAL 240 40 05', hexCode: '#646B70' },
  { factoryValueCode: 'RAL 240 40 10', hexCode: '#5C6D76' },
  { factoryValueCode: 'RAL 240 40 15', hexCode: '#536E7D' },
  { factoryValueCode: 'RAL 240 40 20', hexCode: '#486F82' },
  { factoryValueCode: 'RAL 240 40 25', hexCode: '#3C708A' },
  { factoryValueCode: 'RAL 240 40 30', hexCode: '#28718F' },
  { factoryValueCode: 'RAL 240 40 35', hexCode: '#007295' },
  { factoryValueCode: 'RAL 240 40 40', hexCode: '#00749A' },
  { factoryValueCode: 'RAL 240 50 05', hexCode: '#798186' },
  { factoryValueCode: 'RAL 240 50 10', hexCode: '#6F828C' },
  { factoryValueCode: 'RAL 240 50 15', hexCode: '#668494' },
  { factoryValueCode: 'RAL 240 50 20', hexCode: '#5A859A' },
  { factoryValueCode: 'RAL 240 50 25', hexCode: '#4C86A0' },
  { factoryValueCode: 'RAL 240 50 30', hexCode: '#3C87A6' },
  { factoryValueCode: 'RAL 240 50 35', hexCode: '#1F88AD' },
  { factoryValueCode: 'RAL 240 50 40', hexCode: '#0088B2' },
  { factoryValueCode: 'RAL 240 60 05', hexCode: '#8F999E' },
  { factoryValueCode: 'RAL 240 60 10', hexCode: '#8297A2' },
  { factoryValueCode: 'RAL 240 60 15', hexCode: '#7A9AAA' },
  { factoryValueCode: 'RAL 240 60 20', hexCode: '#709DB3' },
  { factoryValueCode: 'RAL 240 60 25', hexCode: '#639EBA' },
  { factoryValueCode: 'RAL 240 60 30', hexCode: '#519FC0' },
  { factoryValueCode: 'RAL 240 60 35', hexCode: '#3CA0C8' },
  { factoryValueCode: 'RAL 240 60 40', hexCode: '#1BA3CB' },
  { factoryValueCode: 'RAL 240 70 05', hexCode: '#A7B1B7' },
  { factoryValueCode: 'RAL 240 70 10', hexCode: '#9EB2BD' },
  { factoryValueCode: 'RAL 240 70 15', hexCode: '#93B5C5' },
  { factoryValueCode: 'RAL 240 70 20', hexCode: '#88B5CB' },
  { factoryValueCode: 'RAL 240 70 25', hexCode: '#7BB8D3' },
  { factoryValueCode: 'RAL 240 70 30', hexCode: '#6BB8D8' },
  { factoryValueCode: 'RAL 240 80 05', hexCode: '#BFCACF' },
  { factoryValueCode: 'RAL 240 80 10', hexCode: '#B9CFD9' },
  { factoryValueCode: 'RAL 240 80 15', hexCode: '#AECFDE' },
  { factoryValueCode: 'RAL 240 80 20', hexCode: '#A1D1E6' },
  { factoryValueCode: 'RAL 240 85 05', hexCode: '#CDD7DD' },
  { factoryValueCode: 'RAL 240 85 10', hexCode: '#C2D8E3' },
  { factoryValueCode: 'RAL 240 85 15', hexCode: '#B7DBEB' },
  { factoryValueCode: 'RAL 240 90 05', hexCode: '#DCE7E9' },
  { factoryValueCode: 'RAL 240 90 10', hexCode: '#CFE8EF' },
  { factoryValueCode: 'RAL 250 20 20', hexCode: '#334A5B' },
  { factoryValueCode: 'RAL 250 20 25', hexCode: '#2F4A5F' },
  { factoryValueCode: 'RAL 250 30 15', hexCode: '#455968' },
  { factoryValueCode: 'RAL 250 30 20', hexCode: '#3B5A6E' },
  { factoryValueCode: 'RAL 250 30 25', hexCode: '#335B74' },
  { factoryValueCode: 'RAL 250 30 30', hexCode: '#235B7B' },
  { factoryValueCode: 'RAL 250 40 10', hexCode: '#5E6C77' },
  { factoryValueCode: 'RAL 250 40 15', hexCode: '#556C7D' },
  { factoryValueCode: 'RAL 250 40 20', hexCode: '#4A6C83' },
  { factoryValueCode: 'RAL 250 40 25', hexCode: '#3F6E8B' },
  { factoryValueCode: 'RAL 250 40 30', hexCode: '#336F93' },
  { factoryValueCode: 'RAL 250 40 35', hexCode: '#1A6F97' },
  { factoryValueCode: 'RAL 250 40 40', hexCode: '#00719C' },
  { factoryValueCode: 'RAL 250 50 10', hexCode: '#72818D' },
  { factoryValueCode: 'RAL 250 50 15', hexCode: '#688194' },
  { factoryValueCode: 'RAL 250 50 20', hexCode: '#60839B' },
  { factoryValueCode: 'RAL 250 50 25', hexCode: '#5583A3' },
  { factoryValueCode: 'RAL 250 50 30', hexCode: '#4684AB' },
  { factoryValueCode: 'RAL 250 50 35', hexCode: '#3386B2' },
  { factoryValueCode: 'RAL 250 50 40', hexCode: '#0487B9' },
  { factoryValueCode: 'RAL 250 60 10', hexCode: '#8798A5' },
  { factoryValueCode: 'RAL 250 60 15', hexCode: '#7F99AD' },
  { factoryValueCode: 'RAL 250 60 20', hexCode: '#749AB4' },
  { factoryValueCode: 'RAL 250 60 25', hexCode: '#699BBC' },
  { factoryValueCode: 'RAL 250 60 30', hexCode: '#5C9DC3' },
  { factoryValueCode: 'RAL 250 60 35', hexCode: '#4D9DCA' },
  { factoryValueCode: 'RAL 250 60 40', hexCode: '#3A9FD3' },
  { factoryValueCode: 'RAL 250 70 10', hexCode: '#9FB2BE' },
  { factoryValueCode: 'RAL 250 70 15', hexCode: '#97B3C7' },
  { factoryValueCode: 'RAL 250 70 20', hexCode: '#8CB3CE' },
  { factoryValueCode: 'RAL 250 70 25', hexCode: '#82B5D5' },
  { factoryValueCode: 'RAL 250 70 30', hexCode: '#75B5DC' },
  { factoryValueCode: 'RAL 250 80 10', hexCode: '#B9CBD8' },
  { factoryValueCode: 'RAL 250 80 15', hexCode: '#B2CEE0' },
  { factoryValueCode: 'RAL 250 80 20', hexCode: '#A4CBE5' },
  { factoryValueCode: 'RAL 250 85 05', hexCode: '#CCD4DA' },
  { factoryValueCode: 'RAL 250 85 10', hexCode: '#C2D5E2' },
  { factoryValueCode: 'RAL 250 85 15', hexCode: '#BCD8EA' },
  { factoryValueCode: 'RAL 250 90 05', hexCode: '#DBE3E7' },
  { factoryValueCode: 'RAL 260 20 05', hexCode: '#474A4E' },
  { factoryValueCode: 'RAL 260 20 10', hexCode: '#424952' },
  { factoryValueCode: 'RAL 260 20 15', hexCode: '#3B4856' },
  { factoryValueCode: 'RAL 260 20 20', hexCode: '#384A5C' },
  { factoryValueCode: 'RAL 260 30 05', hexCode: '#54595E' },
  { factoryValueCode: 'RAL 260 30 10', hexCode: '#505A65' },
  { factoryValueCode: 'RAL 260 30 15', hexCode: '#4A596A' },
  { factoryValueCode: 'RAL 260 30 20', hexCode: '#445A70' },
  { factoryValueCode: 'RAL 260 30 25', hexCode: '#3A5A75' },
  { factoryValueCode: 'RAL 260 30 30', hexCode: '#345B7D' },
  { factoryValueCode: 'RAL 260 30 35', hexCode: '#1E5B85' },
  { factoryValueCode: 'RAL 260 40 05', hexCode: '#666A70' },
  { factoryValueCode: 'RAL 260 40 10', hexCode: '#626D79' },
  { factoryValueCode: 'RAL 260 40 15', hexCode: '#5C6D80' },
  { factoryValueCode: 'RAL 260 40 20', hexCode: '#526C85' },
  { factoryValueCode: 'RAL 260 40 25', hexCode: '#4B6E8C' },
  { factoryValueCode: 'RAL 260 40 30', hexCode: '#426E92' },
  { factoryValueCode: 'RAL 260 40 35', hexCode: '#356E99' },
  { factoryValueCode: 'RAL 260 40 40', hexCode: '#1E70A3' },
  { factoryValueCode: 'RAL 260 40 45', hexCode: '#0070A9' },
  { factoryValueCode: 'RAL 260 50 05', hexCode: '#797E85' },
  { factoryValueCode: 'RAL 260 50 10', hexCode: '#75808D' },
  { factoryValueCode: 'RAL 260 50 15', hexCode: '#6E8194' },
  { factoryValueCode: 'RAL 260 50 20', hexCode: '#6A849D' },
  { factoryValueCode: 'RAL 260 50 25', hexCode: '#6084A6' },
  { factoryValueCode: 'RAL 260 50 30', hexCode: '#5485AF' },
  { factoryValueCode: 'RAL 260 50 35', hexCode: '#4784B3' },
  { factoryValueCode: 'RAL 260 50 40', hexCode: '#3586BD' },
  { factoryValueCode: 'RAL 260 60 05', hexCode: '#91979E' },
  { factoryValueCode: 'RAL 260 60 10', hexCode: '#8B97A5' },
  { factoryValueCode: 'RAL 260 60 15', hexCode: '#879BB0' },
  { factoryValueCode: 'RAL 260 60 20', hexCode: '#7E9AB5' },
  { factoryValueCode: 'RAL 260 60 25', hexCode: '#759BBE' },
  { factoryValueCode: 'RAL 260 60 30', hexCode: '#6B9CC6' },
  { factoryValueCode: 'RAL 260 60 35', hexCode: '#5F9DCD' },
  { factoryValueCode: 'RAL 260 70 05', hexCode: '#ABB1B8' },
  { factoryValueCode: 'RAL 260 70 10', hexCode: '#A5B2C0' },
  { factoryValueCode: 'RAL 260 70 15', hexCode: '#9CB2C8' },
  { factoryValueCode: 'RAL 260 70 20', hexCode: '#96B4D0' },
  { factoryValueCode: 'RAL 260 70 25', hexCode: '#8CB4D8' },
  { factoryValueCode: 'RAL 260 80 05', hexCode: '#C3CAD1' },
  { factoryValueCode: 'RAL 260 80 10', hexCode: '#BDCBD9' },
  { factoryValueCode: 'RAL 260 80 15', hexCode: '#B5CCE0' },
  { factoryValueCode: 'RAL 260 85 05', hexCode: '#CDD3D9' },
  { factoryValueCode: 'RAL 260 85 10', hexCode: '#C8D7E5' },
  { factoryValueCode: 'RAL 260 90 05', hexCode: '#DDE3E7' },
  { factoryValueCode: 'RAL 270 20 20', hexCode: '#3A475C' },
  { factoryValueCode: 'RAL 270 20 25', hexCode: '#344660' },
  { factoryValueCode: 'RAL 270 20 29', hexCode: '#2E4667' },
  { factoryValueCode: 'RAL 270 30 15', hexCode: '#4C5768' },
  { factoryValueCode: 'RAL 270 30 20', hexCode: '#47576F' },
  { factoryValueCode: 'RAL 270 30 25', hexCode: '#415776' },
  { factoryValueCode: 'RAL 270 30 30', hexCode: '#39567C' },
  { factoryValueCode: 'RAL 270 30 35', hexCode: '#2F5682' },
  { factoryValueCode: 'RAL 270 30 40', hexCode: '#1F568A' },
  { factoryValueCode: 'RAL 270 40 15', hexCode: '#5F6B7F' },
  { factoryValueCode: 'RAL 270 40 20', hexCode: '#576A85' },
  { factoryValueCode: 'RAL 270 40 25', hexCode: '#536B8D' },
  { factoryValueCode: 'RAL 270 40 30', hexCode: '#4A6A94' },
  { factoryValueCode: 'RAL 270 40 35', hexCode: '#406A9B' },
  { factoryValueCode: 'RAL 270 40 40', hexCode: '#3469A2' },
  { factoryValueCode: 'RAL 270 50 10', hexCode: '#77808F' },
  { factoryValueCode: 'RAL 270 50 15', hexCode: '#738197' },
  { factoryValueCode: 'RAL 270 50 20', hexCode: '#6D819E' },
  { factoryValueCode: 'RAL 270 50 25', hexCode: '#6780A6' },
  { factoryValueCode: 'RAL 270 50 30', hexCode: '#5E80AD' },
  { factoryValueCode: 'RAL 270 50 35', hexCode: '#557FB2' },
  { factoryValueCode: 'RAL 270 50 40', hexCode: '#4A81BD' },
  { factoryValueCode: 'RAL 270 60 10', hexCode: '#8C97A7' },
  { factoryValueCode: 'RAL 270 60 15', hexCode: '#8998B0' },
  { factoryValueCode: 'RAL 270 60 20', hexCode: '#8398B7' },
  { factoryValueCode: 'RAL 270 60 25', hexCode: '#7D98BF' },
  { factoryValueCode: 'RAL 270 60 30', hexCode: '#7699C8' },
  { factoryValueCode: 'RAL 270 60 35', hexCode: '#6B97CE' },
  { factoryValueCode: 'RAL 270 70 10', hexCode: '#A7B1C1' },
  { factoryValueCode: 'RAL 270 70 15', hexCode: '#A1B1C9' },
  { factoryValueCode: 'RAL 270 70 20', hexCode: '#9CB2D2' },
  { factoryValueCode: 'RAL 270 70 25', hexCode: '#93AFD8' },
  { factoryValueCode: 'RAL 270 80 10', hexCode: '#C1CAD9' },
  { factoryValueCode: 'RAL 270 80 15', hexCode: '#B9C9E1' },
  { factoryValueCode: 'RAL 270 85 05', hexCode: '#D1D4DA' },
  { factoryValueCode: 'RAL 270 85 10', hexCode: '#CAD4E4' },
  { factoryValueCode: 'RAL 270 85 15', hexCode: '#C4D4EC' },
  { factoryValueCode: 'RAL 270 90 05', hexCode: '#E0E3E8' },
  { factoryValueCode: 'RAL 280 20 05', hexCode: '#4A4A4E' },
  { factoryValueCode: 'RAL 280 20 10', hexCode: '#474A53' },
  { factoryValueCode: 'RAL 280 20 15', hexCode: '#444958' },
  { factoryValueCode: 'RAL 280 20 20', hexCode: '#41485B' },
  { factoryValueCode: 'RAL 280 20 25', hexCode: '#3F4862' },
  { factoryValueCode: 'RAL 280 20 30', hexCode: '#3A4868' },
  { factoryValueCode: 'RAL 280 30 05', hexCode: '#57585D' },
  { factoryValueCode: 'RAL 280 30 10', hexCode: '#555965' },
  { factoryValueCode: 'RAL 280 30 15', hexCode: '#52596B' },
  { factoryValueCode: 'RAL 280 30 20', hexCode: '#4F5972' },
  { factoryValueCode: 'RAL 280 30 25', hexCode: '#4C5977' },
  { factoryValueCode: 'RAL 280 30 30', hexCode: '#45577E' },
  { factoryValueCode: 'RAL 280 30 35', hexCode: '#425783' },
  { factoryValueCode: 'RAL 280 30 40', hexCode: '#3D588A' },
  { factoryValueCode: 'RAL 280 40 05', hexCode: '#696B71' },
  { factoryValueCode: 'RAL 280 40 10', hexCode: '#666A78' },
  { factoryValueCode: 'RAL 280 40 15', hexCode: '#636A7F' },
  { factoryValueCode: 'RAL 280 40 20', hexCode: '#5F6A86' },
  { factoryValueCode: 'RAL 280 40 25', hexCode: '#5D6B8E' },
  { factoryValueCode: 'RAL 280 40 30', hexCode: '#586A94' },
  { factoryValueCode: 'RAL 280 40 35', hexCode: '#526B9B' },
  { factoryValueCode: 'RAL 280 40 40', hexCode: '#4A6AA3' },
  { factoryValueCode: 'RAL 280 40 45', hexCode: '#4169AA' },
  { factoryValueCode: 'RAL 280 50 05', hexCode: '#7D8087' },
  { factoryValueCode: 'RAL 280 50 10', hexCode: '#7B808F' },
  { factoryValueCode: 'RAL 280 50 15', hexCode: '#788096' },
  { factoryValueCode: 'RAL 280 50 20', hexCode: '#747F9E' },
  { factoryValueCode: 'RAL 280 50 25', hexCode: '#717FA5' },
  { factoryValueCode: 'RAL 280 50 30', hexCode: '#6C7FAD' },
  { factoryValueCode: 'RAL 280 50 35', hexCode: '#667EB3' },
  { factoryValueCode: 'RAL 280 50 40', hexCode: '#6180BE' },
  { factoryValueCode: 'RAL 280 60 05', hexCode: '#94979E' },
  { factoryValueCode: 'RAL 280 60 10', hexCode: '#9196A6' },
  { factoryValueCode: 'RAL 280 60 15', hexCode: '#8E96AE' },
  { factoryValueCode: 'RAL 280 60 20', hexCode: '#8B96B7' },
  { factoryValueCode: 'RAL 280 60 25', hexCode: '#8695BE' },
  { factoryValueCode: 'RAL 280 60 30', hexCode: '#8296C5' },
  { factoryValueCode: 'RAL 280 60 35', hexCode: '#7E97CF' },
  { factoryValueCode: 'RAL 280 70 05', hexCode: '#ACAEB6' },
  { factoryValueCode: 'RAL 280 70 10', hexCode: '#ABB0BF' },
  { factoryValueCode: 'RAL 280 70 15', hexCode: '#A8B0C8' },
  { factoryValueCode: 'RAL 280 70 20', hexCode: '#A3AFD1' },
  { factoryValueCode: 'RAL 280 70 25', hexCode: '#A1B0DA' },
  { factoryValueCode: 'RAL 280 80 05', hexCode: '#C8CAD1' },
  { factoryValueCode: 'RAL 280 80 10', hexCode: '#C4C9D9' },
  { factoryValueCode: 'RAL 280 80 15', hexCode: '#BFC8E0' },
  { factoryValueCode: 'RAL 280 85 05', hexCode: '#D2D5DB' },
  { factoryValueCode: 'RAL 280 85 10', hexCode: '#CDD4E4' },
  { factoryValueCode: 'RAL 280 90 05', hexCode: '#E0E3E8' },
  { factoryValueCode: 'RAL 280 93 05', hexCode: '#E8EAF0' },
  { factoryValueCode: 'RAL 290 20 10', hexCode: '#454650' },
  { factoryValueCode: 'RAL 290 20 15', hexCode: '#474655' },
  { factoryValueCode: 'RAL 290 20 20', hexCode: '#47485D' },
  { factoryValueCode: 'RAL 290 20 25', hexCode: '#434661' },
  { factoryValueCode: 'RAL 290 20 30', hexCode: '#404465' },
  { factoryValueCode: 'RAL 290 20 35', hexCode: '#3E446C' },
  { factoryValueCode: 'RAL 290 30 10', hexCode: '#565562' },
  { factoryValueCode: 'RAL 290 30 15', hexCode: '#555669' },
  { factoryValueCode: 'RAL 290 30 20', hexCode: '#52536D' },
  { factoryValueCode: 'RAL 290 30 25', hexCode: '#525475' },
  { factoryValueCode: 'RAL 290 30 30', hexCode: '#4F537B' },
  { factoryValueCode: 'RAL 290 30 35', hexCode: '#4D5483' },
  { factoryValueCode: 'RAL 290 30 40', hexCode: '#495389' },
  { factoryValueCode: 'RAL 290 40 10', hexCode: '#696876' },
  { factoryValueCode: 'RAL 290 40 15', hexCode: '#68687D' },
  { factoryValueCode: 'RAL 290 40 20', hexCode: '#656785' },
  { factoryValueCode: 'RAL 290 40 25', hexCode: '#63658B' },
  { factoryValueCode: 'RAL 290 40 30', hexCode: '#606592' },
  { factoryValueCode: 'RAL 290 40 35', hexCode: '#5E6498' },
  { factoryValueCode: 'RAL 290 40 40', hexCode: '#5B65A1' },
  { factoryValueCode: 'RAL 290 40 45', hexCode: '#5664A7' },
  { factoryValueCode: 'RAL 290 50 10', hexCode: '#7C7C8C' },
  { factoryValueCode: 'RAL 290 50 15', hexCode: '#7B7C92' },
  { factoryValueCode: 'RAL 290 50 20', hexCode: '#797A9B' },
  { factoryValueCode: 'RAL 290 50 25', hexCode: '#797BA4' },
  { factoryValueCode: 'RAL 290 50 30', hexCode: '#777AAA' },
  { factoryValueCode: 'RAL 290 50 35', hexCode: '#7379B2' },
  { factoryValueCode: 'RAL 290 50 40', hexCode: '#7079BA' },
  { factoryValueCode: 'RAL 290 60 10', hexCode: '#9293A5' },
  { factoryValueCode: 'RAL 290 60 15', hexCode: '#9393AC' },
  { factoryValueCode: 'RAL 290 60 20', hexCode: '#8F91B5' },
  { factoryValueCode: 'RAL 290 60 25', hexCode: '#9092BD' },
  { factoryValueCode: 'RAL 290 60 30', hexCode: '#8D91C4' },
  { factoryValueCode: 'RAL 290 60 35', hexCode: '#888FCA' },
  { factoryValueCode: 'RAL 290 70 10', hexCode: '#ADADBF' },
  { factoryValueCode: 'RAL 290 70 15', hexCode: '#ABABC7' },
  { factoryValueCode: 'RAL 290 70 20', hexCode: '#A8ABCE' },
  { factoryValueCode: 'RAL 290 70 25', hexCode: '#A7AAD7' },
  { factoryValueCode: 'RAL 290 80 10', hexCode: '#C6C6D7' },
  { factoryValueCode: 'RAL 290 80 15', hexCode: '#C6C6DE' },
  { factoryValueCode: 'RAL 290 85 05', hexCode: '#D5D5DA' },
  { factoryValueCode: 'RAL 290 85 10', hexCode: '#D0D3E9' },
  { factoryValueCode: 'RAL 290 90 05', hexCode: '#DADBE0' },
  { factoryValueCode: 'RAL 290 93 05', hexCode: '#E8E9EF' },
  { factoryValueCode: 'RAL 300 20 05', hexCode: '#4B494E' },
  { factoryValueCode: 'RAL 300 20 10', hexCode: '#494650' },
  { factoryValueCode: 'RAL 300 20 15', hexCode: '#494655' },
  { factoryValueCode: 'RAL 300 20 20', hexCode: '#49455A' },
  { factoryValueCode: 'RAL 300 20 25', hexCode: '#49445C' },
  { factoryValueCode: 'RAL 300 20 30', hexCode: '#474364' },
  { factoryValueCode: 'RAL 300 30 05', hexCode: '#59575D' },
  { factoryValueCode: 'RAL 300 30 10', hexCode: '#585562' },
  { factoryValueCode: 'RAL 300 30 15', hexCode: '#595466' },
  { factoryValueCode: 'RAL 300 30 20', hexCode: '#59536C' },
  { factoryValueCode: 'RAL 300 30 25', hexCode: '#595272' },
  { factoryValueCode: 'RAL 300 30 30', hexCode: '#595278' },
  { factoryValueCode: 'RAL 300 30 35', hexCode: '#57517E' },
  { factoryValueCode: 'RAL 300 30 40', hexCode: '#565084' },
  { factoryValueCode: 'RAL 300 40 05', hexCode: '#6C6A70' },
  { factoryValueCode: 'RAL 300 40 10', hexCode: '#6B6775' },
  { factoryValueCode: 'RAL 300 40 15', hexCode: '#6B657B' },
  { factoryValueCode: 'RAL 300 40 20', hexCode: '#6C6581' },
  { factoryValueCode: 'RAL 300 40 25', hexCode: '#6C6488' },
  { factoryValueCode: 'RAL 300 40 30', hexCode: '#6C638E' },
  { factoryValueCode: 'RAL 300 40 35', hexCode: '#6B6293' },
  { factoryValueCode: 'RAL 300 40 40', hexCode: '#696099' },
  { factoryValueCode: 'RAL 300 40 45', hexCode: '#6860A1' },
  { factoryValueCode: 'RAL 300 50 05', hexCode: '#807E85' },
  { factoryValueCode: 'RAL 300 50 10', hexCode: '#817C8B' },
  { factoryValueCode: 'RAL 300 50 15', hexCode: '#817B92' },
  { factoryValueCode: 'RAL 300 50 20', hexCode: '#817999' },
  { factoryValueCode: 'RAL 300 50 25', hexCode: '#8178A0' },
  { factoryValueCode: 'RAL 300 50 30', hexCode: '#8177A7' },
  { factoryValueCode: 'RAL 300 50 35', hexCode: '#8277AE' },
  { factoryValueCode: 'RAL 300 50 40', hexCode: '#8075B4' },
  { factoryValueCode: 'RAL 300 60 05', hexCode: '#98969E' },
  { factoryValueCode: 'RAL 300 60 10', hexCode: '#9893A3' },
  { factoryValueCode: 'RAL 300 60 15', hexCode: '#9992AB' },
  { factoryValueCode: 'RAL 300 60 20', hexCode: '#9990B1' },
  { factoryValueCode: 'RAL 300 60 25', hexCode: '#988EB8' },
  { factoryValueCode: 'RAL 300 60 30', hexCode: '#988DC0' },
  { factoryValueCode: 'RAL 300 60 35', hexCode: '#978BC6' },
  { factoryValueCode: 'RAL 300 70 05', hexCode: '#B0AEB7' },
  { factoryValueCode: 'RAL 300 70 10', hexCode: '#B1ABBC' },
  { factoryValueCode: 'RAL 300 70 15', hexCode: '#B1AAC4' },
  { factoryValueCode: 'RAL 300 70 20', hexCode: '#B2A9CB' },
  { factoryValueCode: 'RAL 300 70 25', hexCode: '#B2A7D2' },
  { factoryValueCode: 'RAL 300 80 05', hexCode: '#CAC8D0' },
  { factoryValueCode: 'RAL 300 80 10', hexCode: '#C9C5D8' },
  { factoryValueCode: 'RAL 300 80 15', hexCode: '#CBC4DE' },
  { factoryValueCode: 'RAL 300 85 05', hexCode: '#D5D4DA' },
  { factoryValueCode: 'RAL 300 85 10', hexCode: '#D8D1E4' },
  { factoryValueCode: 'RAL 300 90 05', hexCode: '#E4E2E8' },
  { factoryValueCode: 'RAL 310 20 20', hexCode: '#4F4658' },
  { factoryValueCode: 'RAL 310 20 25', hexCode: '#51445D' },
  { factoryValueCode: 'RAL 310 20 30', hexCode: '#4F4261' },
  { factoryValueCode: 'RAL 310 30 15', hexCode: '#5F5667' },
  { factoryValueCode: 'RAL 310 30 20', hexCode: '#5E536B' },
  { factoryValueCode: 'RAL 310 30 25', hexCode: '#615270' },
  { factoryValueCode: 'RAL 310 30 30', hexCode: '#635176' },
  { factoryValueCode: 'RAL 310 30 35', hexCode: '#625078' },
  { factoryValueCode: 'RAL 310 30 40', hexCode: '#654F7F' },
  { factoryValueCode: 'RAL 310 40 10', hexCode: '#706976' },
  { factoryValueCode: 'RAL 310 40 15', hexCode: '#73687C' },
  { factoryValueCode: 'RAL 310 40 20', hexCode: '#756781' },
  { factoryValueCode: 'RAL 310 40 25', hexCode: '#766587' },
  { factoryValueCode: 'RAL 310 40 30', hexCode: '#76628A' },
  { factoryValueCode: 'RAL 310 40 35', hexCode: '#776190' },
  { factoryValueCode: 'RAL 310 40 40', hexCode: '#7A6196' },
  { factoryValueCode: 'RAL 310 50 10', hexCode: '#857D8C' },
  { factoryValueCode: 'RAL 310 50 15', hexCode: '#867C92' },
  { factoryValueCode: 'RAL 310 50 20', hexCode: '#8A7B97' },
  { factoryValueCode: 'RAL 310 50 25', hexCode: '#8C799E' },
  { factoryValueCode: 'RAL 310 50 30', hexCode: '#8D77A4' },
  { factoryValueCode: 'RAL 310 50 35', hexCode: '#8D75A8' },
  { factoryValueCode: 'RAL 310 50 40', hexCode: '#8F74AE' },
  { factoryValueCode: 'RAL 310 60 10', hexCode: '#9B93A3' },
  { factoryValueCode: 'RAL 310 60 15', hexCode: '#9F92AA' },
  { factoryValueCode: 'RAL 310 60 20', hexCode: '#A291B0' },
  { factoryValueCode: 'RAL 310 60 25', hexCode: '#A48FB5' },
  { factoryValueCode: 'RAL 310 60 30', hexCode: '#A58DBA' },
  { factoryValueCode: 'RAL 310 60 35', hexCode: '#A78AC3' },
  { factoryValueCode: 'RAL 310 70 10', hexCode: '#B5ACBB' },
  { factoryValueCode: 'RAL 310 70 15', hexCode: '#B8AAC2' },
  { factoryValueCode: 'RAL 310 70 20', hexCode: '#B9A8C7' },
  { factoryValueCode: 'RAL 310 70 25', hexCode: '#BBA7CE' },
  { factoryValueCode: 'RAL 310 80 10', hexCode: '#CDC5D5' },
  { factoryValueCode: 'RAL 310 80 15', hexCode: '#D1C4DB' },
  { factoryValueCode: 'RAL 310 85 05', hexCode: '#D6D3DA' },
  { factoryValueCode: 'RAL 310 85 10', hexCode: '#DBD1E2' },
  { factoryValueCode: 'RAL 310 90 05', hexCode: '#E8E3E7' },
  { factoryValueCode: 'RAL 320 20 05', hexCode: '#4D494E' },
  { factoryValueCode: 'RAL 320 20 10', hexCode: '#4E464F' },
  { factoryValueCode: 'RAL 320 20 15', hexCode: '#4F4451' },
  { factoryValueCode: 'RAL 320 20 20', hexCode: '#534455' },
  { factoryValueCode: 'RAL 320 20 25', hexCode: '#534259' },
  { factoryValueCode: 'RAL 320 30 05', hexCode: '#5B565B' },
  { factoryValueCode: 'RAL 320 30 10', hexCode: '#5D545E' },
  { factoryValueCode: 'RAL 320 30 15', hexCode: '#605161' },
  { factoryValueCode: 'RAL 320 30 20', hexCode: '#634F66' },
  { factoryValueCode: 'RAL 320 30 25', hexCode: '#664E6A' },
  { factoryValueCode: 'RAL 320 30 30', hexCode: '#674C6E' },
  { factoryValueCode: 'RAL 320 30 35', hexCode: '#694B73' },
  { factoryValueCode: 'RAL 320 30 37', hexCode: '#6C4B77' },
  { factoryValueCode: 'RAL 320 40 05', hexCode: '#6E696F' },
  { factoryValueCode: 'RAL 320 40 10', hexCode: '#716672' },
  { factoryValueCode: 'RAL 320 40 15', hexCode: '#746477' },
  { factoryValueCode: 'RAL 320 40 20', hexCode: '#77627B' },
  { factoryValueCode: 'RAL 320 40 25', hexCode: '#796080' },
  { factoryValueCode: 'RAL 320 40 30', hexCode: '#7D5D83' },
  { factoryValueCode: 'RAL 320 40 35', hexCode: '#7F5A87' },
  { factoryValueCode: 'RAL 320 40 40', hexCode: '#82598E' },
  { factoryValueCode: 'RAL 320 50 05', hexCode: '#827C83' },
  { factoryValueCode: 'RAL 320 50 10', hexCode: '#867987' },
  { factoryValueCode: 'RAL 320 50 15', hexCode: '#89778C' },
  { factoryValueCode: 'RAL 320 50 20', hexCode: '#8E7793' },
  { factoryValueCode: 'RAL 320 50 25', hexCode: '#907397' },
  { factoryValueCode: 'RAL 320 50 30', hexCode: '#94729D' },
  { factoryValueCode: 'RAL 320 50 35', hexCode: '#966D9F' },
  { factoryValueCode: 'RAL 320 50 40', hexCode: '#996FA7' },
  { factoryValueCode: 'RAL 320 60 05', hexCode: '#9A949C' },
  { factoryValueCode: 'RAL 320 60 10', hexCode: '#9E929F' },
  { factoryValueCode: 'RAL 320 60 15', hexCode: '#A28FA5' },
  { factoryValueCode: 'RAL 320 60 20', hexCode: '#A58BA9' },
  { factoryValueCode: 'RAL 320 60 25', hexCode: '#A889AF' },
  { factoryValueCode: 'RAL 320 60 30', hexCode: '#AC87B5' },
  { factoryValueCode: 'RAL 320 60 35', hexCode: '#AE85B9' },
  { factoryValueCode: 'RAL 320 70 05', hexCode: '#B2ACB3' },
  { factoryValueCode: 'RAL 320 70 10', hexCode: '#B6A9B9' },
  { factoryValueCode: 'RAL 320 70 15', hexCode: '#B9A6BE' },
  { factoryValueCode: 'RAL 320 70 20', hexCode: '#C0A5C6' },
  { factoryValueCode: 'RAL 320 70 25', hexCode: '#C3A2CA' },
  { factoryValueCode: 'RAL 320 80 05', hexCode: '#CDC7CD' },
  { factoryValueCode: 'RAL 320 80 10', hexCode: '#D1C4D3' },
  { factoryValueCode: 'RAL 320 80 15', hexCode: '#D4C0D6' },
  { factoryValueCode: 'RAL 320 85 05', hexCode: '#D8D1D9' },
  { factoryValueCode: 'RAL 320 85 10', hexCode: '#DDCFDF' },
  { factoryValueCode: 'RAL 320 90 05', hexCode: '#E8E1E6' },
  { factoryValueCode: 'RAL 330 20 20', hexCode: '#554251' },
  { factoryValueCode: 'RAL 330 20 25', hexCode: '#5A4256' },
  { factoryValueCode: 'RAL 330 30 15', hexCode: '#645361' },
  { factoryValueCode: 'RAL 330 30 20', hexCode: '#685164' },
  { factoryValueCode: 'RAL 330 30 25', hexCode: '#6B4E66' },
  { factoryValueCode: 'RAL 330 30 30', hexCode: '#704C6A' },
  { factoryValueCode: 'RAL 330 30 35', hexCode: '#734B6E' },
  { factoryValueCode: 'RAL 330 30 40', hexCode: '#75476F' },
  { factoryValueCode: 'RAL 330 40 10', hexCode: '#746772' },
  { factoryValueCode: 'RAL 330 40 15', hexCode: '#786576' },
  { factoryValueCode: 'RAL 330 40 20', hexCode: '#7D647A' },
  { factoryValueCode: 'RAL 330 40 25', hexCode: '#81627D' },
  { factoryValueCode: 'RAL 330 40 30', hexCode: '#885F81' },
  { factoryValueCode: 'RAL 330 40 35', hexCode: '#8B5D84' },
  { factoryValueCode: 'RAL 330 40 40', hexCode: '#8C5885' },
  { factoryValueCode: 'RAL 330 40 45', hexCode: '#8F5788' },
  { factoryValueCode: 'RAL 330 50 10', hexCode: '#897A86' },
  { factoryValueCode: 'RAL 330 50 15', hexCode: '#8F7A8C' },
  { factoryValueCode: 'RAL 330 50 20', hexCode: '#947790' },
  { factoryValueCode: 'RAL 330 50 25', hexCode: '#987593' },
  { factoryValueCode: 'RAL 330 50 30', hexCode: '#9D7399' },
  { factoryValueCode: 'RAL 330 50 35', hexCode: '#A0709C' },
  { factoryValueCode: 'RAL 330 50 40', hexCode: '#A56D9E' },
  { factoryValueCode: 'RAL 330 60 10', hexCode: '#A1929F' },
  { factoryValueCode: 'RAL 330 60 15', hexCode: '#A791A4' },
  { factoryValueCode: 'RAL 330 60 20', hexCode: '#AD8EA8' },
  { factoryValueCode: 'RAL 330 60 25', hexCode: '#AF8AA9' },
  { factoryValueCode: 'RAL 330 60 30', hexCode: '#B588AF' },
  { factoryValueCode: 'RAL 330 60 35', hexCode: '#BB85B3' },
  { factoryValueCode: 'RAL 330 60 40', hexCode: '#BE82B7' },
  { factoryValueCode: 'RAL 330 70 10', hexCode: '#BCABB9' },
  { factoryValueCode: 'RAL 330 70 15', hexCode: '#BFA7BB' },
  { factoryValueCode: 'RAL 330 70 20', hexCode: '#C5A6C0' },
  { factoryValueCode: 'RAL 330 70 25', hexCode: '#CCA3C5' },
  { factoryValueCode: 'RAL 330 70 30', hexCode: '#D0A1C7' },
  { factoryValueCode: 'RAL 330 80 10', hexCode: '#D5C4D1' },
  { factoryValueCode: 'RAL 330 80 15', hexCode: '#DAC1D5' },
  { factoryValueCode: 'RAL 330 80 20', hexCode: '#E2BFD9' },
  { factoryValueCode: 'RAL 330 85 05', hexCode: '#D9D3D9' },
  { factoryValueCode: 'RAL 330 85 10', hexCode: '#E2D1DE' },
  { factoryValueCode: 'RAL 330 85 15', hexCode: '#E8CEE1' },
  { factoryValueCode: 'RAL 330 90 05', hexCode: '#EBE2E5' },
  { factoryValueCode: 'RAL 340 20 05', hexCode: '#4D474B' },
  { factoryValueCode: 'RAL 340 20 10', hexCode: '#50444A' },
  { factoryValueCode: 'RAL 340 20 15', hexCode: '#53414B' },
  { factoryValueCode: 'RAL 340 20 20', hexCode: '#58414E' },
  { factoryValueCode: 'RAL 340 20 25', hexCode: '#5F4252' },
  { factoryValueCode: 'RAL 340 30 05', hexCode: '#5C5559' },
  { factoryValueCode: 'RAL 340 30 10', hexCode: '#61525A' },
  { factoryValueCode: 'RAL 340 30 15', hexCode: '#66505C' },
  { factoryValueCode: 'RAL 340 30 20', hexCode: '#6A4E5E' },
  { factoryValueCode: 'RAL 340 30 25', hexCode: '#6F4C62' },
  { factoryValueCode: 'RAL 340 30 30', hexCode: '#714963' },
  { factoryValueCode: 'RAL 340 30 35', hexCode: '#754664' },
  { factoryValueCode: 'RAL 340 30 38', hexCode: '#7A4366' },
  { factoryValueCode: 'RAL 340 40 05', hexCode: '#6F676B' },
  { factoryValueCode: 'RAL 340 40 10', hexCode: '#76646D' },
  { factoryValueCode: 'RAL 340 40 15', hexCode: '#7B6270' },
  { factoryValueCode: 'RAL 340 40 20', hexCode: '#805F72' },
  { factoryValueCode: 'RAL 340 40 25', hexCode: '#855D76' },
  { factoryValueCode: 'RAL 340 40 30', hexCode: '#895A78' },
  { factoryValueCode: 'RAL 340 40 35', hexCode: '#8B557A' },
  { factoryValueCode: 'RAL 340 40 40', hexCode: '#90527B' },
  { factoryValueCode: 'RAL 340 40 45', hexCode: '#994F80' },
  { factoryValueCode: 'RAL 340 50 05', hexCode: '#857C81' },
  { factoryValueCode: 'RAL 340 50 10', hexCode: '#8C7984' },
  { factoryValueCode: 'RAL 340 50 15', hexCode: '#927686' },
  { factoryValueCode: 'RAL 340 50 20', hexCode: '#987489' },
  { factoryValueCode: 'RAL 340 50 25', hexCode: '#9D708B' },
  { factoryValueCode: 'RAL 340 50 30', hexCode: '#A26D8E' },
  { factoryValueCode: 'RAL 340 50 35', hexCode: '#A56890' },
  { factoryValueCode: 'RAL 340 50 40', hexCode: '#AD6693' },
  { factoryValueCode: 'RAL 340 50 45', hexCode: '#B26295' },
  { factoryValueCode: 'RAL 340 60 05', hexCode: '#9E959A' },
  { factoryValueCode: 'RAL 340 60 10', hexCode: '#A48F9B' },
  { factoryValueCode: 'RAL 340 60 15', hexCode: '#AC8D9F' },
  { factoryValueCode: 'RAL 340 60 20', hexCode: '#B08AA1' },
  { factoryValueCode: 'RAL 340 60 25', hexCode: '#B587A3' },
  { factoryValueCode: 'RAL 340 60 30', hexCode: '#BA84A6' },
  { factoryValueCode: 'RAL 340 60 35', hexCode: '#C181A9' },
  { factoryValueCode: 'RAL 340 60 40', hexCode: '#C87CAD' },
  { factoryValueCode: 'RAL 340 70 05', hexCode: '#B6ACB1' },
  { factoryValueCode: 'RAL 340 70 10', hexCode: '#BCA8B3' },
  { factoryValueCode: 'RAL 340 70 15', hexCode: '#C5A6B8' },
  { factoryValueCode: 'RAL 340 70 20', hexCode: '#CBA3BB' },
  { factoryValueCode: 'RAL 340 70 25', hexCode: '#CE9FBB' },
  { factoryValueCode: 'RAL 340 70 30', hexCode: '#D69CC0' },
  { factoryValueCode: 'RAL 340 70 35', hexCode: '#DD99C4' },
  { factoryValueCode: 'RAL 340 80 05', hexCode: '#D1C7CA' },
  { factoryValueCode: 'RAL 340 80 10', hexCode: '#D9C4D0' },
  { factoryValueCode: 'RAL 340 80 15', hexCode: '#E0C0D2' },
  { factoryValueCode: 'RAL 340 80 20', hexCode: '#E7BDD4' },
  { factoryValueCode: 'RAL 340 85 05', hexCode: '#DDD2D8' },
  { factoryValueCode: 'RAL 340 85 10', hexCode: '#E5CFDB' },
  { factoryValueCode: 'RAL 340 85 15', hexCode: '#EECDDF' },
  { factoryValueCode: 'RAL 340 90 05', hexCode: '#EBE1E4' },
  { factoryValueCode: 'RAL 340 93 05', hexCode: '#F1E8ED' },
  { factoryValueCode: 'RAL 350 20 10', hexCode: '#514449' },
  { factoryValueCode: 'RAL 350 20 15', hexCode: '#57444B' },
  { factoryValueCode: 'RAL 350 20 20', hexCode: '#5C414B' },
  { factoryValueCode: 'RAL 350 20 25', hexCode: '#5F404C' },
  { factoryValueCode: 'RAL 350 20 30', hexCode: '#653D4E' },
  { factoryValueCode: 'RAL 350 30 10', hexCode: '#625158' },
  { factoryValueCode: 'RAL 350 30 15', hexCode: '#684F59' },
  { factoryValueCode: 'RAL 350 30 20', hexCode: '#6F4E5B' },
  { factoryValueCode: 'RAL 350 30 25', hexCode: '#744B5C' },
  { factoryValueCode: 'RAL 350 30 30', hexCode: '#7A4A5E' },
  { factoryValueCode: 'RAL 350 30 35', hexCode: '#7B465E' },
  { factoryValueCode: 'RAL 350 30 40', hexCode: '#804360' },
  { factoryValueCode: 'RAL 350 40 10', hexCode: '#77656C' },
  { factoryValueCode: 'RAL 350 40 15', hexCode: '#7D626D' },
  { factoryValueCode: 'RAL 350 40 20', hexCode: '#835F6F' },
  { factoryValueCode: 'RAL 350 40 25', hexCode: '#875C6F' },
  { factoryValueCode: 'RAL 350 40 30', hexCode: '#8F5971' },
  { factoryValueCode: 'RAL 350 40 35', hexCode: '#945573' },
  { factoryValueCode: 'RAL 350 40 40', hexCode: '#985374' },
  { factoryValueCode: 'RAL 350 40 45', hexCode: '#9D5075' },
  { factoryValueCode: 'RAL 350 40 50', hexCode: '#A24B76' },
  { factoryValueCode: 'RAL 350 50 10', hexCode: '#8D7981' },
  { factoryValueCode: 'RAL 350 50 15', hexCode: '#937682' },
  { factoryValueCode: 'RAL 350 50 20', hexCode: '#9B7385' },
  { factoryValueCode: 'RAL 350 50 25', hexCode: '#A27086' },
  { factoryValueCode: 'RAL 350 50 30', hexCode: '#A76E88' },
  { factoryValueCode: 'RAL 350 50 35', hexCode: '#AF6888' },
  { factoryValueCode: 'RAL 350 50 40', hexCode: '#B56589' },
  { factoryValueCode: 'RAL 350 50 45', hexCode: '#B6618B' },
  { factoryValueCode: 'RAL 350 50 50', hexCode: '#C25E8B' },
  { factoryValueCode: 'RAL 350 60 10', hexCode: '#A59099' },
  { factoryValueCode: 'RAL 350 60 15', hexCode: '#AC8C9A' },
  { factoryValueCode: 'RAL 350 60 20', hexCode: '#B58B9D' },
  { factoryValueCode: 'RAL 350 60 25', hexCode: '#BC869D' },
  { factoryValueCode: 'RAL 350 60 30', hexCode: '#C4839F' },
  { factoryValueCode: 'RAL 350 60 35', hexCode: '#C87FA0' },
  { factoryValueCode: 'RAL 350 60 40', hexCode: '#D07CA1' },
  { factoryValueCode: 'RAL 350 60 45', hexCode: '#D378A4' },
  { factoryValueCode: 'RAL 350 70 10', hexCode: '#BFAAB1' },
  { factoryValueCode: 'RAL 350 70 15', hexCode: '#C7A5B3' },
  { factoryValueCode: 'RAL 350 70 20', hexCode: '#CB9FB3' },
  { factoryValueCode: 'RAL 350 70 25', hexCode: '#D69FB6' },
  { factoryValueCode: 'RAL 350 70 30', hexCode: '#DE9BB8' },
  { factoryValueCode: 'RAL 350 70 35', hexCode: '#E498B9' },
  { factoryValueCode: 'RAL 350 80 10', hexCode: '#D9C1CA' },
  { factoryValueCode: 'RAL 350 80 15', hexCode: '#E0BFCB' },
  { factoryValueCode: 'RAL 350 80 20', hexCode: '#E9BCCF' },
  { factoryValueCode: 'RAL 350 85 05', hexCode: '#DDD2D7' },
  { factoryValueCode: 'RAL 350 85 10', hexCode: '#E7CFD9' },
  { factoryValueCode: 'RAL 350 85 15', hexCode: '#EECCD9' },
  { factoryValueCode: 'RAL 350 90 05', hexCode: '#EEE1E2' },
  { factoryValueCode: 'RAL 350 90 10', hexCode: '#F4DBE5' },
  { factoryValueCode: 'RAL 350 93 05', hexCode: '#F4E8EC' },
  { factoryValueCode: 'RAL 360 20 15', hexCode: '#574247' },
  { factoryValueCode: 'RAL 360 30 05', hexCode: '#5D5456' },
  { factoryValueCode: 'RAL 360 30 10', hexCode: '#635156' },
  { factoryValueCode: 'RAL 360 30 15', hexCode: '#684E56' },
  { factoryValueCode: 'RAL 360 30 20', hexCode: '#704D57' },
  { factoryValueCode: 'RAL 360 30 25', hexCode: '#734956' },
  { factoryValueCode: 'RAL 360 30 30', hexCode: '#784657' },
  { factoryValueCode: 'RAL 360 30 35', hexCode: '#814456' },
  { factoryValueCode: 'RAL 360 30 40', hexCode: '#834257' },
  { factoryValueCode: 'RAL 360 40 05', hexCode: '#726769' },
  { factoryValueCode: 'RAL 360 40 10', hexCode: '#766369' },
  { factoryValueCode: 'RAL 360 40 15', hexCode: '#7D6069' },
  { factoryValueCode: 'RAL 360 40 20', hexCode: '#845D69' },
  { factoryValueCode: 'RAL 360 40 25', hexCode: '#8A5A68' },
  { factoryValueCode: 'RAL 360 40 30', hexCode: '#91576A' },
  { factoryValueCode: 'RAL 360 40 35', hexCode: '#97546B' },
  { factoryValueCode: 'RAL 360 40 40', hexCode: '#9E506C' },
  { factoryValueCode: 'RAL 360 40 45', hexCode: '#A24D6A' },
  { factoryValueCode: 'RAL 360 40 50', hexCode: '#A94669' },
  { factoryValueCode: 'RAL 360 50 05', hexCode: '#887C7E' },
  { factoryValueCode: 'RAL 360 50 10', hexCode: '#8D787E' },
  { factoryValueCode: 'RAL 360 50 15', hexCode: '#95747E' },
  { factoryValueCode: 'RAL 360 50 20', hexCode: '#9B727F' },
  { factoryValueCode: 'RAL 360 50 25', hexCode: '#A46E7D' },
  { factoryValueCode: 'RAL 360 50 30', hexCode: '#AA6B80' },
  { factoryValueCode: 'RAL 360 50 35', hexCode: '#B26780' },
  { factoryValueCode: 'RAL 360 50 40', hexCode: '#B96680' },
  { factoryValueCode: 'RAL 360 50 45', hexCode: '#C06281' },
  { factoryValueCode: 'RAL 360 50 50', hexCode: '#C45D80' },
  { factoryValueCode: 'RAL 360 60 05', hexCode: '#9F9497' },
  { factoryValueCode: 'RAL 360 60 10', hexCode: '#A58F95' },
  { factoryValueCode: 'RAL 360 60 15', hexCode: '#AE8D96' },
  { factoryValueCode: 'RAL 360 60 20', hexCode: '#B78A97' },
  { factoryValueCode: 'RAL 360 60 25', hexCode: '#BD8597' },
  { factoryValueCode: 'RAL 360 70 05', hexCode: '#B9ADB0' },
  { factoryValueCode: 'RAL 360 70 10', hexCode: '#C0A7AE' },
  { factoryValueCode: 'RAL 360 70 15', hexCode: '#C9A5AF' },
  { factoryValueCode: 'RAL 360 80 05', hexCode: '#D3C7C9' },
  { factoryValueCode: 'RAL 360 80 10', hexCode: '#DBC2C8' },
  { factoryValueCode: 'RAL 360 80 15', hexCode: '#E4BFC9' },
  { factoryValueCode: 'RAL 360 85 05', hexCode: '#E0D2D4' },
  { factoryValueCode: 'RAL 360 85 10', hexCode: '#E8CFD5' },
  { factoryValueCode: 'RAL 360 90 05', hexCode: '#F1E2E1' },
  { factoryValueCode: 'RAL 360 90 10', hexCode: '#F7DDE3' },
  { factoryValueCode: 'RAL 360 93 05', hexCode: '#F6E8E9' },
  { factoryValueCode: 'RAL 110-1', hexCode: '#E6E7E6' },
  { factoryValueCode: 'RAL 110-2', hexCode: '#DEDDD5' },
  { factoryValueCode: 'RAL 110-3', hexCode: '#C8C6BE' },
  { factoryValueCode: 'RAL 110-4', hexCode: '#C6C7C4' },
  { factoryValueCode: 'RAL 110-5', hexCode: '#C9CCC6' },
  { factoryValueCode: 'RAL 110-6', hexCode: '#C8C8C7' },
  { factoryValueCode: 'RAL 110-M', hexCode: '#A0A2A4' },
  { factoryValueCode: 'RAL 120-1', hexCode: '#EDEDEA' },
  { factoryValueCode: 'RAL 120-2', hexCode: '#F2F1EC' },
  { factoryValueCode: 'RAL 120-3', hexCode: '#F0EEE5' },
  { factoryValueCode: 'RAL 120-4', hexCode: '#E9E1D4' },
  { factoryValueCode: 'RAL 120-5', hexCode: '#E2D9C6' },
  { factoryValueCode: 'RAL 120-6', hexCode: '#EAE1CE' },
  { factoryValueCode: 'RAL 120-M', hexCode: '#8F8D87' },
  { factoryValueCode: 'RAL 130-1', hexCode: '#F2EDBB' },
  { factoryValueCode: 'RAL 130-2', hexCode: '#F1EEC3' },
  { factoryValueCode: 'RAL 130-3', hexCode: '#F0EECD' },
  { factoryValueCode: 'RAL 130-4', hexCode: '#F8F0CF' },
  { factoryValueCode: 'RAL 130-5', hexCode: '#EDE4BC' },
  { factoryValueCode: 'RAL 130-6', hexCode: '#FBE5B0' },
  { factoryValueCode: 'RAL 130-M', hexCode: '#ABAB90' },
  { factoryValueCode: 'RAL 140-1', hexCode: '#FAD3A9' },
  { factoryValueCode: 'RAL 140-2', hexCode: '#FEDAA6' },
  { factoryValueCode: 'RAL 140-3', hexCode: '#FEE3C1' },
  { factoryValueCode: 'RAL 140-4', hexCode: '#FDDFBE' },
  { factoryValueCode: 'RAL 140-5', hexCode: '#F8E4C8' },
  { factoryValueCode: 'RAL 140-6', hexCode: '#E5D2B6' },
  { factoryValueCode: 'RAL 140-M', hexCode: '#B09E7E' },
  { factoryValueCode: 'RAL 150-1', hexCode: '#F7EFE9' },
  { factoryValueCode: 'RAL 150-2', hexCode: '#F9EBE3' },
  { factoryValueCode: 'RAL 150-3', hexCode: '#EEE1D7' },
  { factoryValueCode: 'RAL 150-4', hexCode: '#FBE3D4' },
  { factoryValueCode: 'RAL 150-5', hexCode: '#FAE8DC' },
  { factoryValueCode: 'RAL 150-6', hexCode: '#F8DFD7' },
  { factoryValueCode: 'RAL 150-M', hexCode: '#AB978A' },
  { factoryValueCode: 'RAL 160-1', hexCode: '#E3E1EC' },
  { factoryValueCode: 'RAL 160-2', hexCode: '#E7E2E8' },
  { factoryValueCode: 'RAL 160-3', hexCode: '#EDE8E8' },
  { factoryValueCode: 'RAL 160-4', hexCode: '#EEE1E2' },
  { factoryValueCode: 'RAL 160-5', hexCode: '#EFE4E0' },
  { factoryValueCode: 'RAL 160-6', hexCode: '#ECE4E9' },
  { factoryValueCode: 'RAL 160-M', hexCode: '#ADA6B5' },
  { factoryValueCode: 'RAL 170-1', hexCode: '#C7C9D0' },
  { factoryValueCode: 'RAL 170-2', hexCode: '#A6ADBD' },
  { factoryValueCode: 'RAL 170-3', hexCode: '#BAC8DA' },
  { factoryValueCode: 'RAL 170-4', hexCode: '#CEDBEC' },
  { factoryValueCode: 'RAL 170-5', hexCode: '#C3C6D6' },
  { factoryValueCode: 'RAL 170-6', hexCode: '#C6C5D6' },
  { factoryValueCode: 'RAL 170-M', hexCode: '#A7A8B9' },
  { factoryValueCode: 'RAL 180-1', hexCode: '#AEBCC6' },
  { factoryValueCode: 'RAL 180-2', hexCode: '#B9CDDD' },
  { factoryValueCode: 'RAL 180-3', hexCode: '#C7DBEB' },
  { factoryValueCode: 'RAL 180-4', hexCode: '#C9E1EC' },
  { factoryValueCode: 'RAL 180-5', hexCode: '#C7DDE1' },
  { factoryValueCode: 'RAL 180-6', hexCode: '#DBE9EB' },
  { factoryValueCode: 'RAL 180-M', hexCode: '#96A4A9' },
  { factoryValueCode: 'RAL 190-1', hexCode: '#A5DADF' },
  { factoryValueCode: 'RAL 190-2', hexCode: '#B9E6F2' },
  { factoryValueCode: 'RAL 190-3', hexCode: '#C0DEE1' },
  { factoryValueCode: 'RAL 190-4', hexCode: '#BDDAD7' },
  { factoryValueCode: 'RAL 190-5', hexCode: '#D4E5E7' },
  { factoryValueCode: 'RAL 190-6', hexCode: '#A3C1BF' },
  { factoryValueCode: 'RAL 190-M', hexCode: '#92B4B2' },
  { factoryValueCode: 'RAL 210-1', hexCode: '#CFC6B2' },
  { factoryValueCode: 'RAL 210-2', hexCode: '#ECE7D2' },
  { factoryValueCode: 'RAL 210-3', hexCode: '#E3E4D9' },
  { factoryValueCode: 'RAL 210-4', hexCode: '#D6E6E3' },
  { factoryValueCode: 'RAL 210-5', hexCode: '#D8E8E0' },
  { factoryValueCode: 'RAL 210-6', hexCode: '#D8E9D6' },
  { factoryValueCode: 'RAL 210-M', hexCode: '#A5A99B' },
  { factoryValueCode: 'RAL 220-1', hexCode: '#66B872' },
  { factoryValueCode: 'RAL 220-2', hexCode: '#339A51' },
  { factoryValueCode: 'RAL 220-3', hexCode: '#006F3C' },
  { factoryValueCode: 'RAL 220-4', hexCode: '#088554' },
  { factoryValueCode: 'RAL 220-5', hexCode: '#267E51' },
  { factoryValueCode: 'RAL 220-6', hexCode: '#006A4D' },
  { factoryValueCode: 'RAL 220-M', hexCode: '#007F3E' },
  { factoryValueCode: 'RAL 230-1', hexCode: '#BBDB9A' },
  { factoryValueCode: 'RAL 230-2', hexCode: '#96C86C' },
  { factoryValueCode: 'RAL 230-3', hexCode: '#7DB344' },
  { factoryValueCode: 'RAL 230-4', hexCode: '#5F973A' },
  { factoryValueCode: 'RAL 230-5', hexCode: '#396938' },
  { factoryValueCode: 'RAL 230-6', hexCode: '#365C30' },
  { factoryValueCode: 'RAL 230-M', hexCode: '#62A74E' },
  { factoryValueCode: 'RAL 240-1', hexCode: '#DCD691' },
  { factoryValueCode: 'RAL 240-2', hexCode: '#AAAF66' },
  { factoryValueCode: 'RAL 240-3', hexCode: '#939755' },
  { factoryValueCode: 'RAL 240-4', hexCode: '#7E7E42' },
  { factoryValueCode: 'RAL 240-5', hexCode: '#5D6D3C' },
  { factoryValueCode: 'RAL 240-6', hexCode: '#4F6D35' },
  { factoryValueCode: 'RAL 240-M', hexCode: '#627439' },
  { factoryValueCode: 'RAL 250-1', hexCode: '#EEE6A5' },
  { factoryValueCode: 'RAL 250-2', hexCode: '#E8DE6F' },
  { factoryValueCode: 'RAL 250-3', hexCode: '#BFB700' },
  { factoryValueCode: 'RAL 250-4', hexCode: '#A4A541' },
  { factoryValueCode: 'RAL 250-5', hexCode: '#919138' },
  { factoryValueCode: 'RAL 250-6', hexCode: '#69652C' },
  { factoryValueCode: 'RAL 250-M', hexCode: '#AEA73B' },
  { factoryValueCode: 'RAL 260-1', hexCode: '#F3E9B4' },
  { factoryValueCode: 'RAL 260-2', hexCode: '#F1E483' },
  { factoryValueCode: 'RAL 260-3', hexCode: '#F3D446' },
  { factoryValueCode: 'RAL 260-4', hexCode: '#E8C01F' },
  { factoryValueCode: 'RAL 260-5', hexCode: '#DEB02D' },
  { factoryValueCode: 'RAL 260-6', hexCode: '#EFB416' },
  { factoryValueCode: 'RAL 260-M', hexCode: '#B8944F' },
  { factoryValueCode: 'RAL 270-1', hexCode: '#FFDE83' },
  { factoryValueCode: 'RAL 270-2', hexCode: '#FACC39' },
  { factoryValueCode: 'RAL 270-3', hexCode: '#F4BD16' },
  { factoryValueCode: 'RAL 270-4', hexCode: '#EBB100' },
  { factoryValueCode: 'RAL 270-5', hexCode: '#F6B600' },
  { factoryValueCode: 'RAL 270-6', hexCode: '#FEC43F' },
  { factoryValueCode: 'RAL 270-M', hexCode: '#CB9437' },
  { factoryValueCode: 'RAL 280-1', hexCode: '#FDE193' },
  { factoryValueCode: 'RAL 280-2', hexCode: '#F0D391' },
  { factoryValueCode: 'RAL 280-3', hexCode: '#E1BE78' },
  { factoryValueCode: 'RAL 280-4', hexCode: '#D6AE5F' },
  { factoryValueCode: 'RAL 280-5', hexCode: '#DCA140' },
  { factoryValueCode: 'RAL 280-6', hexCode: '#D0973C' },
  { factoryValueCode: 'RAL 280-M', hexCode: '#B28740' },
  { factoryValueCode: 'RAL 290-1', hexCode: '#D89B50' },
  { factoryValueCode: 'RAL 290-2', hexCode: '#BF853B' },
  { factoryValueCode: 'RAL 290-3', hexCode: '#D8A960' },
  { factoryValueCode: 'RAL 290-4', hexCode: '#CC921B' },
  { factoryValueCode: 'RAL 290-5', hexCode: '#E6B03E' },
  { factoryValueCode: 'RAL 290-6', hexCode: '#FCAB04' },
  { factoryValueCode: 'RAL 290-M', hexCode: '#B87E32' },
  { factoryValueCode: 'RAL 310-1', hexCode: '#F5D6B4' },
  { factoryValueCode: 'RAL 310-2', hexCode: '#EBC297' },
  { factoryValueCode: 'RAL 310-3', hexCode: '#DFAB73' },
  { factoryValueCode: 'RAL 310-4', hexCode: '#D09355' },
  { factoryValueCode: 'RAL 310-5', hexCode: '#BA7C43' },
  { factoryValueCode: 'RAL 310-6', hexCode: '#8E5B2D' },
  { factoryValueCode: 'RAL 310-M', hexCode: '#B87D4F' },
  { factoryValueCode: 'RAL 320-1', hexCode: '#D2A96C' },
  { factoryValueCode: 'RAL 320-2', hexCode: '#AE8151' },
  { factoryValueCode: 'RAL 320-3', hexCode: '#B9864C' },
  { factoryValueCode: 'RAL 320-4', hexCode: '#A06735' },
  { factoryValueCode: 'RAL 320-5', hexCode: '#7F4E2E' },
  { factoryValueCode: 'RAL 320-6', hexCode: '#6E4428' },
  { factoryValueCode: 'RAL 320-M', hexCode: '#B9731E' },
  { factoryValueCode: 'RAL 330-1', hexCode: '#A86859' },
  { factoryValueCode: 'RAL 330-2', hexCode: '#8E4B35' },
  { factoryValueCode: 'RAL 330-3', hexCode: '#794E3E' },
  { factoryValueCode: 'RAL 330-4', hexCode: '#5C3B2D' },
  { factoryValueCode: 'RAL 330-5', hexCode: '#50312A' },
  { factoryValueCode: 'RAL 330-6', hexCode: '#46322E' },
  { factoryValueCode: 'RAL 330-M', hexCode: '#8B5943' },
  { factoryValueCode: 'RAL 340-1', hexCode: '#BEA4A9' },
  { factoryValueCode: 'RAL 340-2', hexCode: '#A48C92' },
  { factoryValueCode: 'RAL 340-3', hexCode: '#7F5452' },
  { factoryValueCode: 'RAL 340-4', hexCode: '#683D40' },
  { factoryValueCode: 'RAL 340-5', hexCode: '#4F2A2D' },
  { factoryValueCode: 'RAL 340-6', hexCode: '#4F2B31' },
  { factoryValueCode: 'RAL 340-M', hexCode: '#53353B' },
  { factoryValueCode: 'RAL 350-1', hexCode: '#9D311F' },
  { factoryValueCode: 'RAL 350-2', hexCode: '#A73F32' },
  { factoryValueCode: 'RAL 350-3', hexCode: '#A24733' },
  { factoryValueCode: 'RAL 350-4', hexCode: '#813021' },
  { factoryValueCode: 'RAL 350-5', hexCode: '#783122' },
  { factoryValueCode: 'RAL 350-6', hexCode: '#66322B' },
  { factoryValueCode: 'RAL 350-M', hexCode: '#582F2A' },
  { factoryValueCode: 'RAL 360-1', hexCode: '#E07D29' },
  { factoryValueCode: 'RAL 360-2', hexCode: '#D9751E' },
  { factoryValueCode: 'RAL 360-3', hexCode: '#C66217' },
  { factoryValueCode: 'RAL 360-4', hexCode: '#B75629' },
  { factoryValueCode: 'RAL 360-5', hexCode: '#9A4F2C' },
  { factoryValueCode: 'RAL 360-6', hexCode: '#915033' },
  { factoryValueCode: 'RAL 360-M', hexCode: '#A45633' },
  { factoryValueCode: 'RAL 370-1', hexCode: '#FFAE47' },
  { factoryValueCode: 'RAL 370-2', hexCode: '#FF9B38' },
  { factoryValueCode: 'RAL 370-3', hexCode: '#FF901D' },
  { factoryValueCode: 'RAL 370-4', hexCode: '#E68316' },
  { factoryValueCode: 'RAL 370-5', hexCode: '#D4781F' },
  { factoryValueCode: 'RAL 370-6', hexCode: '#CD6C10' },
  { factoryValueCode: 'RAL 370-M', hexCode: '#B47A3C' },
  { factoryValueCode: 'RAL 380-1', hexCode: '#FF9B29' },
  { factoryValueCode: 'RAL 380-2', hexCode: '#FF9204' },
  { factoryValueCode: 'RAL 380-3', hexCode: '#FA841A' },
  { factoryValueCode: 'RAL 380-4', hexCode: '#E27121' },
  { factoryValueCode: 'RAL 380-5', hexCode: '#F2782F' },
  { factoryValueCode: 'RAL 380-6', hexCode: '#EA6A24' },
  { factoryValueCode: 'RAL 380-M', hexCode: '#A7552A' },
  { factoryValueCode: 'RAL 390-1', hexCode: '#EB773F' },
  { factoryValueCode: 'RAL 390-2', hexCode: '#E36125' },
  { factoryValueCode: 'RAL 390-3', hexCode: '#DE5411' },
  { factoryValueCode: 'RAL 390-4', hexCode: '#D8511C' },
  { factoryValueCode: 'RAL 390-5', hexCode: '#D8480F' },
  { factoryValueCode: 'RAL 390-6', hexCode: '#CD5E2A' },
  { factoryValueCode: 'RAL 390-M', hexCode: '#BF633B' },
  { factoryValueCode: 'RAL 410-1', hexCode: '#ED8165' },
  { factoryValueCode: 'RAL 410-2', hexCode: '#EA734F' },
  { factoryValueCode: 'RAL 410-3', hexCode: '#E46440' },
  { factoryValueCode: 'RAL 410-4', hexCode: '#DC5D38' },
  { factoryValueCode: 'RAL 410-5', hexCode: '#D25535' },
  { factoryValueCode: 'RAL 410-6', hexCode: '#D05D42' },
  { factoryValueCode: 'RAL 410-M', hexCode: '#AB4924' },
  { factoryValueCode: 'RAL 420-1', hexCode: '#EDAE9A' },
  { factoryValueCode: 'RAL 420-2', hexCode: '#F29D86' },
  { factoryValueCode: 'RAL 420-3', hexCode: '#E98A6C' },
  { factoryValueCode: 'RAL 420-4', hexCode: '#E46443' },
  { factoryValueCode: 'RAL 420-5', hexCode: '#CC5738' },
  { factoryValueCode: 'RAL 420-6', hexCode: '#BF502E' },
  { factoryValueCode: 'RAL 420-M', hexCode: '#9D4B32' },
  { factoryValueCode: 'RAL 430-1', hexCode: '#F2C2B6' },
  { factoryValueCode: 'RAL 430-2', hexCode: '#EC998B' },
  { factoryValueCode: 'RAL 430-3', hexCode: '#E48074' },
  { factoryValueCode: 'RAL 430-4', hexCode: '#DD5A4C' },
  { factoryValueCode: 'RAL 430-5', hexCode: '#D5433C' },
  { factoryValueCode: 'RAL 430-6', hexCode: '#BE3A24' },
  { factoryValueCode: 'RAL 430-M', hexCode: '#A84C45' },
  { factoryValueCode: 'RAL 440-1', hexCode: '#CA383C' },
  { factoryValueCode: 'RAL 440-2', hexCode: '#D34C49' },
  { factoryValueCode: 'RAL 440-3', hexCode: '#BA3C3E' },
  { factoryValueCode: 'RAL 440-4', hexCode: '#9B2929' },
  { factoryValueCode: 'RAL 440-5', hexCode: '#A63129' },
  { factoryValueCode: 'RAL 440-6', hexCode: '#B93525' },
  { factoryValueCode: 'RAL 440-M', hexCode: '#9B252C' },
  { factoryValueCode: 'RAL 450-1', hexCode: '#F4C7CA' },
  { factoryValueCode: 'RAL 450-2', hexCode: '#EDA5AA' },
  { factoryValueCode: 'RAL 450-3', hexCode: '#E07A81' },
  { factoryValueCode: 'RAL 450-4', hexCode: '#C85862' },
  { factoryValueCode: 'RAL 450-5', hexCode: '#B2312F' },
  { factoryValueCode: 'RAL 450-6', hexCode: '#BB201D' },
  { factoryValueCode: 'RAL 450-M', hexCode: '#A71616' },
  { factoryValueCode: 'RAL 460-1', hexCode: '#EFA3A7' },
  { factoryValueCode: 'RAL 460-2', hexCode: '#E37F89' },
  { factoryValueCode: 'RAL 460-3', hexCode: '#DF6368' },
  { factoryValueCode: 'RAL 460-4', hexCode: '#D35254' },
  { factoryValueCode: 'RAL 460-5', hexCode: '#A8373B' },
  { factoryValueCode: 'RAL 460-6', hexCode: '#8B1B28' },
  { factoryValueCode: 'RAL 460-M', hexCode: '#AE363B' },
  { factoryValueCode: 'RAL 470-1', hexCode: '#F0B3C1' },
  { factoryValueCode: 'RAL 470-2', hexCode: '#E68B9D' },
  { factoryValueCode: 'RAL 470-3', hexCode: '#DE7383' },
  { factoryValueCode: 'RAL 470-4', hexCode: '#CA4D67' },
  { factoryValueCode: 'RAL 470-5', hexCode: '#AC2D4C' },
  { factoryValueCode: 'RAL 470-6', hexCode: '#9C223F' },
  { factoryValueCode: 'RAL 470-M', hexCode: '#B14F5D' },
  { factoryValueCode: 'RAL 480-1', hexCode: '#F5CAC9' },
  { factoryValueCode: 'RAL 480-2', hexCode: '#F5C0BE' },
  { factoryValueCode: 'RAL 480-3', hexCode: '#EEBABC' },
  { factoryValueCode: 'RAL 480-4', hexCode: '#EEA5B1' },
  { factoryValueCode: 'RAL 480-5', hexCode: '#E9909E' },
  { factoryValueCode: 'RAL 480-6', hexCode: '#DA6C82' },
  { factoryValueCode: 'RAL 480-M', hexCode: '#A87579' },
  { factoryValueCode: 'RAL 490-1', hexCode: '#F3CFD0' },
  { factoryValueCode: 'RAL 490-2', hexCode: '#F7CAC3' },
  { factoryValueCode: 'RAL 490-3', hexCode: '#E89A92' },
  { factoryValueCode: 'RAL 490-4', hexCode: '#C37B77' },
  { factoryValueCode: 'RAL 490-5', hexCode: '#BE7F8C' },
  { factoryValueCode: 'RAL 490-6', hexCode: '#D29EA8' },
  { factoryValueCode: 'RAL 490-M', hexCode: '#A77D88' },
  { factoryValueCode: 'RAL 510-1', hexCode: '#ECC8DC' },
  { factoryValueCode: 'RAL 510-2', hexCode: '#E0A5CB' },
  { factoryValueCode: 'RAL 510-3', hexCode: '#D584B1' },
  { factoryValueCode: 'RAL 510-4', hexCode: '#C4638D' },
  { factoryValueCode: 'RAL 510-5', hexCode: '#BA4877' },
  { factoryValueCode: 'RAL 510-6', hexCode: '#9A3B6A' },
  { factoryValueCode: 'RAL 510-M', hexCode: '#8C3D71' },
  { factoryValueCode: 'RAL 520-1', hexCode: '#EFD2DF' },
  { factoryValueCode: 'RAL 520-2', hexCode: '#E8BAD2' },
  { factoryValueCode: 'RAL 520-3', hexCode: '#DCA5C0' },
  { factoryValueCode: 'RAL 520-4', hexCode: '#BA7293' },
  { factoryValueCode: 'RAL 520-5', hexCode: '#A04E6F' },
  { factoryValueCode: 'RAL 520-6', hexCode: '#92526E' },
  { factoryValueCode: 'RAL 520-M', hexCode: '#9E588B' },
  { factoryValueCode: 'RAL 530-1', hexCode: '#98444D' },
  { factoryValueCode: 'RAL 530-2', hexCode: '#8F3F4E' },
  { factoryValueCode: 'RAL 530-3', hexCode: '#793644' },
  { factoryValueCode: 'RAL 530-4', hexCode: '#7C2F4B' },
  { factoryValueCode: 'RAL 530-5', hexCode: '#66253D' },
  { factoryValueCode: 'RAL 530-6', hexCode: '#61294A' },
  { factoryValueCode: 'RAL 530-M', hexCode: '#5C2D3A' },
  { factoryValueCode: 'RAL 540-1', hexCode: '#D4C1D7' },
  { factoryValueCode: 'RAL 540-2', hexCode: '#BEA1C1' },
  { factoryValueCode: 'RAL 540-3', hexCode: '#805F83' },
  { factoryValueCode: 'RAL 540-4', hexCode: '#966B98' },
  { factoryValueCode: 'RAL 540-5', hexCode: '#81537A' },
  { factoryValueCode: 'RAL 540-6', hexCode: '#562C51' },
  { factoryValueCode: 'RAL 540-M', hexCode: '#562F4E' },
  { factoryValueCode: 'RAL 550-1', hexCode: '#E0D1D9' },
  { factoryValueCode: 'RAL 550-2', hexCode: '#D0BBC9' },
  { factoryValueCode: 'RAL 550-3', hexCode: '#B292A8' },
  { factoryValueCode: 'RAL 550-4', hexCode: '#9C7488' },
  { factoryValueCode: 'RAL 550-5', hexCode: '#8D6177' },
  { factoryValueCode: 'RAL 550-6', hexCode: '#784C5E' },
  { factoryValueCode: 'RAL 550-M', hexCode: '#A78890' },
  { factoryValueCode: 'RAL 560-1', hexCode: '#CCBCC7' },
  { factoryValueCode: 'RAL 560-2', hexCode: '#B09CAD' },
  { factoryValueCode: 'RAL 560-3', hexCode: '#8C6F80' },
  { factoryValueCode: 'RAL 560-4', hexCode: '#775460' },
  { factoryValueCode: 'RAL 560-5', hexCode: '#85727F' },
  { factoryValueCode: 'RAL 560-6', hexCode: '#7D6E7F' },
  { factoryValueCode: 'RAL 560-M', hexCode: '#A592A4' },
  { factoryValueCode: 'RAL 570-1', hexCode: '#D1CEE8' },
  { factoryValueCode: 'RAL 570-2', hexCode: '#C3BFE1' },
  { factoryValueCode: 'RAL 570-3', hexCode: '#ADADDD' },
  { factoryValueCode: 'RAL 570-4', hexCode: '#9B9ACF' },
  { factoryValueCode: 'RAL 570-5', hexCode: '#8078B3' },
  { factoryValueCode: 'RAL 570-6', hexCode: '#79689B' },
  { factoryValueCode: 'RAL 570-M', hexCode: '#6B589A' },
  { factoryValueCode: 'RAL 580-1', hexCode: '#C2CFE6' },
  { factoryValueCode: 'RAL 580-2', hexCode: '#BCC7E0' },
  { factoryValueCode: 'RAL 580-3', hexCode: '#A7B2D1' },
  { factoryValueCode: 'RAL 580-4', hexCode: '#69749A' },
  { factoryValueCode: 'RAL 580-5', hexCode: '#41506E' },
  { factoryValueCode: 'RAL 580-6', hexCode: '#243154' },
  { factoryValueCode: 'RAL 580-M', hexCode: '#636C86' },
  { factoryValueCode: 'RAL 590-1', hexCode: '#666D9B' },
  { factoryValueCode: 'RAL 590-2', hexCode: '#424276' },
  { factoryValueCode: 'RAL 590-3', hexCode: '#2A366B' },
  { factoryValueCode: 'RAL 590-4', hexCode: '#272F5B' },
  { factoryValueCode: 'RAL 590-5', hexCode: '#142D58' },
  { factoryValueCode: 'RAL 590-6', hexCode: '#093B7A' },
  { factoryValueCode: 'RAL 590-M', hexCode: '#293862' },
  { factoryValueCode: 'RAL 610-1', hexCode: '#6E8FAB' },
  { factoryValueCode: 'RAL 610-2', hexCode: '#617A94' },
  { factoryValueCode: 'RAL 610-3', hexCode: '#6D95B9' },
  { factoryValueCode: 'RAL 610-4', hexCode: '#89B2D8' },
  { factoryValueCode: 'RAL 610-5', hexCode: '#4777AE' },
  { factoryValueCode: 'RAL 610-6', hexCode: '#436999' },
  { factoryValueCode: 'RAL 610-M', hexCode: '#7897B5' },
  { factoryValueCode: 'RAL 620-1', hexCode: '#34688A' },
  { factoryValueCode: 'RAL 620-2', hexCode: '#6092AC' },
  { factoryValueCode: 'RAL 620-3', hexCode: '#64818F' },
  { factoryValueCode: 'RAL 620-4', hexCode: '#3A5A6A' },
  { factoryValueCode: 'RAL 620-5', hexCode: '#14354B' },
  { factoryValueCode: 'RAL 620-6', hexCode: '#1E2D3F' },
  { factoryValueCode: 'RAL 620-M', hexCode: '#093246' },
  { factoryValueCode: 'RAL 630-1', hexCode: '#51A3D3' },
  { factoryValueCode: 'RAL 630-2', hexCode: '#446B8E' },
  { factoryValueCode: 'RAL 630-3', hexCode: '#2E4E6F' },
  { factoryValueCode: 'RAL 630-4', hexCode: '#2D4A6E' },
  { factoryValueCode: 'RAL 630-5', hexCode: '#1F3454' },
  { factoryValueCode: 'RAL 630-6', hexCode: '#193654' },
  { factoryValueCode: 'RAL 630-M', hexCode: '#16304C' },
  { factoryValueCode: 'RAL 640-1', hexCode: '#49A0C5' },
  { factoryValueCode: 'RAL 640-2', hexCode: '#0087B5' },
  { factoryValueCode: 'RAL 640-3', hexCode: '#007BAE' },
  { factoryValueCode: 'RAL 640-4', hexCode: '#005C8C' },
  { factoryValueCode: 'RAL 640-5', hexCode: '#00548A' },
  { factoryValueCode: 'RAL 640-6', hexCode: '#004F7D' },
  { factoryValueCode: 'RAL 640-M', hexCode: '#004E87' },
  { factoryValueCode: 'RAL 650-1', hexCode: '#64B5D6' },
  { factoryValueCode: 'RAL 650-2', hexCode: '#0077A0' },
  { factoryValueCode: 'RAL 650-3', hexCode: '#006C97' },
  { factoryValueCode: 'RAL 650-4', hexCode: '#005577' },
  { factoryValueCode: 'RAL 650-5', hexCode: '#1D5B78' },
  { factoryValueCode: 'RAL 650-6', hexCode: '#0A4962' },
  { factoryValueCode: 'RAL 650-M', hexCode: '#00719D' },
  { factoryValueCode: 'RAL 660-1', hexCode: '#0094B0' },
  { factoryValueCode: 'RAL 660-2', hexCode: '#0B8DA8' },
  { factoryValueCode: 'RAL 660-3', hexCode: '#51A5B8' },
  { factoryValueCode: 'RAL 660-4', hexCode: '#3FB8CF' },
  { factoryValueCode: 'RAL 660-5', hexCode: '#6CC3D4' },
  { factoryValueCode: 'RAL 660-6', hexCode: '#8AC8D5' },
  { factoryValueCode: 'RAL 660-M', hexCode: '#5597A9' },
  { factoryValueCode: 'RAL 670-1', hexCode: '#8AD3EA' },
  { factoryValueCode: 'RAL 670-2', hexCode: '#97DAEF' },
  { factoryValueCode: 'RAL 670-3', hexCode: '#8FC5D6' },
  { factoryValueCode: 'RAL 670-4', hexCode: '#69BBD3' },
  { factoryValueCode: 'RAL 670-5', hexCode: '#5BB9D5' },
  { factoryValueCode: 'RAL 670-6', hexCode: '#4EC2E6' },
  { factoryValueCode: 'RAL 670-M', hexCode: '#74A7B8' },
  { factoryValueCode: 'RAL 680-1', hexCode: '#72AABA' },
  { factoryValueCode: 'RAL 680-2', hexCode: '#338FA4' },
  { factoryValueCode: 'RAL 680-3', hexCode: '#177185' },
  { factoryValueCode: 'RAL 680-4', hexCode: '#26768D' },
  { factoryValueCode: 'RAL 680-5', hexCode: '#006A85' },
  { factoryValueCode: 'RAL 680-6', hexCode: '#005B74' },
  { factoryValueCode: 'RAL 680-M', hexCode: '#0E455C' },
  { factoryValueCode: 'RAL 690-1', hexCode: '#3FBFCB' },
  { factoryValueCode: 'RAL 690-2', hexCode: '#00A2AD' },
  { factoryValueCode: 'RAL 690-3', hexCode: '#00838E' },
  { factoryValueCode: 'RAL 690-4', hexCode: '#006C7B' },
  { factoryValueCode: 'RAL 690-5', hexCode: '#00535F' },
  { factoryValueCode: 'RAL 690-6', hexCode: '#005160' },
  { factoryValueCode: 'RAL 690-M', hexCode: '#006773' },
  { factoryValueCode: 'RAL 710-1', hexCode: '#78D1CD' },
  { factoryValueCode: 'RAL 710-2', hexCode: '#00AAA7' },
  { factoryValueCode: 'RAL 710-3', hexCode: '#058A8B' },
  { factoryValueCode: 'RAL 710-4', hexCode: '#007476' },
  { factoryValueCode: 'RAL 710-5', hexCode: '#005C60' },
  { factoryValueCode: 'RAL 710-6', hexCode: '#0C4746' },
  { factoryValueCode: 'RAL 710-M', hexCode: '#00686B' },
  { factoryValueCode: 'RAL 720-1', hexCode: '#C2E3DE' },
  { factoryValueCode: 'RAL 720-2', hexCode: '#A4E2DB' },
  { factoryValueCode: 'RAL 720-3', hexCode: '#86D3D4' },
  { factoryValueCode: 'RAL 720-4', hexCode: '#58BEC1' },
  { factoryValueCode: 'RAL 720-5', hexCode: '#3393A0' },
  { factoryValueCode: 'RAL 720-6', hexCode: '#197C86' },
  { factoryValueCode: 'RAL 720-M', hexCode: '#1A949A' },
  { factoryValueCode: 'RAL 730-1', hexCode: '#CBE7E2' },
  { factoryValueCode: 'RAL 730-2', hexCode: '#98D3D3' },
  { factoryValueCode: 'RAL 730-3', hexCode: '#7DB8BA' },
  { factoryValueCode: 'RAL 730-4', hexCode: '#7BB9B4' },
  { factoryValueCode: 'RAL 730-5', hexCode: '#79ACAC' },
  { factoryValueCode: 'RAL 730-6', hexCode: '#46877F' },
  { factoryValueCode: 'RAL 730-M', hexCode: '#62A293' },
  { factoryValueCode: 'RAL 740-1', hexCode: '#C5DCCE' },
  { factoryValueCode: 'RAL 740-2', hexCode: '#B3D6C9' },
  { factoryValueCode: 'RAL 740-3', hexCode: '#95C3B2' },
  { factoryValueCode: 'RAL 740-4', hexCode: '#498574' },
  { factoryValueCode: 'RAL 740-5', hexCode: '#006F5B' },
  { factoryValueCode: 'RAL 740-6', hexCode: '#005D4E' },
  { factoryValueCode: 'RAL 740-M', hexCode: '#3A6F5F' },
  { factoryValueCode: 'RAL 750-1', hexCode: '#BFD7C9' },
  { factoryValueCode: 'RAL 750-2', hexCode: '#8FB4A0' },
  { factoryValueCode: 'RAL 750-3', hexCode: '#3D7461' },
  { factoryValueCode: 'RAL 750-4', hexCode: '#164234' },
  { factoryValueCode: 'RAL 750-5', hexCode: '#335449' },
  { factoryValueCode: 'RAL 750-6', hexCode: '#2E3C3B' },
  { factoryValueCode: 'RAL 750-M', hexCode: '#17372D' },
  { factoryValueCode: 'RAL 760-1', hexCode: '#D5E3CA' },
  { factoryValueCode: 'RAL 760-2', hexCode: '#B8CDAA' },
  { factoryValueCode: 'RAL 760-3', hexCode: '#B0BE9B' },
  { factoryValueCode: 'RAL 760-4', hexCode: '#8B9B7A' },
  { factoryValueCode: 'RAL 760-5', hexCode: '#6D7E5C' },
  { factoryValueCode: 'RAL 760-6', hexCode: '#4A6448' },
  { factoryValueCode: 'RAL 760-M', hexCode: '#334B2E' },
  { factoryValueCode: 'RAL 770-1', hexCode: '#989D84' },
  { factoryValueCode: 'RAL 770-2', hexCode: '#A9A88F' },
  { factoryValueCode: 'RAL 770-3', hexCode: '#7A755A' },
  { factoryValueCode: 'RAL 770-4', hexCode: '#817A66' },
  { factoryValueCode: 'RAL 770-5', hexCode: '#B4AF9F' },
  { factoryValueCode: 'RAL 770-6', hexCode: '#7E8273' },
  { factoryValueCode: 'RAL 770-M', hexCode: '#8D8864' },
  { factoryValueCode: 'RAL 780-1', hexCode: '#E9DECC' },
  { factoryValueCode: 'RAL 780-2', hexCode: '#E7D6B9' },
  { factoryValueCode: 'RAL 780-3', hexCode: '#DDC49A' },
  { factoryValueCode: 'RAL 780-4', hexCode: '#D1B186' },
  { factoryValueCode: 'RAL 780-5', hexCode: '#A38E79' },
  { factoryValueCode: 'RAL 780-6', hexCode: '#74695C' },
  { factoryValueCode: 'RAL 780-M', hexCode: '#B2A074' },
  { factoryValueCode: 'RAL 790-1', hexCode: '#3E4849' },
  { factoryValueCode: 'RAL 790-2', hexCode: '#3B4147' },
  { factoryValueCode: 'RAL 790-3', hexCode: '#313538' },
  { factoryValueCode: 'RAL 790-4', hexCode: '#302F32' },
  { factoryValueCode: 'RAL 790-5', hexCode: '#212224' },
  { factoryValueCode: 'RAL 790-6', hexCode: '#21232D' },
  { factoryValueCode: 'RAL 790-M', hexCode: '#221F1D' },
  { factoryValueCode: 'RAL 810-1', hexCode: '#979DA2' },
  { factoryValueCode: 'RAL 810-2', hexCode: '#8A9499' },
  { factoryValueCode: 'RAL 810-3', hexCode: '#79888E' },
  { factoryValueCode: 'RAL 810-4', hexCode: '#5E6B73' },
  { factoryValueCode: 'RAL 810-5', hexCode: '#51595D' },
  { factoryValueCode: 'RAL 810-6', hexCode: '#394146' },
  { factoryValueCode: 'RAL 810-M', hexCode: '#404649' },
  { factoryValueCode: 'RAL 820-1', hexCode: '#C5C8CA' },
  { factoryValueCode: 'RAL 820-2', hexCode: '#A9AEB2' },
  { factoryValueCode: 'RAL 820-3', hexCode: '#8D9395' },
  { factoryValueCode: 'RAL 820-4', hexCode: '#7D8589' },
  { factoryValueCode: 'RAL 820-5', hexCode: '#50555C' },
  { factoryValueCode: 'RAL 820-6', hexCode: '#444951' },
  { factoryValueCode: 'RAL 820-M', hexCode: '#929191' },
  { factoryValueCode: 'RAL 830-1', hexCode: '#BABCBA' },
  { factoryValueCode: 'RAL 830-2', hexCode: '#A4A7A5' },
  { factoryValueCode: 'RAL 830-3', hexCode: '#8D9291' },
  { factoryValueCode: 'RAL 830-4', hexCode: '#6C706D' },
  { factoryValueCode: 'RAL 830-5', hexCode: '#515554' },
  { factoryValueCode: 'RAL 830-6', hexCode: '#575E60' },
  { factoryValueCode: 'RAL 830-M', hexCode: '#82817F' },
  { factoryValueCode: 'RAL 840-1', hexCode: '#E7E3D8' },
  { factoryValueCode: 'RAL 840-2', hexCode: '#D7D5CC' },
  { factoryValueCode: 'RAL 840-3', hexCode: '#B8B4A8' },
  { factoryValueCode: 'RAL 840-4', hexCode: '#808077' },
  { factoryValueCode: 'RAL 840-5', hexCode: '#5A5D54' },
  { factoryValueCode: 'RAL 840-6', hexCode: '#474135' },
  { factoryValueCode: 'RAL 840-M', hexCode: '#494440' },
  { factoryValueCode: 'RAL 850-1', hexCode: '#C3C2B9' },
  { factoryValueCode: 'RAL 850-2', hexCode: '#B1B1AA' },
  { factoryValueCode: 'RAL 850-3', hexCode: '#A6A6A0' },
  { factoryValueCode: 'RAL 850-4', hexCode: '#918D85' },
  { factoryValueCode: 'RAL 850-5', hexCode: '#6B6760' },
  { factoryValueCode: 'RAL 850-6', hexCode: '#4C4B46' },
  { factoryValueCode: 'RAL 850-M', hexCode: '#625E59' },
  { factoryValueCode: 'RAL 860-1', hexCode: '#D8DADB' },
  { factoryValueCode: 'RAL 860-2', hexCode: '#CFD2D5' },
  { factoryValueCode: 'RAL 860-3', hexCode: '#C1C2C4' },
  { factoryValueCode: 'RAL 860-4', hexCode: '#9A9A9B' },
  { factoryValueCode: 'RAL 860-5', hexCode: '#7A7A79' },
  { factoryValueCode: 'RAL 860-6', hexCode: '#5B5F5F' },
  { factoryValueCode: 'RAL 860-M', hexCode: '#A4A09F' },
  { factoryValueCode: 'RAL 870-1', hexCode: '#D3D0D0' },
  { factoryValueCode: 'RAL 870-2', hexCode: '#969392' },
  { factoryValueCode: 'RAL 870-3', hexCode: '#636164' },
  { factoryValueCode: 'RAL 870-4', hexCode: '#514D4E' },
  { factoryValueCode: 'RAL 870-5', hexCode: '#4A4747' },
  { factoryValueCode: 'RAL 870-6', hexCode: '#3D3737' },
  { factoryValueCode: 'RAL 870-M', hexCode: '#4D4747' },
]

export const getHexCode = (factoryValueCode) => {
  if (!factoryValueCode) return

  const color = colors
    .filter((colorCodes) => factoryValueCode.split(' ').join('') === colorCodes.factoryValueCode.split(' ').join(''))
    .map((colorCodes) => colorCodes.hexCode)

  return color[0]
}
